import { Moment } from "moment";
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: Moment; }
  DateTime: { input: string; output: Moment; }
  _FieldSet: { input: any; output: any; }
};

export type AddUserActivityResponse = {
  __typename?: 'AddUserActivityResponse';
  activityId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AiRecommendationResult = {
  __typename?: 'AiRecommendationResult';
  aiScore?: Maybe<Scalars['Float']['output']>;
  cons?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  explanation?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  pros?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AllTimeReport = {
  __typename?: 'AllTimeReport';
  HID_ACA_ON_EXCHANGE_EXTERNAL?: Maybe<Scalars['Int']['output']>;
  HID_ACA_ON_EXCHANGE_VELAPOINT?: Maybe<Scalars['Int']['output']>;
  HID_ACA_ON_EXCHANGE_WHEN?: Maybe<Scalars['Int']['output']>;
  HID_COBRA?: Maybe<Scalars['Int']['output']>;
  HID_DECLINE_TO_DISCLOSE?: Maybe<Scalars['Int']['output']>;
  HID_MEDICAID_EXTERNAL?: Maybe<Scalars['Int']['output']>;
  HID_MEDICARE_EXTERNAL?: Maybe<Scalars['Int']['output']>;
  HID_MEDICARE_VELAPOINT?: Maybe<Scalars['Int']['output']>;
  HID_MEDICARE_WHEN?: Maybe<Scalars['Int']['output']>;
  HID_NEW_EMPLOYMENT?: Maybe<Scalars['Int']['output']>;
  HID_OFF_EXCHANGE_EXTERNAL?: Maybe<Scalars['Int']['output']>;
  HID_OFF_EXCHANGE_VELAPOINT?: Maybe<Scalars['Int']['output']>;
  HID_OFF_EXCHANGE_WHEN?: Maybe<Scalars['Int']['output']>;
  HID_OTHER_EXTERNAL_COVERAGE?: Maybe<Scalars['Int']['output']>;
  HID_PARENTS?: Maybe<Scalars['Int']['output']>;
  HID_PENDING?: Maybe<Scalars['Int']['output']>;
  HID_SHORT_TERM_EXTERNAL?: Maybe<Scalars['Int']['output']>;
  HID_SHORT_TERM_VELAPOINT?: Maybe<Scalars['Int']['output']>;
  HID_SHORT_TERM_WHEN?: Maybe<Scalars['Int']['output']>;
  HID_SPOUSE?: Maybe<Scalars['Int']['output']>;
  HID_UNINSURED?: Maybe<Scalars['Int']['output']>;
  HID_UNKNOWN_CASE_CLOSED?: Maybe<Scalars['Int']['output']>;
  activatedCases?: Maybe<Scalars['Int']['output']>;
  activeCases?: Maybe<Scalars['Int']['output']>;
  cancelledResolvedCases?: Maybe<Scalars['Int']['output']>;
  closedCases?: Maybe<Scalars['Int']['output']>;
  closedInactiveCases?: Maybe<Scalars['Int']['output']>;
  closedResolvedCases?: Maybe<Scalars['Int']['output']>;
  healthDecisionACA?: Maybe<Scalars['Int']['output']>;
  healthDecisionCobra?: Maybe<Scalars['Int']['output']>;
  healthDecisionOther?: Maybe<Scalars['Int']['output']>;
  healthDecisionUnknown?: Maybe<Scalars['Int']['output']>;
  lastUpdated?: Maybe<Scalars['String']['output']>;
  openCases?: Maybe<Scalars['Int']['output']>;
  totalCases?: Maybe<Scalars['Int']['output']>;
  wbForfeited?: Maybe<Scalars['Float']['output']>;
  wbRemaining?: Maybe<Scalars['Float']['output']>;
  wbSpent?: Maybe<Scalars['Float']['output']>;
  wbTotal?: Maybe<Scalars['Float']['output']>;
};

export type Application = {
  __typename?: 'Application';
  assignee?: Maybe<Scalars['String']['output']>;
  carrierName: Scalars['String']['output'];
  contact?: Maybe<ApplicationContact>;
  createdAt: Scalars['String']['output'];
  data?: Maybe<ApplicationData>;
  documents?: Maybe<Array<Maybe<ApplicationDocument>>>;
  effectiveDate: Scalars['String']['output'];
  enrollmentSite?: Maybe<Scalars['String']['output']>;
  externalApplicationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Array<Maybe<ApplicationNote>>>;
  plan?: Maybe<ApplicationPlan>;
  planId: Scalars['String']['output'];
  planName: Scalars['String']['output'];
  planType: Scalars['String']['output'];
  premiumAmount: Scalars['String']['output'];
  state: Scalars['String']['output'];
  status: Scalars['String']['output'];
  submittedBy?: Maybe<Scalars['String']['output']>;
  submittedOn?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type ApplicationCarrier = {
  __typename?: 'ApplicationCarrier';
  name?: Maybe<Scalars['String']['output']>;
};

export type ApplicationContact = {
  __typename?: 'ApplicationContact';
  address?: Maybe<ApplicationContactAddress>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<ApplicationName>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneType?: Maybe<Scalars['String']['output']>;
};

export type ApplicationContactAddress = {
  __typename?: 'ApplicationContactAddress';
  city?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type ApplicationData = {
  __typename?: 'ApplicationData';
  consent?: Maybe<Array<Maybe<ConsentRecord>>>;
  enrollmentStatus?: Maybe<ApplicationEnrollmentStatus>;
  household?: Maybe<ApplicationHousehold>;
  information?: Maybe<ApplicationInformation>;
  yourIncome?: Maybe<ApplicationIncome>;
};

export type ApplicationDataInput = {
  consent?: InputMaybe<Array<InputMaybe<ConsentRecordInput>>>;
  enrollmentStatus?: InputMaybe<ApplicationEnrollmentStatusInput>;
  household?: InputMaybe<ApplicationHouseholdInput>;
  information?: InputMaybe<ApplicationInformationInput>;
  yourIncome?: InputMaybe<ApplicationIncomeInput>;
};

export type ApplicationDocument = {
  __typename?: 'ApplicationDocument';
  documentType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  size: Scalars['String']['output'];
  storagePath: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ApplicationDocumentResult = {
  __typename?: 'ApplicationDocumentResult';
  document?: Maybe<ApplicationDocument>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ApplicationEnrollmentStatus = {
  __typename?: 'ApplicationEnrollmentStatus';
  currentlyEnrolled?: Maybe<Scalars['Boolean']['output']>;
  currentlyEnrolledMembers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  dayOfCoverageLose?: Maybe<Scalars['String']['output']>;
  endCurrentlyEnrolledPlan?: Maybe<Scalars['Boolean']['output']>;
  lastDateOfCurrentCoverage?: Maybe<Scalars['String']['output']>;
  lifeChanges?: Maybe<Scalars['String']['output']>;
  loseQualifyingCoverage?: Maybe<Scalars['Boolean']['output']>;
  loseQualifyingCoverageMembers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nameOfCurrentCoverage?: Maybe<Scalars['String']['output']>;
  nameOfPriorCoverage?: Maybe<Scalars['String']['output']>;
  offeredHRAMembers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  offeredICHRAMembers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  offeredICHRAOrQSEHRAMembers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  step?: Maybe<StepCompletion>;
};

export type ApplicationEnrollmentStatusInput = {
  currentlyEnrolled?: InputMaybe<Scalars['Boolean']['input']>;
  currentlyEnrolledMembers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dayOfCoverageLose?: InputMaybe<Scalars['String']['input']>;
  endCurrentlyEnrolledPlan?: InputMaybe<Scalars['Boolean']['input']>;
  lastDateOfCurrentCoverage?: InputMaybe<Scalars['String']['input']>;
  lifeChanges?: InputMaybe<Scalars['String']['input']>;
  loseQualifyingCoverage?: InputMaybe<Scalars['Boolean']['input']>;
  loseQualifyingCoverageMembers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nameOfCurrentCoverage?: InputMaybe<Scalars['String']['input']>;
  nameOfPriorCoverage?: InputMaybe<Scalars['String']['input']>;
  offeredHRAMembers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offeredICHRAMembers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offeredICHRAOrQSEHRAMembers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  step?: InputMaybe<StepCompletionInput>;
};

export type ApplicationHousehold = {
  __typename?: 'ApplicationHousehold';
  checkForPremiumTax?: Maybe<Scalars['Boolean']['output']>;
  claimDependents?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  claimingDependents?: Maybe<Scalars['Boolean']['output']>;
  jointSpouseTax?: Maybe<Scalars['Boolean']['output']>;
  liveWithUnder19IfNotMarried?: Maybe<Scalars['Boolean']['output']>;
  livesTogether?: Maybe<Scalars['Boolean']['output']>;
  married?: Maybe<Scalars['Boolean']['output']>;
  members?: Maybe<Array<Maybe<ApplicationHouseholdMember>>>;
  planFederalITR?: Maybe<Scalars['Boolean']['output']>;
  primaryCaretaker?: Maybe<Scalars['String']['output']>;
  provideTaxFilerInfo?: Maybe<Scalars['Boolean']['output']>;
  step?: Maybe<StepCompletion>;
  taxFilerName?: Maybe<Scalars['String']['output']>;
  taxFilerRelationship?: Maybe<Scalars['String']['output']>;
  willTaxDependentBySomeone?: Maybe<Scalars['Boolean']['output']>;
};

export type ApplicationHouseholdInput = {
  checkForPremiumTax?: InputMaybe<Scalars['Boolean']['input']>;
  claimDependents?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  claimingDependents?: InputMaybe<Scalars['Boolean']['input']>;
  jointSpouseTax?: InputMaybe<Scalars['Boolean']['input']>;
  liveWithUnder19IfNotMarried?: InputMaybe<Scalars['Boolean']['input']>;
  livesTogether?: InputMaybe<Scalars['Boolean']['input']>;
  married?: InputMaybe<Scalars['Boolean']['input']>;
  members?: InputMaybe<Array<InputMaybe<ApplicationHouseholdMemberInput>>>;
  planFederalITR?: InputMaybe<Scalars['Boolean']['input']>;
  primaryCaretaker?: InputMaybe<Scalars['String']['input']>;
  provideTaxFilerInfo?: InputMaybe<Scalars['Boolean']['input']>;
  step?: InputMaybe<StepCompletionInput>;
  taxFilerName?: InputMaybe<Scalars['String']['input']>;
  taxFilerRelationship?: InputMaybe<Scalars['String']['input']>;
  willTaxDependentBySomeone?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApplicationHouseholdMember = {
  __typename?: 'ApplicationHouseholdMember';
  assistanceAndLivingConditionsQuestion?: Maybe<Scalars['Boolean']['output']>;
  citizen?: Maybe<Scalars['Boolean']['output']>;
  disabilityOrMentalHealthCondition?: Maybe<Scalars['Boolean']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  expenses?: Maybe<Array<Maybe<ExpenseSource>>>;
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  incarcerated?: Maybe<Scalars['Boolean']['output']>;
  income?: Maybe<ApplicationMemberIncome>;
  incomeAndDeductions?: Maybe<LegacyIncomeAndDeductions>;
  incomes?: Maybe<Array<Maybe<IncomeSource>>>;
  legacyExpenses?: Maybe<ApplicationMemberExpenses>;
  medicaidChipCoverage?: Maybe<Scalars['Boolean']['output']>;
  medicaidChipEligibility?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  native?: Maybe<Scalars['Boolean']['output']>;
  notCovered?: Maybe<Scalars['Boolean']['output']>;
  pregnant?: Maybe<Scalars['Boolean']['output']>;
  relationship?: Maybe<Scalars['String']['output']>;
  ssn?: Maybe<Scalars['String']['output']>;
  tobacco?: Maybe<Scalars['Boolean']['output']>;
};

export type ApplicationHouseholdMemberInput = {
  assistanceAndLivingConditionsQuestion?: InputMaybe<Scalars['Boolean']['input']>;
  citizen?: InputMaybe<Scalars['Boolean']['input']>;
  disabilityOrMentalHealthCondition?: InputMaybe<Scalars['Boolean']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  expenses?: InputMaybe<Array<InputMaybe<ExpenseSourceInput>>>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  incarcerated?: InputMaybe<Scalars['Boolean']['input']>;
  income?: InputMaybe<ApplicationMemberIncomeInput>;
  incomeAndDeductions?: InputMaybe<LegacyIncomeAndDeductionsInput>;
  incomes?: InputMaybe<Array<InputMaybe<IncomeSourceInput>>>;
  legacyExpenses?: InputMaybe<ApplicationMemberExpensesInput>;
  medicaidChipCoverage?: InputMaybe<Scalars['Boolean']['input']>;
  medicaidChipEligibility?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  native?: InputMaybe<Scalars['Boolean']['input']>;
  notCovered?: InputMaybe<Scalars['Boolean']['input']>;
  pregnant?: InputMaybe<Scalars['Boolean']['input']>;
  relationship?: InputMaybe<Scalars['String']['input']>;
  tobacco?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApplicationHouseholdMemberResult = {
  __typename?: 'ApplicationHouseholdMemberResult';
  error?: Maybe<Scalars['String']['output']>;
  memberId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ApplicationIncome = {
  __typename?: 'ApplicationIncome';
  expense?: Maybe<ExpenseDetails>;
  expenses?: Maybe<Array<Maybe<ExpenseSource>>>;
  hasDeduction?: Maybe<Scalars['Boolean']['output']>;
  hasIncome?: Maybe<Scalars['Boolean']['output']>;
  income?: Maybe<IncomeDetails>;
  incomes?: Maybe<Array<Maybe<IncomeSource>>>;
  step?: Maybe<StepCompletion>;
};

export type ApplicationIncomeInput = {
  expense?: InputMaybe<ExpenseDetailsInput>;
  expenses?: InputMaybe<Array<InputMaybe<ExpenseSourceInput>>>;
  hasDeduction?: InputMaybe<Scalars['Boolean']['input']>;
  hasIncome?: InputMaybe<Scalars['Boolean']['input']>;
  income?: InputMaybe<IncomeDetailsInput>;
  incomes?: InputMaybe<Array<InputMaybe<IncomeSourceInput>>>;
  step?: InputMaybe<StepCompletionInput>;
};

export type ApplicationInformation = {
  __typename?: 'ApplicationInformation';
  contactInformation?: Maybe<ContactInformation>;
  primaryContact?: Maybe<PrimaryContactInformation>;
  yourInformation?: Maybe<PersonalInformation>;
};

export type ApplicationInformationInput = {
  contactInformation?: InputMaybe<ContactInformationInput>;
  primaryContact?: InputMaybe<PrimaryContactInformationInput>;
  yourInformation?: InputMaybe<PersonalInformationInput>;
};

export type ApplicationMemberExpenses = {
  __typename?: 'ApplicationMemberExpenses';
  details?: Maybe<ExpenseDetails>;
  hasExpenses?: Maybe<Scalars['Boolean']['output']>;
};

export type ApplicationMemberExpensesInput = {
  details?: InputMaybe<ExpenseDetailsInput>;
  hasExpenses?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApplicationMemberIncome = {
  __typename?: 'ApplicationMemberIncome';
  details?: Maybe<IncomeDetails>;
  hasIncome?: Maybe<Scalars['Boolean']['output']>;
};

export type ApplicationMemberIncomeInput = {
  details?: InputMaybe<IncomeDetailsInput>;
  hasIncome?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApplicationName = {
  __typename?: 'ApplicationName';
  first?: Maybe<Scalars['String']['output']>;
  last?: Maybe<Scalars['String']['output']>;
};

export type ApplicationNote = {
  __typename?: 'ApplicationNote';
  date: Scalars['String']['output'];
  id: Scalars['String']['output'];
  note: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type ApplicationNoteInput = {
  date: Scalars['String']['input'];
  id: Scalars['String']['input'];
  note: Scalars['String']['input'];
  userName: Scalars['String']['input'];
};

export type ApplicationPlan = {
  __typename?: 'ApplicationPlan';
  carrier?: Maybe<ApplicationCarrier>;
  effectiveDate?: Maybe<Scalars['String']['output']>;
  federalSubsidyAmount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  insuranceType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  rateSubsidized?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type ApplicationPlanDataInput = {
  carrierName: Scalars['String']['input'];
  effectiveDate: Scalars['String']['input'];
  enrollmentSite: Scalars['String']['input'];
  planName: Scalars['String']['input'];
  planType: Scalars['String']['input'];
  premiumAmount: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type ApplicationResponse = {
  __typename?: 'ApplicationResponse';
  applicationId?: Maybe<Scalars['ID']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum ApplicationStatus {
  Approved = 'approved',
  Cancelled = 'cancelled',
  Declined = 'declined',
  Draft = 'draft',
  Processed = 'processed',
  Submitted = 'submitted'
}

export type ApplicationStepData = {
  __typename?: 'ApplicationStepData';
  data?: Maybe<Scalars['String']['output']>;
  isCompleted?: Maybe<Scalars['Boolean']['output']>;
  stepName: Scalars['String']['output'];
};

export type ApplicationUpdateInput = {
  assignee?: InputMaybe<Scalars['String']['input']>;
  enrollmentSite?: InputMaybe<Scalars['String']['input']>;
  externalApplicationId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  submittedBy?: InputMaybe<Scalars['String']['input']>;
  submittedOn?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicationUpdateResult = {
  __typename?: 'ApplicationUpdateResult';
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type BankInfo = {
  __typename?: 'BankInfo';
  accountNumber?: Maybe<Scalars['String']['output']>;
  nameOnAccount?: Maybe<Scalars['String']['output']>;
  routingNumber?: Maybe<Scalars['String']['output']>;
};

export type BenefitPlan = {
  __typename?: 'BenefitPlan';
  carrier: Scalars['String']['output'];
  familyDeductible: Scalars['Float']['output'];
  familyOutOfPocketMaximum: Scalars['Float']['output'];
  fourTierPremium: FourTierPremium;
  id: Scalars['String']['output'];
  individualDeductible: Scalars['Float']['output'];
  individualOutOfPocketMaximum: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  planNetworkType: Scalars['String']['output'];
};

export enum BenefitTier {
  Family = 'family',
  Individual = 'individual',
  None = 'none'
}

export type BulkCaseCreateInput = {
  benefitAllocationType?: InputMaybe<DistributionType>;
  cobraEligibility?: InputMaybe<Scalars['String']['input']>;
  companyCode: Scalars['String']['input'];
  currentMonthlyBenefitCost?: InputMaybe<Scalars['Float']['input']>;
  dateOfBirth: Scalars['String']['input'];
  employeeID: Scalars['String']['input'];
  event: Scalars['String']['input'];
  eventDate: Scalars['String']['input'];
  externalCompanyIdentifier?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  homeAddressCity?: InputMaybe<Scalars['String']['input']>;
  homeAddressLine1?: InputMaybe<Scalars['String']['input']>;
  homeAddressLine2?: InputMaybe<Scalars['String']['input']>;
  homeAddressPostalCode: Scalars['String']['input'];
  homeAddressState: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  monthlyAllocationAmount?: InputMaybe<Scalars['Float']['input']>;
  monthlyCobraEstimate?: InputMaybe<Scalars['Float']['input']>;
  monthsToAllocate?: InputMaybe<Scalars['Float']['input']>;
  personalEmail?: InputMaybe<Scalars['String']['input']>;
  personalPhone?: InputMaybe<Scalars['String']['input']>;
  serviceLevel?: InputMaybe<Scalars['String']['input']>;
  shareDate?: InputMaybe<Scalars['String']['input']>;
  unusedFunds?: InputMaybe<UnusedFundsType>;
  whenBenefitAmount?: InputMaybe<Scalars['Float']['input']>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
};

export type BulkCaseCreateResult = {
  __typename?: 'BulkCaseCreateResult';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CsvUploadQueries = {
  __typename?: 'CSVUploadQueries';
  estimateImpact?: Maybe<EstimateImpactResult>;
};


export type CsvUploadQueriesEstimateImpactArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Carrier = {
  __typename?: 'Carrier';
  largeLogo: Scalars['String']['output'];
  logo: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CarrierAppointmentsCsvInput = {
  LOA: Scalars['String']['input'];
  LOAStatus: Scalars['String']['input'];
  NAICCode: Scalars['String']['input'];
  NPN: Scalars['Int']['input'];
  OrgName: Scalars['String']['input'];
  appointmentEffectiveDate?: InputMaybe<Scalars['String']['input']>;
  appointmentExpirationDate?: InputMaybe<Scalars['String']['input']>;
  appointmentStatus: Scalars['String']['input'];
  carrier: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  homeState: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  producerStatus: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type CarrierInput = {
  largeLogo?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type Case = {
  __typename?: 'Case';
  assignee?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use employee.benefitTier from zod caseObject */
  benefitTier?: Maybe<Scalars['String']['output']>;
  benefits?: Maybe<Array<Maybe<CaseBenefit>>>;
  caseId: Scalars['String']['output'];
  caseType?: Maybe<CaseTypes>;
  childCompany?: Maybe<CaseCompany>;
  /** @deprecated Use closedAt from zod caseObject */
  closeDate?: Maybe<Scalars['Date']['output']>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  cobraElectionReason?: Maybe<CobraElectionReasonType>;
  cobranding?: Maybe<CaseCobranding>;
  companyId: Scalars['String']['output'];
  contact?: Maybe<CaseContact>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  dataVersion: Scalars['String']['output'];
  /** @deprecated Use contact field */
  employee?: Maybe<Employee>;
  event?: Maybe<CaseEvent>;
  /** @deprecated Not in new zod caseObject */
  exitMeetingDate?: Maybe<Scalars['Date']['output']>;
  healthInsuranceDecision?: Maybe<HealthInsuranceDecisionType>;
  /** @deprecated Use healthInsuranceDecision */
  healthInsuranceDecisionDetail?: Maybe<HealthInsuranceDecisionDetailType>;
  household?: Maybe<Array<Maybe<CaseHouseholdMember>>>;
  id: Scalars['String']['output'];
  klaviyo?: Maybe<CaseKlaviyo>;
  klaviyoCaseShared?: Maybe<Scalars['Boolean']['output']>;
  lastDay?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Not in new zod caseObject */
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use event.termination.reason from zod caseObject */
  reason?: Maybe<Scalars['String']['output']>;
  ref?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use whenBenefit.releasedDate from zod caseObject */
  released?: Maybe<Scalars['DateTime']['output']>;
  scheduled?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Never used */
  secure?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Not in new zod caseObject */
  services?: Maybe<Array<Maybe<CaseService>>>;
  servicesEnabled?: Maybe<Array<ServiceType>>;
  shareDate?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Use shareDate or sharedOn from zod caseObject */
  shared?: Maybe<Scalars['Date']['output']>;
  sharedOn?: Maybe<Scalars['Date']['output']>;
  sharedStatus?: Maybe<SharedStatus>;
  status: CaseStatus;
  syncStatus?: Maybe<Scalars['Boolean']['output']>;
  syncUser?: Maybe<SyncUser>;
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
  tasks?: Maybe<CaseTasks>;
  terminationDate?: Maybe<Scalars['Date']['output']>;
  terminationType?: Maybe<TerminationTypes>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  whenBenefit?: Maybe<CaseWhenBenefit>;
  zendesk?: Maybe<CaseZendesk>;
  zendeskTicket?: Maybe<Scalars['Boolean']['output']>;
  zendeskUserId?: Maybe<Scalars['String']['output']>;
};

export type CaseAccess = {
  __typename?: 'CaseAccess';
  caseId?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  expiration?: Maybe<Scalars['String']['output']>;
};

export type CaseBenefit = {
  __typename?: 'CaseBenefit';
  benefitEndDate?: Maybe<Scalars['Date']['output']>;
  carrier?: Maybe<Scalars['String']['output']>;
  dependents?: Maybe<Array<Maybe<CaseDependent>>>;
  monthlyEmployeeContribution?: Maybe<Scalars['Float']['output']>;
  monthlyEmployerContribution?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CaseBenefitInput = {
  benefitEndDate?: InputMaybe<Scalars['Date']['input']>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  dependents?: InputMaybe<Array<InputMaybe<CaseDependentInput>>>;
  monthlyEmployeeContribution?: InputMaybe<Scalars['Float']['input']>;
  monthlyEmployerContribution?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CaseCobra = {
  __typename?: 'CaseCobra';
  administratorPhone?: Maybe<Scalars['String']['output']>;
  administratorWebsite?: Maybe<Scalars['String']['output']>;
  currentContribution?: Maybe<Scalars['Float']['output']>;
  estimate?: Maybe<Scalars['Float']['output']>;
  qualifyingEvent?: Maybe<Scalars['String']['output']>;
};

export type CaseCobraInput = {
  administratorPhone?: InputMaybe<Scalars['String']['input']>;
  administratorWebsite?: InputMaybe<Scalars['String']['input']>;
  currentContribution?: InputMaybe<Scalars['Float']['input']>;
  estimate?: InputMaybe<Scalars['Float']['input']>;
  qualifyingEvent?: InputMaybe<Scalars['String']['input']>;
};

export type CaseCobranding = {
  __typename?: 'CaseCobranding';
  companyCode?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CaseCobrandingInput = {
  companyCode?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CaseCompany = {
  __typename?: 'CaseCompany';
  address?: Maybe<ExtendedAddress>;
  contact?: Maybe<CaseCompanyContact>;
  id?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CaseCompanyContact = {
  __typename?: 'CaseCompanyContact';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type CaseCompanyContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CaseCompanyInput = {
  address?: InputMaybe<ExtendedAddressInput>;
  contact?: InputMaybe<CaseCompanyContactInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CaseContact = {
  __typename?: 'CaseContact';
  address?: Maybe<ExtendedAddress>;
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  ethnicity?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  flsaStatus?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hireDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  payCurrency?: Maybe<Scalars['String']['output']>;
  payFrequency?: Maybe<Scalars['String']['output']>;
  payRate?: Maybe<Scalars['Float']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  salary?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  terminationDate?: Maybe<Scalars['Date']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CaseContactAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street1?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type CaseContactInput = {
  address?: InputMaybe<CaseContactAddressInput>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  ethnicity?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  flsaStatus?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hireDate?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  payCurrency?: InputMaybe<Scalars['String']['input']>;
  payFrequency?: InputMaybe<Scalars['String']['input']>;
  payRate?: InputMaybe<Scalars['Float']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  salary?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  terminationDate?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CaseContactUpdateInput = {
  address?: InputMaybe<CaseContactAddressInput>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  ethnicity?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  flsaStatus?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hireDate?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  payCurrency?: InputMaybe<Scalars['String']['input']>;
  payFrequency?: InputMaybe<Scalars['String']['input']>;
  payRate?: InputMaybe<Scalars['Float']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  salary?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  terminationDate?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CaseDependent = {
  __typename?: 'CaseDependent';
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  relationship?: Maybe<Scalars['String']['output']>;
};

export type CaseDependentInput = {
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  relationship?: InputMaybe<Scalars['String']['input']>;
};

export type CaseEmployeeInput = {
  benefitTier?: InputMaybe<Scalars['String']['input']>;
  cobra?: InputMaybe<CaseCobraInput>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  ethnicity?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  flsaStatus?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hireDate?: InputMaybe<Scalars['Date']['input']>;
  home?: InputMaybe<ExtendedAddressInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastDay?: InputMaybe<Scalars['Date']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  payCurrency?: InputMaybe<Scalars['String']['input']>;
  payFrequency?: InputMaybe<Scalars['String']['input']>;
  payRate?: InputMaybe<Scalars['Float']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  salary?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  terminationDate?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CaseEvent = {
  __typename?: 'CaseEvent';
  cobra?: Maybe<CaseCobra>;
  date?: Maybe<Scalars['Date']['output']>;
  termination?: Maybe<CaseTermination>;
  type?: Maybe<CaseEventTypes>;
};

export type CaseEventInput = {
  cobra?: InputMaybe<CaseCobraInput>;
  date: Scalars['Date']['input'];
  termination?: InputMaybe<CaseTerminationInput>;
  type: CaseEventTypes;
};

export enum CaseEventTypes {
  CobraOe = 'COBRA_OE',
  DependentLossOfCoverage = 'DEPENDENT_LOSS_OF_COVERAGE',
  EarlyRetirement = 'EARLY_RETIREMENT',
  FamilySeparation = 'FAMILY_SEPARATION',
  FriendsAndFamily = 'FRIENDS_AND_FAMILY',
  Hire = 'HIRE',
  HoursReduction = 'HOURS_REDUCTION',
  InvoluntaryTermination = 'INVOLUNTARY_TERMINATION',
  LossOfCoverage = 'LOSS_OF_COVERAGE',
  MedicareEligible = 'MEDICARE_ELIGIBLE',
  Onboarding = 'ONBOARDING',
  OpenEnrollment = 'OPEN_ENROLLMENT',
  Retirement = 'RETIREMENT',
  StudentLossOfCoverage = 'STUDENT_LOSS_OF_COVERAGE',
  VoluntaryTermination = 'VOLUNTARY_TERMINATION'
}

export type CaseHouseholdMember = {
  __typename?: 'CaseHouseholdMember';
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  relationship?: Maybe<Scalars['String']['output']>;
};

export type CaseImpactResult = {
  __typename?: 'CaseImpactResult';
  caseExistsNoUpdates: Scalars['Int']['output'];
  casesToBeCreated: Scalars['Int']['output'];
  casesToBeUpdated: Scalars['Int']['output'];
  employeesExists: Scalars['Int']['output'];
  employeesToBeCreated: Scalars['Int']['output'];
};

export type CaseInput = {
  assignee?: InputMaybe<Scalars['String']['input']>;
  benefits?: InputMaybe<Array<InputMaybe<CaseBenefitInput>>>;
  caseId?: InputMaybe<Scalars['String']['input']>;
  caseType: CaseTypes;
  childCompany?: InputMaybe<CaseCompanyInput>;
  closedAt?: InputMaybe<Scalars['DateTime']['input']>;
  cobraElectionReason?: InputMaybe<CobraElectionReasonType>;
  cobranding?: InputMaybe<CaseCobrandingInput>;
  companyId: Scalars['String']['input'];
  contact: CaseContactInput;
  dataVersion?: InputMaybe<Scalars['String']['input']>;
  event: CaseEventInput;
  healthInsuranceDecision?: InputMaybe<HealthInsuranceDecisionType>;
  healthInsuranceDecisionDetail?: InputMaybe<HealthInsuranceDecisionDetailType>;
  id?: InputMaybe<Scalars['String']['input']>;
  klaviyo?: InputMaybe<CaseKlaviyoInput>;
  klaviyoCaseShared?: InputMaybe<Scalars['Boolean']['input']>;
  lastDay?: InputMaybe<Scalars['Date']['input']>;
  ref?: InputMaybe<Scalars['String']['input']>;
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  servicesEnabled?: InputMaybe<Array<ServiceType>>;
  shareDate?: InputMaybe<Scalars['Date']['input']>;
  sharedOn?: InputMaybe<Scalars['DateTime']['input']>;
  sharedStatus?: InputMaybe<SharedStatus>;
  status?: InputMaybe<CaseStatus>;
  syncStatus?: InputMaybe<Scalars['Boolean']['input']>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  tasks?: InputMaybe<CaseTasksInput>;
  terminationDate?: InputMaybe<Scalars['Date']['input']>;
  terminationType?: InputMaybe<TerminationTypes>;
  whenBenefit?: InputMaybe<CaseWhenBenefitInput>;
  zendesk?: InputMaybe<CaseZendeskInput>;
  zendeskTicket?: InputMaybe<Scalars['Boolean']['input']>;
  zendeskUserId?: InputMaybe<Scalars['String']['input']>;
};

export type CaseKlaviyo = {
  __typename?: 'CaseKlaviyo';
  caseShared?: Maybe<CaseKlaviyoCaseShared>;
};

export type CaseKlaviyoCaseShared = {
  __typename?: 'CaseKlaviyoCaseShared';
  date?: Maybe<Scalars['DateTime']['output']>;
};

export type CaseKlaviyoCaseSharedInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CaseKlaviyoInput = {
  caseShared?: InputMaybe<CaseKlaviyoCaseSharedInput>;
};

export type CaseService = {
  __typename?: 'CaseService';
  type?: Maybe<Scalars['String']['output']>;
  whenBenefitAmount?: Maybe<Scalars['Float']['output']>;
};

export type CaseServiceInput = {
  type?: InputMaybe<Scalars['String']['input']>;
  whenBenefitAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type CaseStateByCreatedAt = {
  __typename?: 'CaseStateByCreatedAt';
  activatedCases?: Maybe<Scalars['Int']['output']>;
  activeCases?: Maybe<Scalars['Int']['output']>;
  cancelledResolvedCases?: Maybe<Scalars['Int']['output']>;
  casesSharedOnTime?: Maybe<Scalars['Int']['output']>;
  closedCases?: Maybe<Scalars['Int']['output']>;
  closedInactiveCases?: Maybe<Scalars['Int']['output']>;
  closedResolvedCases?: Maybe<Scalars['Int']['output']>;
  companyIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt: Scalars['String']['output'];
  healthDecisionACA?: Maybe<Scalars['Int']['output']>;
  healthDecisionCobra?: Maybe<Scalars['Int']['output']>;
  healthDecisionOther?: Maybe<Scalars['Int']['output']>;
  healthDecisionUnknown?: Maybe<Scalars['Int']['output']>;
  klaviyoCasesShared?: Maybe<Scalars['Int']['output']>;
  openCases?: Maybe<Scalars['Int']['output']>;
  totalCases?: Maybe<Scalars['Int']['output']>;
  totalCompanies?: Maybe<Scalars['Int']['output']>;
  wbForfeited?: Maybe<Scalars['Float']['output']>;
  wbRemaining?: Maybe<Scalars['Float']['output']>;
  wbSpent?: Maybe<Scalars['Float']['output']>;
  wbTotal?: Maybe<Scalars['Float']['output']>;
  zendeskCasesShared?: Maybe<Scalars['Int']['output']>;
};

export type CaseStateByCreatedAtData = {
  __typename?: 'CaseStateByCreatedAtData';
  data?: Maybe<Array<Maybe<CaseStateByCreatedAt>>>;
  lastUpdated?: Maybe<Scalars['String']['output']>;
};

export enum CaseStatus {
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  ClosedInactive = 'CLOSED_INACTIVE',
  ClosedResolved = 'CLOSED_RESOLVED',
  Open = 'OPEN'
}

export type CaseTasks = {
  __typename?: 'CaseTasks';
  closed?: Maybe<Scalars['Int']['output']>;
  open?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type CaseTasksInput = {
  closed?: InputMaybe<Scalars['Int']['input']>;
  open?: InputMaybe<Scalars['Int']['input']>;
  total?: InputMaybe<Scalars['Int']['input']>;
};

export type CaseTermination = {
  __typename?: 'CaseTermination';
  reason?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TerminationTypes>;
};

export type CaseTerminationInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TerminationTypes>;
};

export enum CaseTypes {
  ActiveEmployee = 'ACTIVE_EMPLOYEE',
  CobraRenewal = 'COBRA_RENEWAL',
  Ichra = 'ICHRA',
  OtherCobraEvent = 'OTHER_COBRA_EVENT',
  Student = 'STUDENT',
  TerminationInvoluntary = 'TERMINATION_INVOLUNTARY',
  TerminationVoluntary = 'TERMINATION_VOLUNTARY'
}

export type CaseUpdateInput = {
  assignee?: InputMaybe<Scalars['String']['input']>;
  benefits?: InputMaybe<Array<InputMaybe<CaseBenefitInput>>>;
  caseType?: InputMaybe<CaseTypes>;
  childCompany?: InputMaybe<CaseCompanyInput>;
  closedAt?: InputMaybe<Scalars['DateTime']['input']>;
  cobraElectionReason?: InputMaybe<CobraElectionReasonType>;
  cobranding?: InputMaybe<CaseCobrandingInput>;
  contact?: InputMaybe<CaseContactUpdateInput>;
  dataVersion?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<CaseEventInput>;
  healthInsuranceDecision?: InputMaybe<HealthInsuranceDecisionType>;
  healthInsuranceDecisionDetail?: InputMaybe<HealthInsuranceDecisionDetailType>;
  klaviyo?: InputMaybe<CaseKlaviyoInput>;
  klaviyoCaseShared?: InputMaybe<Scalars['Boolean']['input']>;
  lastDay?: InputMaybe<Scalars['Date']['input']>;
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  servicesEnabled?: InputMaybe<Array<ServiceType>>;
  shareDate?: InputMaybe<Scalars['Date']['input']>;
  sharedOn?: InputMaybe<Scalars['Date']['input']>;
  sharedStatus?: InputMaybe<SharedStatus>;
  status?: InputMaybe<CaseStatus>;
  syncStatus?: InputMaybe<Scalars['Boolean']['input']>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  tasks?: InputMaybe<CaseTasksInput>;
  terminationDate?: InputMaybe<Scalars['Date']['input']>;
  terminationType?: InputMaybe<TerminationTypes>;
  whenBenefit?: InputMaybe<CaseWhenBenefitInput>;
  zendesk?: InputMaybe<CaseZendeskInput>;
  zendeskTicket?: InputMaybe<Scalars['Boolean']['input']>;
  zendeskUserId?: InputMaybe<Scalars['String']['input']>;
};

export type CaseWhenBenefit = {
  __typename?: 'CaseWhenBenefit';
  amount?: Maybe<Scalars['Float']['output']>;
  benefitTier?: Maybe<Scalars['String']['output']>;
  detail?: Maybe<CaseWhenBenefitDetail>;
  distributionType?: Maybe<DistributionType>;
  hasBenefit?: Maybe<Scalars['Boolean']['output']>;
  monthlyBenefitInitialGracePeriod?: Maybe<MonthlyBenefitTiming>;
  /** Only used when distributionType is MONTHLY_ALLOCATION */
  months?: Maybe<Array<CaseWhenBenefitMonth>>;
  /** Only used when distributionType is MONTHLY_ALLOCATION */
  monthsToAllocate?: Maybe<Scalars['Float']['output']>;
  perMonthDeadline?: Maybe<MonthlyBenefitTiming>;
  /** All reimbursement requests by month */
  reimbursementRequests?: Maybe<Array<ReimbursementRequest>>;
  releasedDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<WhenBenefitSubstatusType>;
  /** total amount allocated for when benefit */
  total?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  /** determines if funds will expire or roll over */
  unusedFunds?: Maybe<UnusedFundsType>;
  useOnCobra?: Maybe<Scalars['Boolean']['output']>;
};

export type CaseWhenBenefitDetail = {
  __typename?: 'CaseWhenBenefitDetail';
  amountForfeited?: Maybe<Scalars['Float']['output']>;
  amountPending?: Maybe<Scalars['Float']['output']>;
  amountRemaining?: Maybe<Scalars['Float']['output']>;
  amountSpent?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type CaseWhenBenefitDetailInput = {
  amountForfeited?: InputMaybe<Scalars['Float']['input']>;
  amountPending?: InputMaybe<Scalars['Float']['input']>;
  amountRemaining?: InputMaybe<Scalars['Float']['input']>;
  amountSpent?: InputMaybe<Scalars['Float']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
};

export type CaseWhenBenefitInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  benefitTier?: InputMaybe<Scalars['String']['input']>;
  detail?: InputMaybe<CaseWhenBenefitDetailInput>;
  distributionType?: InputMaybe<DistributionType>;
  hasBenefit?: InputMaybe<Scalars['Boolean']['input']>;
  monthlyBenefitInitialGracePeriod?: InputMaybe<MonthlyBenefitTimingInput>;
  /** Only used when distributionType is MONTHLY_ALLOCATION */
  months?: InputMaybe<Array<CaseWhenBenefitMonthInput>>;
  /** Only used when distributionType is MONTHLY_ALLOCATION */
  monthsToAllocate?: InputMaybe<Scalars['Float']['input']>;
  perMonthDeadline?: InputMaybe<MonthlyBenefitTimingInput>;
  /** All reimbursement requests by month */
  reimbursementRequests?: InputMaybe<Array<ReimbursementRequestInput>>;
  releasedDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<WhenBenefitSubstatusType>;
  /** total amount allocated for when benefit */
  total?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  /** determines if funds will expire or roll over */
  unusedFunds?: InputMaybe<UnusedFundsType>;
  useOnCobra?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CaseWhenBenefitMonth = {
  __typename?: 'CaseWhenBenefitMonth';
  amount?: Maybe<Scalars['Float']['output']>;
  deadline?: Maybe<Scalars['Date']['output']>;
  expired?: Maybe<Scalars['Float']['output']>;
  month: Scalars['String']['output'];
  reimbursedAmount?: Maybe<Scalars['Float']['output']>;
  requested?: Maybe<Scalars['Float']['output']>;
  returned?: Maybe<Scalars['Float']['output']>;
};

export type CaseWhenBenefitMonthInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  deadline?: InputMaybe<Scalars['Date']['input']>;
  expired?: InputMaybe<Scalars['Float']['input']>;
  month: Scalars['String']['input'];
  reimbursedAmount?: InputMaybe<Scalars['Float']['input']>;
  requested?: InputMaybe<Scalars['Float']['input']>;
  returned?: InputMaybe<Scalars['Float']['input']>;
};

export type CaseZendesk = {
  __typename?: 'CaseZendesk';
  date?: Maybe<Scalars['DateTime']['output']>;
  ticketId?: Maybe<Scalars['Int']['output']>;
};

export type CaseZendeskInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  ticketId?: InputMaybe<Scalars['Int']['input']>;
};

export type CasesFiltersInput = {
  caseId?: InputMaybe<StringQueryOperatorInput>;
  companyId?: InputMaybe<StringQueryOperatorInput>;
  contactId?: InputMaybe<StringQueryOperatorInput>;
  syncUserId?: InputMaybe<StringQueryOperatorInput>;
};

export type CobraAdministrator = {
  __typename?: 'CobraAdministrator';
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export enum CobraElectionReasonType {
  AccumulatorReset = 'ACCUMULATOR_RESET',
  CobraMoreAffordable = 'COBRA_MORE_AFFORDABLE',
  ContinuityOfCare = 'CONTINUITY_OF_CARE',
  NeededBackdatedCoverage = 'NEEDED_BACKDATED_COVERAGE',
  NoReasonProvided = 'NO_REASON_PROVIDED',
  Other = 'OTHER',
  PrescriptionDrugCoverage = 'PRESCRIPTION_DRUG_COVERAGE',
  ProviderAccess = 'PROVIDER_ACCESS'
}

export enum CobraQualifyingEvent {
  Chip = 'CHIP',
  Death = 'DEATH',
  Divorce = 'DIVORCE',
  FamilySeparation = 'FAMILY_SEPARATION',
  HoursReduction = 'HOURS_REDUCTION',
  LeaveOfAbsence = 'LEAVE_OF_ABSENCE',
  LossOfCoverage = 'LOSS_OF_COVERAGE',
  Medicaid = 'MEDICAID',
  Medicare = 'MEDICARE',
  MedicareEligible = 'MEDICARE_ELIGIBLE',
  Other = 'OTHER',
  Termination = 'TERMINATION'
}

export type Company = {
  __typename?: 'Company';
  activationDate?: Maybe<Scalars['String']['output']>;
  address?: Maybe<ExtendedAddress>;
  automation?: Maybe<CompanyAutomation>;
  branding?: Maybe<CompanyBranding>;
  cobraAdministrationProvider?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  companyPointOfContact?: Maybe<CompanyContact>;
  createdOn: Scalars['DateTime']['output'];
  customerSuccessManager?: Maybe<Scalars['String']['output']>;
  emailDomain?: Maybe<Array<Scalars['String']['output']>>;
  employeeCount?: Maybe<Scalars['Int']['output']>;
  externalCompanyIdentifier?: Maybe<Scalars['String']['output']>;
  fein?: Maybe<Scalars['String']['output']>;
  headquarterState?: Maybe<Scalars['String']['output']>;
  healthInsurancePlanRenewalMonth?: Maybe<Scalars['String']['output']>;
  hrisSetup?: Maybe<Scalars['Boolean']['output']>;
  landingPages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  logo?: Maybe<Scalars['String']['output']>;
  monthlyWhenBenefitSettings?: Maybe<CompanyMonthlyWhenBenefitSettings>;
  name: Scalars['String']['output'];
  planRenewalMonth?: Maybe<Scalars['String']['output']>;
  servicesEnabled?: Maybe<Array<ServiceType>>;
  terminationDate?: Maybe<Scalars['String']['output']>;
  timing?: Maybe<CompanyTiming>;
  verificationStep?: Maybe<Scalars['Boolean']['output']>;
  whenBenefitUseOnCobra?: Maybe<Scalars['String']['output']>;
  zendeskOrganizationId?: Maybe<Scalars['Float']['output']>;
};

export type CompanyAutomation = {
  __typename?: 'CompanyAutomation';
  employerPlatformLessWorkflowEnable: Scalars['Boolean']['output'];
  errorNotificationContactEmail: Scalars['String']['output'];
  numberOfDays: Scalars['Int']['output'];
};

export type CompanyAutomationInput = {
  employerPlatformLessWorkflowEnable: Scalars['Boolean']['input'];
  errorNotificationContactEmail: Scalars['String']['input'];
  numberOfDays: Scalars['Int']['input'];
};

export type CompanyBranding = {
  __typename?: 'CompanyBranding';
  bannerImage?: Maybe<CompanyBrandingImage>;
  bannerTintColor?: Maybe<Scalars['String']['output']>;
  bannerTintTransparency?: Maybe<Scalars['String']['output']>;
  customerLogoColor?: Maybe<CompanyBrandingImage>;
  customerLogoWhite?: Maybe<CompanyBrandingImage>;
  header?: Maybe<Scalars['String']['output']>;
  heroParagraph1?: Maybe<Scalars['String']['output']>;
  heroParagraph2?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  primaryIconColor?: Maybe<Scalars['String']['output']>;
};

export type CompanyBrandingImage = {
  __typename?: 'CompanyBrandingImage';
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CompanyBrandingImageInput = {
  name: Scalars['String']['input'];
  path: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type CompanyBrandingInput = {
  bannerImage: CompanyBrandingImageInput;
  bannerTintColor: Scalars['String']['input'];
  bannerTintTransparency: Scalars['String']['input'];
  customerLogoColor: CompanyBrandingImageInput;
  customerLogoWhite?: InputMaybe<CompanyBrandingImageInput>;
};

export type CompanyContact = {
  __typename?: 'CompanyContact';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CompanyContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyHrContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyInput = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CompanyMonthlyWhenBenefitSettings = {
  __typename?: 'CompanyMonthlyWhenBenefitSettings';
  monthlyBenefitInitialGracePeriod?: Maybe<MonthlyBenefitTiming>;
  perMonthDeadline?: Maybe<MonthlyBenefitTiming>;
  unusedFunds?: Maybe<UnusedFundsType>;
};

export type CompanyMonthlyWhenBenefitSettingsInput = {
  monthlyBenefitInitialGracePeriod?: InputMaybe<MonthlyBenefitTimingInput>;
  perMonthDeadline?: InputMaybe<MonthlyBenefitTimingInput>;
  unusedFunds?: InputMaybe<UnusedFundsType>;
};

export type CompanyMutationResponse = {
  __typename?: 'CompanyMutationResponse';
  company?: Maybe<Company>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CompanyTiming = {
  __typename?: 'CompanyTiming';
  betweenRequests?: Maybe<TimingValue>;
  firstRequest?: Maybe<TimingValue>;
};

export type CompanyTimingInput = {
  betweenRequests?: InputMaybe<TimingValueInput>;
  firstRequest?: InputMaybe<TimingValueInput>;
};

export type ConnectionError = {
  __typename?: 'ConnectionError';
  activityId?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  connectionId?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ConnectionErrorObject = {
  __typename?: 'ConnectionErrorObject';
  errors?: Maybe<Array<Maybe<ConnectionError>>>;
  total: Scalars['Int']['output'];
};

export type ConsentRecord = {
  __typename?: 'ConsentRecord';
  consentText?: Maybe<Scalars['String']['output']>;
  consentedOn?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ConsentRecordInput = {
  consentText?: InputMaybe<Scalars['String']['input']>;
  consentedOn?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Contact = {
  __typename?: 'Contact';
  benefit?: Maybe<Scalars['Int']['output']>;
  employeeId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type ContactInformation = {
  __typename?: 'ContactInformation';
  email?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  notificationMethod?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneType?: Maybe<Scalars['String']['output']>;
  spokenLanguage?: Maybe<Scalars['String']['output']>;
  writtenLanguage?: Maybe<Scalars['String']['output']>;
};

export type ContactInformationInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  extension?: InputMaybe<Scalars['String']['input']>;
  notificationMethod?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneType?: InputMaybe<Scalars['String']['input']>;
  spokenLanguage?: InputMaybe<Scalars['String']['input']>;
  writtenLanguage?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationDataResult = {
  __typename?: 'ConversationDataResult';
  conversationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ConversationEnrollmentDataInput = {
  capturedAt?: InputMaybe<Scalars['String']['input']>;
  checkPremiumTaxCredits?: InputMaybe<Scalars['Boolean']['input']>;
  county?: InputMaybe<CountyInput>;
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
  household?: InputMaybe<ConversationHouseholdInput>;
  householdIncome?: InputMaybe<Scalars['Float']['input']>;
  isNativeAmerican?: InputMaybe<Scalars['Boolean']['input']>;
  selectedBenefitPlan?: InputMaybe<Scalars['String']['input']>;
  submittedAt?: InputMaybe<Scalars['String']['input']>;
  taxFilingStatus?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationFeedbackInput = {
  additionalFeedback?: InputMaybe<Scalars['String']['input']>;
  canContact?: InputMaybe<Scalars['Boolean']['input']>;
  conversationId?: InputMaybe<Scalars['String']['input']>;
  feedbackType: Scalars['String']['input'];
  messageId: Scalars['String']['input'];
  sentiment?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationHouseholdInput = {
  members?: InputMaybe<Array<ConversationHouseholdMemberInput>>;
};

export type ConversationHouseholdMemberInput = {
  dob?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pregnant?: InputMaybe<Scalars['Boolean']['input']>;
  relationship?: InputMaybe<Scalars['String']['input']>;
  tobacco?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversationPlanTypePreferencesInput = {
  hmo?: InputMaybe<Scalars['Float']['input']>;
  ppo?: InputMaybe<Scalars['Float']['input']>;
  shortterm?: InputMaybe<Scalars['Float']['input']>;
};

export type ConversationPreferencesDataInput = {
  comprehensiveCoverage?: InputMaybe<Scalars['Float']['input']>;
  dental?: InputMaybe<Scalars['Float']['input']>;
  lowDeductible?: InputMaybe<Scalars['Float']['input']>;
  lowPremium?: InputMaybe<Scalars['Float']['input']>;
  mentalHealth?: InputMaybe<Scalars['Float']['input']>;
  networkSize?: InputMaybe<Scalars['Float']['input']>;
  planType?: InputMaybe<ConversationPlanTypePreferencesInput>;
  vision?: InputMaybe<Scalars['Float']['input']>;
};

export type Counties = {
  __typename?: 'Counties';
  fips?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type CountyInput = {
  fips?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type CsvInput = {
  benefitTier: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  currentMonthlyBenefitsCost: Scalars['Float']['input'];
  employeeId: Scalars['String']['input'];
  lastDayOfWork?: InputMaybe<Scalars['String']['input']>;
  monthlyCobraEstimate: Scalars['Float']['input'];
  personalEmail: Scalars['String']['input'];
  personalPhone?: InputMaybe<Scalars['String']['input']>;
  shareDate: Scalars['String']['input'];
  startingChecklist?: InputMaybe<Scalars['String']['input']>;
  terminationDate: Scalars['String']['input'];
  terminationType: Scalars['String']['input'];
  whenBenefitAmount: Scalars['Float']['input'];
};

export type DeviceDataInput = {
  browser?: InputMaybe<Scalars['String']['input']>;
  browserVersion?: InputMaybe<Scalars['String']['input']>;
  deviceModel?: InputMaybe<Scalars['String']['input']>;
  deviceType?: InputMaybe<Scalars['String']['input']>;
  deviceVendor?: InputMaybe<Scalars['String']['input']>;
  ip?: InputMaybe<Scalars['String']['input']>;
  os?: InputMaybe<Scalars['String']['input']>;
  osVersion?: InputMaybe<Scalars['String']['input']>;
};

export type DirectDeposit = {
  __typename?: 'DirectDeposit';
  accountHolderName?: Maybe<Scalars['String']['output']>;
  accountType?: Maybe<Scalars['String']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
};

export type DirectDepositInput = {
  accountHolderName?: InputMaybe<Scalars['String']['input']>;
  accountNumber: Scalars['String']['input'];
  accountType?: InputMaybe<Scalars['String']['input']>;
  routingNumber: Scalars['String']['input'];
};

export enum DistributionType {
  LumpSum = 'LUMP_SUM',
  MonthlyAllocation = 'MONTHLY_ALLOCATION'
}

export type DrugCoverage = {
  __typename?: 'DrugCoverage';
  drugPackageId: Scalars['String']['output'];
  planId: Scalars['String']['output'];
  priorAuthorization: Scalars['Boolean']['output'];
  quantityLimit: Scalars['Boolean']['output'];
  stepTherapy: Scalars['Boolean']['output'];
  tier: Scalars['String']['output'];
};

export type DrugPackage = {
  __typename?: 'DrugPackage';
  activeIngredientStrength?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  nonProprietaryName?: Maybe<Scalars['String']['output']>;
  proprietaryName?: Maybe<Scalars['String']['output']>;
};

export type Employee = {
  __typename?: 'Employee';
  benefitTier?: Maybe<Scalars['String']['output']>;
  cobra?: Maybe<CaseCobra>;
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  ethnicity?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  flsaStatus?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hireDate?: Maybe<Scalars['Date']['output']>;
  home?: Maybe<ExtendedAddress>;
  id?: Maybe<Scalars['String']['output']>;
  lastDay?: Maybe<Scalars['Date']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  payCurrency?: Maybe<Scalars['String']['output']>;
  payFrequency?: Maybe<Scalars['String']['output']>;
  payRate?: Maybe<Scalars['Float']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  salary?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  terminationDate?: Maybe<Scalars['Date']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type EmployeeInput = {
  BirthDate: Scalars['String']['input'];
  City: Scalars['String']['input'];
  Compensation?: InputMaybe<Scalars['String']['input']>;
  CompensationType?: InputMaybe<Scalars['String']['input']>;
  DateOfHire: Scalars['String']['input'];
  Department?: InputMaybe<Scalars['String']['input']>;
  EmployeeStatus: Scalars['String']['input'];
  EmployeeTimeType?: InputMaybe<Scalars['String']['input']>;
  FLSAStatus?: InputMaybe<Scalars['String']['input']>;
  FirstName: Scalars['String']['input'];
  Gender?: InputMaybe<Scalars['String']['input']>;
  HomeAddressLine1: Scalars['String']['input'];
  HomeAddressLine2?: InputMaybe<Scalars['String']['input']>;
  LastName: Scalars['String']['input'];
  PayFrequency?: InputMaybe<Scalars['String']['input']>;
  PersonalEmailAddress: Scalars['String']['input'];
  PersonalPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  PostalCode: Scalars['String']['input'];
  State: Scalars['String']['input'];
  TerminationDate: Scalars['String']['input'];
  Title?: InputMaybe<Scalars['String']['input']>;
  WorkLocation?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

export type EnrollmentUrl = {
  __typename?: 'EnrollmentUrl';
  redirectUrl?: Maybe<Scalars['String']['output']>;
};

export type EstimateImpactResult = {
  __typename?: 'EstimateImpactResult';
  existing: Scalars['Int']['output'];
  missing: Scalars['Int']['output'];
  new: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum Ethnicity {
  AmericanIndianOrAlaskaNative = 'AMERICAN_INDIAN_OR_ALASKA_NATIVE',
  AsianOrIndianSubcontinent = 'ASIAN_OR_INDIAN_SUBCONTINENT',
  BlackOrAfricanAmerican = 'BLACK_OR_AFRICAN_AMERICAN',
  HispanicOrLatino = 'HISPANIC_OR_LATINO',
  NativeHawaiianOrOtherPacificIslander = 'NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER',
  Other = 'OTHER',
  PreferNotToDisclose = 'PREFER_NOT_TO_DISCLOSE',
  TwoOrMoreRaces = 'TWO_OR_MORE_RACES',
  White = 'WHITE'
}

export type ExitCodeInfo = {
  __typename?: 'ExitCodeInfo';
  documents?: Maybe<Scalars['Int']['output']>;
  firstName: Scalars['String']['output'];
  hasBeenSynced?: Maybe<Scalars['Boolean']['output']>;
  servicesEnabled?: Maybe<Array<ServiceType>>;
  whenBenefit?: Maybe<Scalars['Float']['output']>;
};

export type ExpenseDetails = {
  __typename?: 'ExpenseDetails';
  amount?: Maybe<Scalars['Float']['output']>;
  expenseType?: Maybe<Scalars['String']['output']>;
  howOften?: Maybe<Scalars['String']['output']>;
};

export type ExpenseDetailsInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  expenseType?: InputMaybe<Scalars['String']['input']>;
  howOften?: InputMaybe<Scalars['String']['input']>;
};

export type ExpenseSource = {
  __typename?: 'ExpenseSource';
  amount?: Maybe<Scalars['Float']['output']>;
  expenseType?: Maybe<Scalars['String']['output']>;
  howOften?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export type ExpenseSourceInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  expenseType?: InputMaybe<Scalars['String']['input']>;
  howOften?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

export type ExtendedAddress = {
  __typename?: 'ExtendedAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type ExtendedAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street1?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type FinchMutations = {
  __typename?: 'FinchMutations';
  connectFinch?: Maybe<Scalars['Boolean']['output']>;
};


export type FinchMutationsConnectFinchArgs = {
  clientCode: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
};

export type FourTierPremium = {
  __typename?: 'FourTierPremium';
  employeeOnly: PremiumTier;
  employeePlusChildren: PremiumTier;
  employeePlusSpouse: PremiumTier;
  family: PremiumTier;
};

export type GptResponse = {
  __typename?: 'GPTResponse';
  raw?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Scalars['String']['output']>;
};

export enum Gender {
  Female = 'female',
  Male = 'male'
}

export enum HipaaViewReasons {
  BenefitAdmin = 'benefitAdmin',
  CustomerFollowUp = 'customerFollowUp',
  CustomerSupport = 'customerSupport',
  EnrollmentSupport = 'enrollmentSupport',
  Legal = 'legal',
  ProductManagement = 'productManagement',
  ReimbursementProcessing = 'reimbursementProcessing',
  Security = 'security',
  TestingDebugging = 'testing_debugging'
}

export type HrisMutations = {
  __typename?: 'HRISMutations';
  csvUpload?: Maybe<CsvUploadMutations>;
  finch: FinchMutations;
  merge: MergeMutations;
};

export type HrisQueries = {
  __typename?: 'HRISQueries';
  csvUpload: CsvUploadQueries;
  merge: MergeQueries;
};

export type HealthBenefit = {
  __typename?: 'HealthBenefit';
  covered?: Maybe<Scalars['Boolean']['output']>;
  inNetwork?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  outOfNetwork?: Maybe<Scalars['String']['output']>;
};

export enum HealthInsuranceDecisionDetailType {
  AcaOnExchangeExternal = 'ACA_ON_EXCHANGE_EXTERNAL',
  AcaOnExchangeWhen = 'ACA_ON_EXCHANGE_WHEN',
  Cobra = 'COBRA',
  DeclineToDisclose = 'DECLINE_TO_DISCLOSE',
  MedicaidExternal = 'MEDICAID_EXTERNAL',
  MedicaidWhen = 'MEDICAID_WHEN',
  MedicareExternal = 'MEDICARE_EXTERNAL',
  MedicareWhen = 'MEDICARE_WHEN',
  NewEmployment = 'NEW_EMPLOYMENT',
  OffExchangeExternal = 'OFF_EXCHANGE_EXTERNAL',
  OffExchangeWhen = 'OFF_EXCHANGE_WHEN',
  Parents = 'PARENTS',
  Pending = 'PENDING',
  ShortTermExternal = 'SHORT_TERM_EXTERNAL',
  ShortTermWhen = 'SHORT_TERM_WHEN',
  Spouse = 'SPOUSE',
  Uninsured = 'UNINSURED',
  UnknownCaseClosed = 'UNKNOWN_CASE_CLOSED'
}

export enum HealthInsuranceDecisionType {
  AcaOnExchangeExternal = 'ACA_ON_EXCHANGE_EXTERNAL',
  AcaOnExchangeVelapoint = 'ACA_ON_EXCHANGE_VELAPOINT',
  AcaOnExchangeWhen = 'ACA_ON_EXCHANGE_WHEN',
  Cobra = 'COBRA',
  DeclineToDisclose = 'DECLINE_TO_DISCLOSE',
  MedicaidExternal = 'MEDICAID_EXTERNAL',
  MedicareExternal = 'MEDICARE_EXTERNAL',
  MedicareVelapoint = 'MEDICARE_VELAPOINT',
  MedicareWhen = 'MEDICARE_WHEN',
  NewEmployment = 'NEW_EMPLOYMENT',
  OffExchangeExternal = 'OFF_EXCHANGE_EXTERNAL',
  OffExchangeVelapoint = 'OFF_EXCHANGE_VELAPOINT',
  OffExchangeWhen = 'OFF_EXCHANGE_WHEN',
  OtherExternalCoverage = 'OTHER_EXTERNAL_COVERAGE',
  Parents = 'PARENTS',
  Pending = 'PENDING',
  ShortTermExternal = 'SHORT_TERM_EXTERNAL',
  ShortTermVelapoint = 'SHORT_TERM_VELAPOINT',
  ShortTermWhen = 'SHORT_TERM_WHEN',
  Spouse = 'SPOUSE',
  Uninsured = 'UNINSURED',
  UnknownCaseClosed = 'UNKNOWN_CASE_CLOSED'
}

export type Household = {
  __typename?: 'Household';
  members?: Maybe<Array<Maybe<HouseholdMember>>>;
};

export type HouseholdMember = {
  __typename?: 'HouseholdMember';
  dob?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  name?: Maybe<Scalars['String']['output']>;
  pregnant?: Maybe<Scalars['Boolean']['output']>;
  relationship?: Maybe<Relationship>;
  tobacco?: Maybe<Scalars['Boolean']['output']>;
};

export type HouseholdMemberInput = {
  dob?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  name?: InputMaybe<Scalars['String']['input']>;
  pregnant?: InputMaybe<Scalars['Boolean']['input']>;
  relationship?: InputMaybe<Relationship>;
  tobacco?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HrisConnectionDetails = {
  __typename?: 'HrisConnectionDetails';
  createdOn?: Maybe<Scalars['String']['output']>;
  lastImport?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  squareLogo?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type IncomeDetails = {
  __typename?: 'IncomeDetails';
  amount?: Maybe<Scalars['Float']['output']>;
  employerName?: Maybe<Scalars['String']['output']>;
  howOften?: Maybe<Scalars['String']['output']>;
  incomeType?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type IncomeDetailsInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  employerName?: InputMaybe<Scalars['String']['input']>;
  howOften?: InputMaybe<Scalars['String']['input']>;
  incomeType?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type IncomeSource = {
  __typename?: 'IncomeSource';
  amount?: Maybe<Scalars['Float']['output']>;
  employerName?: Maybe<Scalars['String']['output']>;
  howOften?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  incomeType?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type IncomeSourceInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  employerName?: InputMaybe<Scalars['String']['input']>;
  howOften?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  incomeType?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type InsuranceDetails = {
  __typename?: 'InsuranceDetails';
  county?: Maybe<Counties>;
  effectiveDate?: Maybe<Scalars['String']['output']>;
  household?: Maybe<Household>;
  income?: Maybe<Scalars['Float']['output']>;
  isNativeAmarican?: Maybe<Scalars['Boolean']['output']>;
  knowsBenefitPlan?: Maybe<Scalars['Boolean']['output']>;
  providers?: Maybe<Array<Maybe<Provider>>>;
  selectedBenefitPlan?: Maybe<Scalars['String']['output']>;
  taxFilingStatus?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type InsuranceDetailsInput = {
  county?: InputMaybe<CountyInput>;
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
  income?: InputMaybe<Scalars['Float']['input']>;
  isNativeAmarican?: InputMaybe<Scalars['Boolean']['input']>;
  knowsBenefitPlan?: InputMaybe<Scalars['Boolean']['input']>;
  providers?: InputMaybe<Array<InputMaybe<ProviderInput>>>;
  selectedBenefitPlan?: InputMaybe<Scalars['String']['input']>;
  taxFilingStatus?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type Language = {
  __typename?: 'Language';
  id: Scalars['String']['output'];
  iso639_2?: Maybe<Scalars['String']['output']>;
  iso639_3?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type LegacyIncomeAndDeductions = {
  __typename?: 'LegacyIncomeAndDeductions';
  deductionAmount?: Maybe<Scalars['String']['output']>;
  deductionFrequency?: Maybe<Scalars['String']['output']>;
  employerName?: Maybe<Scalars['String']['output']>;
  expenseType?: Maybe<Scalars['String']['output']>;
  hasDeduction?: Maybe<Scalars['Boolean']['output']>;
  hasIncome?: Maybe<Scalars['Boolean']['output']>;
  incomeAmount?: Maybe<Scalars['String']['output']>;
  incomeFrequency?: Maybe<Scalars['String']['output']>;
  incomeType?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type LegacyIncomeAndDeductionsInput = {
  deductionAmount?: InputMaybe<Scalars['String']['input']>;
  deductionFrequency?: InputMaybe<Scalars['String']['input']>;
  employerName?: InputMaybe<Scalars['String']['input']>;
  expenseType?: InputMaybe<Scalars['String']['input']>;
  hasDeduction?: InputMaybe<Scalars['Boolean']['input']>;
  hasIncome?: InputMaybe<Scalars['Boolean']['input']>;
  incomeAmount?: InputMaybe<Scalars['String']['input']>;
  incomeFrequency?: InputMaybe<Scalars['String']['input']>;
  incomeType?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type LinkTokenResponse = {
  __typename?: 'LinkTokenResponse';
  token: Scalars['String']['output'];
};

export type Mfa = {
  __typename?: 'MFA';
  backupCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  lastUpdated?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type MfaInput = {
  backupCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdated?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum MaritalStatus {
  Divorced = 'DIVORCED',
  HeadOfHousehold = 'HEAD_OF_HOUSEHOLD',
  Married = 'MARRIED',
  MarriedFilingJointly = 'MARRIED_FILING_JOINTLY',
  MarriedFilingSeparately = 'MARRIED_FILING_SEPARATELY',
  Single = 'SINGLE',
  Widowed = 'WIDOWED'
}

export type MarketplaceService = {
  __typename?: 'MarketplaceService';
  CTAButton?: Maybe<Scalars['Boolean']['output']>;
  CTAButtonText?: Maybe<Scalars['String']['output']>;
  CTAButtonURL?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fontColor?: Maybe<Scalars['String']['output']>;
  headerPhoto?: Maybe<ServicePhoto>;
  id?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  logoFile?: Maybe<ServicePhoto>;
  phoneButton?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  redeemCode?: Maybe<Scalars['String']['output']>;
  serviceCategory?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  serviceName?: Maybe<Scalars['String']['output']>;
  serviceProvider?: Maybe<Scalars['String']['output']>;
  tileBodyText?: Maybe<Scalars['String']['output']>;
  tileHeader?: Maybe<Scalars['String']['output']>;
  tilesVisibility?: Maybe<Scalars['String']['output']>;
};

export type MedicalPlan = {
  __typename?: 'MedicalPlan';
  baseRateUnit: Scalars['String']['output'];
  benefitLevel: Scalars['String']['output'];
  benefits: Array<QuotitHealthBenefit>;
  benefitsLink: Scalars['String']['output'];
  carrier: Carrier;
  carrierId: Scalars['String']['output'];
  contractStatus: Scalars['String']['output'];
  deductible: Scalars['String']['output'];
  disclaimer: Scalars['String']['output'];
  drugCoverages: Array<DrugCoverage>;
  effectiveDate: Scalars['String']['output'];
  exclusionsLink: Scalars['String']['output'];
  id: Scalars['String']['output'];
  insuranceType: Scalars['String']['output'];
  moop: Scalars['String']['output'];
  name: Scalars['String']['output'];
  offMarket?: Maybe<Scalars['Boolean']['output']>;
  onMarket?: Maybe<Scalars['Boolean']['output']>;
  planType: Scalars['String']['output'];
  premium?: Maybe<Scalars['Float']['output']>;
  premiumSubsidized?: Maybe<Scalars['Float']['output']>;
  providerLink: Scalars['String']['output'];
  providers: Array<PlanProvider>;
  rate: Scalars['Float']['output'];
  rateSubsidized?: Maybe<Scalars['Float']['output']>;
  rating: Rating;
  ratingMethod: Scalars['String']['output'];
  recommendation: Recommendation;
  source: Scalars['String']['output'];
  state: Scalars['String']['output'];
  summaryOfBenefitsLink: Scalars['String']['output'];
  visibility: Scalars['String']['output'];
};

export type MergeMutations = {
  __typename?: 'MergeMutations';
  setPublicToken?: Maybe<Scalars['Boolean']['output']>;
};


export type MergeMutationsSetPublicTokenArgs = {
  companyId: Scalars['String']['input'];
  publicToken: Scalars['String']['input'];
};

export type MergeQueries = {
  __typename?: 'MergeQueries';
  getLinkToken?: Maybe<LinkTokenResponse>;
};


export type MergeQueriesGetLinkTokenArgs = {
  companyId: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  emailAddress: Scalars['String']['input'];
  integrationMethodId?: InputMaybe<Scalars['String']['input']>;
};

export type Message = {
  __typename?: 'Message';
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  user: Scalars['Boolean']['output'];
};

export type MigrationResult = {
  __typename?: 'MigrationResult';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  stats?: Maybe<MigrationStats>;
  success: Scalars['Boolean']['output'];
};

export type MigrationStats = {
  __typename?: 'MigrationStats';
  casesMigrated: Scalars['Int']['output'];
  errorCount: Scalars['Int']['output'];
  reimbursementsMigrated: Scalars['Int']['output'];
  usersProcessed: Scalars['Int']['output'];
  whenBenefitsMigrated: Scalars['Int']['output'];
};

export type MixpanelData = {
  __typename?: 'MixpanelData';
  data?: Maybe<MixpanelEventData>;
};

export type MixpanelDateValue = {
  __typename?: 'MixpanelDateValue';
  date: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type MixpanelEvent = {
  __typename?: 'MixpanelEvent';
  event: Scalars['String']['output'];
  values: Array<MixpanelDateValue>;
};

export type MixpanelEventData = {
  __typename?: 'MixpanelEventData';
  events: Array<MixpanelEvent>;
};

export type MonthlyBenefitTiming = {
  __typename?: 'MonthlyBenefitTiming';
  dayOfMonth?: Maybe<Scalars['Int']['output']>;
  monthsAfter?: Maybe<Scalars['Int']['output']>;
};

export type MonthlyBenefitTimingInput = {
  dayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  monthsAfter?: InputMaybe<Scalars['Int']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addApplicationHouseholdMember?: Maybe<ApplicationHouseholdMemberResult>;
  addApplicationNote?: Maybe<Scalars['Boolean']['output']>;
  addCase?: Maybe<Case>;
  addUserActivity?: Maybe<AddUserActivityResponse>;
  addUserPrescription: Scalars['Boolean']['output'];
  addUserProvider: Scalars['Boolean']['output'];
  additionalInfoRequest?: Maybe<Scalars['Boolean']['output']>;
  adminCreateApplication: ApplicationResponse;
  adminCreateUserFromCase?: Maybe<User>;
  approveReimbursementRequest?: Maybe<Scalars['Boolean']['output']>;
  automatedSyncManagement?: Maybe<Scalars['Boolean']['output']>;
  beginJamieChat: Scalars['Boolean']['output'];
  bulkCaseCreate?: Maybe<BulkCaseCreateResult>;
  cancelCase?: Maybe<Case>;
  cancelMessage?: Maybe<Scalars['Boolean']['output']>;
  cancelReimbursementRequest?: Maybe<Scalars['Boolean']['output']>;
  clearMessages?: Maybe<Scalars['Boolean']['output']>;
  closeCase?: Maybe<Case>;
  completeApplicationStep?: Maybe<ApplicationUpdateResult>;
  configureDemoCase?: Maybe<Case>;
  connectSimpleHris?: Maybe<Scalars['Boolean']['output']>;
  connectUserToCompany?: Maybe<Scalars['Boolean']['output']>;
  contactUs?: Maybe<Scalars['Boolean']['output']>;
  createApplication: ApplicationResponse;
  /** @deprecated Use addCase mutation instead */
  createCase?: Maybe<Scalars['String']['output']>;
  createCompany?: Maybe<CompanyMutationResponse>;
  deleteUserDirectDeposit?: Maybe<Scalars['Boolean']['output']>;
  denyReimbursementRequest?: Maybe<Scalars['Boolean']['output']>;
  hris: HrisMutations;
  loadOpportunity?: Maybe<Scalars['Boolean']['output']>;
  migrateWhenBenefitsAndReimbursements?: Maybe<MigrationResult>;
  queueHrisSync?: Maybe<Scalars['Boolean']['output']>;
  reimburseReimbursementRequest?: Maybe<Scalars['Boolean']['output']>;
  releaseCaseBenefit?: Maybe<Scalars['Boolean']['output']>;
  removeApplicationField?: Maybe<ApplicationUpdateResult>;
  removeApplicationHouseholdMember?: Maybe<ApplicationUpdateResult>;
  removeUserPrescription: Scalars['Boolean']['output'];
  removeUserProvider: Scalars['Boolean']['output'];
  resendCaseToMailchimp?: Maybe<Scalars['Boolean']['output']>;
  resendConnectEmail?: Maybe<Scalars['Boolean']['output']>;
  retryActivitySync?: Maybe<Scalars['Boolean']['output']>;
  saveApplicationSSN?: Maybe<Scalars['Boolean']['output']>;
  saveConversationEnrollmentData: ConversationDataResult;
  saveConversationFeedback: ConversationDataResult;
  saveConversationPreferencesData: ConversationDataResult;
  sendMessage: Scalars['Boolean']['output'];
  sendProcessedApplicationEmail: SendProcessedApplicationEmailResponse;
  setBenefitPlanKnowledge?: Maybe<Scalars['Boolean']['output']>;
  setDirectDeposit?: Maybe<User>;
  setHousehold?: Maybe<Scalars['Boolean']['output']>;
  setInsuranceDetails?: Maybe<Scalars['Boolean']['output']>;
  setPreferences?: Maybe<Scalars['Boolean']['output']>;
  setSelectedBenefitPlan?: Maybe<Scalars['Boolean']['output']>;
  setSelectedPlanDetails?: Maybe<Scalars['Boolean']['output']>;
  setUserClaims?: Maybe<User>;
  setUserDirectDeposit?: Maybe<Scalars['Boolean']['output']>;
  setupCompany?: Maybe<Scalars['Boolean']['output']>;
  shareCase?: Maybe<Case>;
  submitApplication?: Maybe<Scalars['Boolean']['output']>;
  submitReimbursementRequest?: Maybe<Scalars['Boolean']['output']>;
  syncDataForExitCode?: Maybe<Scalars['Boolean']['output']>;
  syncEmployeeFromHRIS?: Maybe<Scalars['Boolean']['output']>;
  triggerPipeline?: Maybe<Scalars['Boolean']['output']>;
  updateApplicationAlgoliaRecord?: Maybe<UpdateApplicationAlgoliaRecordResult>;
  updateApplicationConsent?: Maybe<ApplicationUpdateResult>;
  updateApplicationField?: Maybe<ApplicationUpdateResult>;
  updateApplicationHouseholdMember?: Maybe<ApplicationUpdateResult>;
  updateApplicationStatus?: Maybe<ApplicationUpdateResult>;
  updateApplicationStep?: Maybe<ApplicationUpdateResult>;
  updateCase?: Maybe<Case>;
  updateCaseHealthInsuranceDecision?: Maybe<Case>;
  updateCompany?: Maybe<CompanyMutationResponse>;
  updateUser?: Maybe<User>;
  uploadApplicationDocument?: Maybe<ApplicationDocumentResult>;
  uploadCarrierAppointments?: Maybe<UploadCarrierAppointmentsResponse>;
  userSignOut?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationAddApplicationHouseholdMemberArgs = {
  applicationId: Scalars['String']['input'];
  member: ApplicationHouseholdMemberInput;
  userId: Scalars['String']['input'];
};


export type MutationAddApplicationNoteArgs = {
  applicationId: Scalars['ID']['input'];
  applicationUserId: Scalars['String']['input'];
  note: ApplicationNoteInput;
};


export type MutationAddCaseArgs = {
  caseInput: CaseInput;
  companyId: Scalars['String']['input'];
};


export type MutationAddUserActivityArgs = {
  input: UserActivityInput;
};


export type MutationAddUserPrescriptionArgs = {
  prescription: PrescriptionInput;
  uid: Scalars['String']['input'];
};


export type MutationAddUserProviderArgs = {
  provider: ProviderInput;
  uid: Scalars['String']['input'];
};


export type MutationAdditionalInfoRequestArgs = {
  msg?: InputMaybe<Scalars['String']['input']>;
  requestBenefitId: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
  requestUserId: Scalars['String']['input'];
  status: Scalars['String']['input'];
};


export type MutationAdminCreateApplicationArgs = {
  applicantUserId: Scalars['String']['input'];
  applicationPlanData: ApplicationPlanDataInput;
};


export type MutationAdminCreateUserFromCaseArgs = {
  caseId: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  dateOfBirth: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};


export type MutationApproveReimbursementRequestArgs = {
  approvedAmount: Scalars['String']['input'];
  companyId?: InputMaybe<Scalars['String']['input']>;
  notes: Scalars['String']['input'];
  requestBenefitId: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
  requestUserId: Scalars['String']['input'];
  status: Scalars['String']['input'];
};


export type MutationBeginJamieChatArgs = {
  userId: Scalars['String']['input'];
};


export type MutationBulkCaseCreateArgs = {
  bulkCaseData?: InputMaybe<Array<InputMaybe<BulkCaseCreateInput>>>;
};


export type MutationCancelCaseArgs = {
  caseId: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
};


export type MutationCancelReimbursementRequestArgs = {
  id: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  whenBenefitId: Scalars['String']['input'];
};


export type MutationCloseCaseArgs = {
  caseId: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
};


export type MutationCompleteApplicationStepArgs = {
  applicationId: Scalars['String']['input'];
  step: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationConfigureDemoCaseArgs = {
  caseType: CaseTypes;
  whenBenefit?: InputMaybe<CaseWhenBenefitInput>;
};


export type MutationConnectSimpleHrisArgs = {
  companyId: Scalars['String']['input'];
  connectionDetails: Scalars['String']['input'];
  connectionMethod: Scalars['String']['input'];
};


export type MutationConnectUserToCompanyArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  inviteId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationContactUsArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateApplicationArgs = {
  planId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationCreateCaseArgs = {
  benefitTier: BenefitTier;
  checklistId: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  employeeId: Scalars['String']['input'];
  lastDay?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
  secure: Scalars['Boolean']['input'];
  terminationDate: Scalars['String']['input'];
  terminationType: Scalars['String']['input'];
};


export type MutationCreateCompanyArgs = {
  companyInput: CompanyInput;
};


export type MutationDeleteUserDirectDepositArgs = {
  userId: Scalars['String']['input'];
};


export type MutationDenyReimbursementRequestArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  denialReason: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  requestBenefitId: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
  requestUserId: Scalars['String']['input'];
};


export type MutationLoadOpportunityArgs = {
  opportunityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMigrateWhenBenefitsAndReimbursementsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationQueueHrisSyncArgs = {
  companyId: Scalars['String']['input'];
  importAll?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationReimburseReimbursementRequestArgs = {
  caseId: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['String']['input'];
};


export type MutationReleaseCaseBenefitArgs = {
  caseId: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
};


export type MutationRemoveApplicationFieldArgs = {
  applicationId: Scalars['String']['input'];
  field: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationRemoveApplicationHouseholdMemberArgs = {
  applicationId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationRemoveUserPrescriptionArgs = {
  prescriptionId: Scalars['String']['input'];
  uid: Scalars['String']['input'];
};


export type MutationRemoveUserProviderArgs = {
  npi: Scalars['Int']['input'];
  uid: Scalars['String']['input'];
};


export type MutationResendCaseToMailchimpArgs = {
  caseId: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
};


export type MutationResendConnectEmailArgs = {
  companyId: Scalars['String']['input'];
  inviteId: Scalars['String']['input'];
};


export type MutationRetryActivitySyncArgs = {
  activityId: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
};


export type MutationSaveApplicationSsnArgs = {
  applicationId: Scalars['ID']['input'];
  householdMemberId: Scalars['String']['input'];
  ssn: Scalars['String']['input'];
  uid: Scalars['String']['input'];
};


export type MutationSaveConversationEnrollmentDataArgs = {
  enrollmentData: ConversationEnrollmentDataInput;
  oldEnrollmentData?: InputMaybe<ConversationEnrollmentDataInput>;
  uid: Scalars['String']['input'];
};


export type MutationSaveConversationFeedbackArgs = {
  feedbackData: ConversationFeedbackInput;
  uid: Scalars['String']['input'];
};


export type MutationSaveConversationPreferencesDataArgs = {
  oldPreferencesData?: InputMaybe<ConversationPreferencesDataInput>;
  preferencesData: ConversationPreferencesDataInput;
  uid: Scalars['String']['input'];
};


export type MutationSendMessageArgs = {
  message: Scalars['String']['input'];
};


export type MutationSendProcessedApplicationEmailArgs = {
  applicantUserId: Scalars['String']['input'];
};


export type MutationSetBenefitPlanKnowledgeArgs = {
  knowsBenefitPlan?: InputMaybe<Scalars['Boolean']['input']>;
  selectedBenefitPlan?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetDirectDepositArgs = {
  directDeposit: DirectDepositInput;
  uid: Scalars['String']['input'];
};


export type MutationSetHouseholdArgs = {
  members?: InputMaybe<Array<InputMaybe<HouseholdMemberInput>>>;
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetInsuranceDetailsArgs = {
  details?: InputMaybe<InsuranceDetailsInput>;
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetPreferencesArgs = {
  preferences?: InputMaybe<PreferencesInput>;
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetSelectedBenefitPlanArgs = {
  selectedBenefitPlan?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetSelectedPlanDetailsArgs = {
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
  planDetails?: InputMaybe<SelectedPlanDetailsInput>;
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetUserClaimsArgs = {
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetUserDirectDepositArgs = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  nameOnAccount?: InputMaybe<Scalars['String']['input']>;
  routingNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetupCompanyArgs = {
  companyName: Scalars['String']['input'];
  country: Scalars['String']['input'];
  emailAddress: Scalars['String']['input'];
  employeeCount: Scalars['Int']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


export type MutationShareCaseArgs = {
  caseId: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  shareDate: Scalars['Date']['input'];
};


export type MutationSubmitApplicationArgs = {
  applicationId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSubmitReimbursementRequestArgs = {
  amount: Scalars['Float']['input'];
  caseId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  coverageEndDate?: InputMaybe<Scalars['String']['input']>;
  coverageStartDate?: InputMaybe<Scalars['String']['input']>;
  files: Array<ReimbursementFileInput>;
  months?: InputMaybe<Array<Scalars['String']['input']>>;
  userId: Scalars['String']['input'];
  whenBenefitId: Scalars['String']['input'];
};


export type MutationSyncDataForExitCodeArgs = {
  birthDate: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  exitCode?: InputMaybe<Scalars['String']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  userUid?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['String']['input'];
};


export type MutationSyncEmployeeFromHrisArgs = {
  companyId: Scalars['String']['input'];
  employeeId: Scalars['String']['input'];
};


export type MutationTriggerPipelineArgs = {
  parameters?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};


export type MutationUpdateApplicationAlgoliaRecordArgs = {
  applicationData: ApplicationUpdateInput;
  applicationId: Scalars['ID']['input'];
  uid: Scalars['String']['input'];
};


export type MutationUpdateApplicationConsentArgs = {
  applicationId: Scalars['String']['input'];
  consent: Array<ConsentRecordInput>;
  userId: Scalars['String']['input'];
};


export type MutationUpdateApplicationFieldArgs = {
  applicationId: Scalars['String']['input'];
  field: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  value: Scalars['String']['input'];
};


export type MutationUpdateApplicationHouseholdMemberArgs = {
  applicationId: Scalars['String']['input'];
  data: ApplicationHouseholdMemberInput;
  memberId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationUpdateApplicationStatusArgs = {
  applicationId: Scalars['String']['input'];
  status: ApplicationStatus;
  userId: Scalars['String']['input'];
};


export type MutationUpdateApplicationStepArgs = {
  applicationId: Scalars['String']['input'];
  data: Scalars['String']['input'];
  step: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationUpdateCaseArgs = {
  caseId: Scalars['String']['input'];
  caseInput: CaseUpdateInput;
  companyId: Scalars['String']['input'];
};


export type MutationUpdateCaseHealthInsuranceDecisionArgs = {
  caseId: Scalars['String']['input'];
  cobraElectionReason?: InputMaybe<CobraElectionReasonType>;
  companyId: Scalars['String']['input'];
  healthInsuranceDecision: HealthInsuranceDecisionType;
};


export type MutationUpdateCompanyArgs = {
  companyId: Scalars['String']['input'];
  companyInput: UpdateCompanyInput;
};


export type MutationUpdateUserArgs = {
  uid?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserInput>;
};


export type MutationUploadApplicationDocumentArgs = {
  applicationId: Scalars['String']['input'];
  documentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileSize: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  fileUrl: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationUploadCarrierAppointmentsArgs = {
  csvData: Array<CarrierAppointmentsCsvInput>;
};


export type MutationUserSignOutArgs = {
  userId: Scalars['String']['input'];
};

export type PersonalInformation = {
  __typename?: 'PersonalInformation';
  citizen?: Maybe<Scalars['Boolean']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  incarcerated?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastTobaccoUsage?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  native?: Maybe<Scalars['Boolean']['output']>;
  ssn?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
  tobaccoUsage?: Maybe<Scalars['Boolean']['output']>;
};

export type PersonalInformationInput = {
  citizen?: InputMaybe<Scalars['Boolean']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  incarcerated?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastTobaccoUsage?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  native?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  tobaccoUsage?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PlanDetails = {
  __typename?: 'PlanDetails';
  benefitUrl?: Maybe<Scalars['String']['output']>;
  benefits?: Maybe<Array<Maybe<HealthBenefit>>>;
  brochureUrl?: Maybe<Scalars['String']['output']>;
  deductible?: Maybe<Scalars['Float']['output']>;
  diseasePrograms?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  formularyUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  market?: Maybe<Scalars['String']['output']>;
  maxOutOfPocket?: Maybe<Scalars['Float']['output']>;
  metal?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  networkUrl?: Maybe<Scalars['String']['output']>;
  premium?: Maybe<Scalars['Float']['output']>;
  premiumWithCredit?: Maybe<Scalars['Float']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PlanFilter = {
  __typename?: 'PlanFilter';
  filter?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type PlanProvider = {
  __typename?: 'PlanProvider';
  addresses: Array<PlanProviderAddress>;
  inNetwork: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  npi: Scalars['Int']['output'];
};

export type PlanProviderAddress = {
  __typename?: 'PlanProviderAddress';
  acceptingNewPatients?: Maybe<Scalars['Boolean']['output']>;
  city: Scalars['String']['output'];
  faxNumbers?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  networkTier?: Maybe<Scalars['String']['output']>;
  phoneNumbers?: Maybe<Array<Scalars['String']['output']>>;
  state: Scalars['String']['output'];
  streetLine1?: Maybe<Scalars['String']['output']>;
  streetLine2?: Maybe<Scalars['String']['output']>;
  zipCode: Scalars['String']['output'];
};

export type PlanTypePreferences = {
  __typename?: 'PlanTypePreferences';
  hmo?: Maybe<Scalars['Float']['output']>;
  ppo?: Maybe<Scalars['Float']['output']>;
  shortterm?: Maybe<Scalars['Float']['output']>;
};

export type PlanTypePreferencesInput = {
  hmo?: InputMaybe<Scalars['Float']['input']>;
  ppo?: InputMaybe<Scalars['Float']['input']>;
  shortterm?: InputMaybe<Scalars['Float']['input']>;
};

export type Preferences = {
  __typename?: 'Preferences';
  comprehensiveCoverage?: Maybe<Scalars['Float']['output']>;
  dental?: Maybe<Scalars['Float']['output']>;
  lowDeductible?: Maybe<Scalars['Float']['output']>;
  lowPremium?: Maybe<Scalars['Float']['output']>;
  mentalHealth?: Maybe<Scalars['Float']['output']>;
  networkSize?: Maybe<Scalars['Float']['output']>;
  planType?: Maybe<PlanTypePreferences>;
  vision?: Maybe<Scalars['Float']['output']>;
};

export type PreferencesInput = {
  comprehensiveCoverage?: InputMaybe<Scalars['Float']['input']>;
  dental?: InputMaybe<Scalars['Float']['input']>;
  lowDeductible?: InputMaybe<Scalars['Float']['input']>;
  lowPremium?: InputMaybe<Scalars['Float']['input']>;
  mentalHealth?: InputMaybe<Scalars['Float']['input']>;
  networkSize?: InputMaybe<Scalars['Float']['input']>;
  planType?: InputMaybe<PlanTypePreferencesInput>;
  vision?: InputMaybe<Scalars['Float']['input']>;
};

export type PremiumTier = {
  __typename?: 'PremiumTier';
  employeeContribution: Scalars['Float']['output'];
  employerContribution: Scalars['Float']['output'];
  totalPremium: Scalars['Float']['output'];
};

export type Prescription = {
  __typename?: 'Prescription';
  activeIngredientStrength?: Maybe<Scalars['String']['output']>;
  addedAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  medId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  ndcPackageCode?: Maybe<Scalars['String']['output']>;
  rxCuiId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type PrescriptionInput = {
  activeIngredientStrength?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  medId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  ndcPackageCode?: InputMaybe<Scalars['String']['input']>;
  rxCuiId?: InputMaybe<Scalars['String']['input']>;
};

export type PrescriptionSearchResult = {
  __typename?: 'PrescriptionSearchResult';
  drugPackages: Array<DrugPackage>;
  id?: Maybe<Scalars['String']['output']>;
  medId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  rxCuiId?: Maybe<Scalars['String']['output']>;
};

export type PrimaryContactInformation = {
  __typename?: 'PrimaryContactInformation';
  mailingAddress?: Maybe<Scalars['String']['output']>;
  mailingAddressLine2?: Maybe<Scalars['String']['output']>;
  mailingCity?: Maybe<Scalars['String']['output']>;
  mailingSameAsPermanent?: Maybe<Scalars['Boolean']['output']>;
  mailingState?: Maybe<Scalars['String']['output']>;
  mailingZip?: Maybe<Scalars['String']['output']>;
  permanentAddress?: Maybe<Scalars['String']['output']>;
  permanentAddressLine2?: Maybe<Scalars['String']['output']>;
  permanentCity?: Maybe<Scalars['String']['output']>;
  permanentState?: Maybe<Scalars['String']['output']>;
  permanentZip?: Maybe<Scalars['String']['output']>;
};

export type PrimaryContactInformationInput = {
  mailingAddress?: InputMaybe<Scalars['String']['input']>;
  mailingAddressLine2?: InputMaybe<Scalars['String']['input']>;
  mailingCity?: InputMaybe<Scalars['String']['input']>;
  mailingSameAsPermanent?: InputMaybe<Scalars['Boolean']['input']>;
  mailingState?: InputMaybe<Scalars['String']['input']>;
  mailingZip?: InputMaybe<Scalars['String']['input']>;
  permanentAddress?: InputMaybe<Scalars['String']['input']>;
  permanentAddressLine2?: InputMaybe<Scalars['String']['input']>;
  permanentCity?: InputMaybe<Scalars['String']['input']>;
  permanentState?: InputMaybe<Scalars['String']['input']>;
  permanentZip?: InputMaybe<Scalars['String']['input']>;
};

export type Provider = {
  __typename?: 'Provider';
  addedAt: Scalars['DateTime']['output'];
  addressId?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  npi: Scalars['Int']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  presentationName?: Maybe<Scalars['String']['output']>;
  specialty?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type ProviderAddress = {
  __typename?: 'ProviderAddress';
  accepting_new_patients?: Maybe<Scalars['Boolean']['output']>;
  city: Scalars['String']['output'];
  fax_numbers?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  phone_numbers?: Maybe<Array<Scalars['String']['output']>>;
  state: Scalars['String']['output'];
  street_line_1?: Maybe<Scalars['String']['output']>;
  street_line_2?: Maybe<Scalars['String']['output']>;
  zip_code: Scalars['String']['output'];
};

export type ProviderInput = {
  address_id?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  npi: Scalars['Int']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  presentation_name?: InputMaybe<Scalars['String']['input']>;
  specialty?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  zip_code?: InputMaybe<Scalars['String']['input']>;
};

export type ProviderNetwork = {
  __typename?: 'ProviderNetwork';
  carrier_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  languages?: Maybe<Array<Language>>;
  name: Scalars['String']['output'];
  specialties?: Maybe<Array<Specialty>>;
  tier?: Maybe<Scalars['String']['output']>;
};

export type ProviderNpiAddress = {
  __typename?: 'ProviderNpiAddress';
  city?: Maybe<Scalars['String']['output']>;
  fax_numbers: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  phone_numbers: Array<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street_line_1?: Maybe<Scalars['String']['output']>;
  street_line_2?: Maybe<Scalars['String']['output']>;
  zip_code?: Maybe<Scalars['String']['output']>;
};

export type ProviderSearchResult = {
  __typename?: 'ProviderSearchResult';
  addresses: Array<ProviderAddress>;
  credentials: Array<Scalars['String']['output']>;
  doing_business_as_name?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  middle_name?: Maybe<Scalars['String']['output']>;
  networks: Array<ProviderNetwork>;
  npi_address?: Maybe<ProviderNpiAddress>;
  npi_specialties: Array<ProviderSpecialty>;
  npis: Array<Scalars['Int']['output']>;
  organization_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  presentation_name: Scalars['String']['output'];
  specialty?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ProviderSpecialty = {
  __typename?: 'ProviderSpecialty';
  category?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  primary?: Maybe<Scalars['Boolean']['output']>;
  taxonomy_code?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  adminGetCase?: Maybe<CaseAccess>;
  adminGetUser?: Maybe<UserAccess>;
  aiRecommendation?: Maybe<AiRecommendationResult>;
  case: Case;
  caseEstimateImpact: CaseImpactResult;
  cases?: Maybe<Array<Case>>;
  company?: Maybe<Company>;
  confirmExitCodeIdentity?: Maybe<Scalars['Boolean']['output']>;
  connectionErrors?: Maybe<ConnectionErrorObject>;
  exitCodeInfo?: Maybe<ExitCodeInfo>;
  fetchDecryptedSSN?: Maybe<Scalars['String']['output']>;
  generateEnrollmentUrl?: Maybe<EnrollmentUrl>;
  geographyByZip?: Maybe<Array<Maybe<Counties>>>;
  getAllTimeReport?: Maybe<AllTimeReport>;
  getApplication?: Maybe<Application>;
  getApplicationNotes?: Maybe<Array<Maybe<ApplicationNote>>>;
  getApplicationStep?: Maybe<ApplicationStepData>;
  getApplications?: Maybe<Array<Maybe<Application>>>;
  getBenefitPlans: Array<BenefitPlan>;
  getCartStatus?: Maybe<Scalars['String']['output']>;
  getCaseStateByCreatedAt?: Maybe<CaseStateByCreatedAtData>;
  getCobraAdminDetails?: Maybe<CobraAdministrator>;
  getHousehold?: Maybe<Household>;
  getInsuranceDetails?: Maybe<InsuranceDetails>;
  getMixpanelData?: Maybe<MixpanelData>;
  getPreferences?: Maybe<Preferences>;
  getRates?: Maybe<Total>;
  getSearchToken?: Maybe<Scalars['String']['output']>;
  getSelectedPlanDetails?: Maybe<SelectedPlanDetails>;
  getUserBankInfo?: Maybe<BankInfo>;
  getUserPrescriptions: Array<Prescription>;
  getUserProviders: Array<Provider>;
  gptPrompt?: Maybe<GptResponse>;
  hris: HrisQueries;
  hrisConnectionDetails?: Maybe<HrisConnectionDetails>;
  listUsers?: Maybe<UsersSearchResults>;
  lookupEmployee?: Maybe<Contact>;
  marketplaceServices?: Maybe<Array<Maybe<MarketplaceService>>>;
  medicalPlans?: Maybe<Array<Maybe<MedicalPlan>>>;
  messages: Array<Message>;
  rawMessages?: Maybe<Array<Maybe<RawMessage>>>;
  reScorePlans?: Maybe<Total>;
  refreshEmployees?: Maybe<Scalars['Boolean']['output']>;
  reimbursements?: Maybe<Array<Maybe<ReimbursementRequest>>>;
  searchPlans?: Maybe<SearchResults>;
  searchPrescriptions: Array<PrescriptionSearchResult>;
  searchProviders: Array<ProviderSearchResult>;
  searchSpecialties: Array<Specialty>;
  subsidyCheck?: Maybe<FederalSubsidyAmount>;
  user?: Maybe<User>;
  whenBenefits?: Maybe<Array<Maybe<WhenBenefitWithCaseInfo>>>;
};


export type QueryAdminGetCaseArgs = {
  caseId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<HipaaViewReasons>;
};


export type QueryAdminGetUserArgs = {
  reason?: InputMaybe<HipaaViewReasons>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAiRecommendationArgs = {
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCaseArgs = {
  caseId: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
};


export type QueryCaseEstimateImpactArgs = {
  csvData: Array<BulkCaseCreateInput>;
};


export type QueryCasesArgs = {
  filters?: InputMaybe<CasesFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCompanyArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryConfirmExitCodeIdentityArgs = {
  birthDate: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  exitCode?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  terminationDate?: InputMaybe<Scalars['String']['input']>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryConnectionErrorsArgs = {
  companyId: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
};


export type QueryExitCodeInfoArgs = {
  companyId: Scalars['String']['input'];
  exitCode: Scalars['String']['input'];
};


export type QueryFetchDecryptedSsnArgs = {
  applicationId: Scalars['ID']['input'];
  applicationUserId: Scalars['String']['input'];
  householdMemberId: Scalars['String']['input'];
};


export type QueryGenerateEnrollmentUrlArgs = {
  carrierId?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGeographyByZipArgs = {
  zipcode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetApplicationArgs = {
  applicationId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QueryGetApplicationNotesArgs = {
  applicationId: Scalars['ID']['input'];
  applicationUserId: Scalars['String']['input'];
};


export type QueryGetApplicationStepArgs = {
  applicationId: Scalars['String']['input'];
  step: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QueryGetApplicationsArgs = {
  status?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetBenefitPlansArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryGetCartStatusArgs = {
  cartId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCaseStateByCreatedAtArgs = {
  fromDate: Scalars['String']['input'];
  toDate: Scalars['String']['input'];
};


export type QueryGetCobraAdminDetailsArgs = {
  cobraAdminName: Scalars['String']['input'];
};


export type QueryGetHouseholdArgs = {
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetInsuranceDetailsArgs = {
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetMixpanelDataArgs = {
  events: Scalars['String']['input'];
  fromDate: Scalars['String']['input'];
  toDate: Scalars['String']['input'];
};


export type QueryGetPreferencesArgs = {
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRatesArgs = {
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSearchTokenArgs = {
  adminSearch?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSelectedPlanDetailsArgs = {
  uid: Scalars['String']['input'];
};


export type QueryGetUserBankInfoArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserPrescriptionsArgs = {
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserProvidersArgs = {
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGptPromptArgs = {
  prompt?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHrisConnectionDetailsArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  connectionId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListUsersArgs = {
  filters?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLookupEmployeeArgs = {
  company?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplaceServicesArgs = {
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMedicalPlansArgs = {
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReScorePlansArgs = {
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRefreshEmployeesArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReimbursementsArgs = {
  reimbursementId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchPlansArgs = {
  filters?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchPrescriptionsArgs = {
  requireFormulary?: InputMaybe<Scalars['Boolean']['input']>;
  searchTerm: Scalars['String']['input'];
};


export type QuerySearchProvidersArgs = {
  providerNameSearch: Scalars['String']['input'];
  radius?: InputMaybe<Scalars['Int']['input']>;
  specialtyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['String']['input'];
};


export type QuerySearchSpecialtiesArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySubsidyCheckArgs = {
  uid: Scalars['String']['input'];
};


export type QueryUserArgs = {
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWhenBenefitsArgs = {
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QuotitHealthBenefit = {
  __typename?: 'QuotitHealthBenefit';
  category: Scalars['String']['output'];
  enum: Scalars['String']['output'];
  exclusions?: Maybe<Scalars['String']['output']>;
  inNetwork: Scalars['String']['output'];
  outOfNetwork: Scalars['String']['output'];
};

export type Rating = {
  __typename?: 'Rating';
  administration: Scalars['String']['output'];
  experience: Scalars['String']['output'];
  medical: Scalars['String']['output'];
  overall: Scalars['String']['output'];
};

export type RatingInput = {
  administration?: InputMaybe<Scalars['String']['input']>;
  experience?: InputMaybe<Scalars['String']['input']>;
  medical?: InputMaybe<Scalars['String']['input']>;
  overall?: InputMaybe<Scalars['String']['input']>;
};

export type RawMessage = {
  __typename?: 'RawMessage';
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  user: Scalars['Boolean']['output'];
};

export type Recommendation = {
  __typename?: 'Recommendation';
  aiScore?: Maybe<Scalars['Float']['output']>;
  cons?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  explanation?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  internalScore: Scalars['Float']['output'];
  pros?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type RecommendationPlans = {
  __typename?: 'RecommendationPlans';
  lowestDeductible?: Maybe<PlanDetails>;
  lowestOutOfPocket?: Maybe<PlanDetails>;
  lowestPremium?: Maybe<PlanDetails>;
};

export type Recommendations = {
  __typename?: 'Recommendations';
  plans?: Maybe<RecommendationPlans>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ReimbursementFile = {
  __typename?: 'ReimbursementFile';
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ReimbursementFileInput = {
  name: Scalars['String']['input'];
  path: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type ReimbursementRequest = {
  __typename?: 'ReimbursementRequest';
  amount: Scalars['Float']['output'];
  approvedAmount?: Maybe<Scalars['Float']['output']>;
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  approvedBy?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use coverageMonths instead */
  coverageEndDate?: Maybe<Scalars['String']['output']>;
  coverageMonths: Array<Scalars['String']['output']>;
  /** @deprecated Use coverageMonths instead */
  coverageStartDate?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deniedAt?: Maybe<Scalars['DateTime']['output']>;
  deniedBy?: Maybe<Scalars['String']['output']>;
  files: Array<ReimbursementFile>;
  notes?: Maybe<Scalars['String']['output']>;
  reimbursedAt?: Maybe<Scalars['DateTime']['output']>;
  reimbursedBy?: Maybe<Scalars['String']['output']>;
  reimbursementRequestId: Scalars['String']['output'];
  status: ReimbursementRequestStatus;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type ReimbursementRequestInput = {
  amount: Scalars['Float']['input'];
  approvedAmount?: InputMaybe<Scalars['Float']['input']>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  approvedBy?: InputMaybe<Scalars['String']['input']>;
  coverageMonths: Array<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deniedAt?: InputMaybe<Scalars['DateTime']['input']>;
  deniedBy?: InputMaybe<Scalars['String']['input']>;
  files: Array<ReimbursementFileInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  reimbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reimbursedBy?: InputMaybe<Scalars['String']['input']>;
  reimbursementRequestId: Scalars['String']['input'];
  status: ReimbursementRequestStatus;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
};

export enum ReimbursementRequestStatus {
  Approved = 'APPROVED',
  Denied = 'DENIED',
  Pending = 'PENDING',
  Reimbursed = 'REIMBURSED'
}

export enum Relationship {
  Child = 'child',
  Other = 'other',
  Self = 'self',
  Spouse = 'spouse'
}

export enum Role {
  AdminEditor = 'AdminEditor',
  AdminViewer = 'AdminViewer',
  CompaniesEditor = 'CompaniesEditor',
  CompaniesViewer = 'CompaniesViewer',
  InsuranceEditor = 'InsuranceEditor',
  InsuranceViewer = 'InsuranceViewer',
  ReimbursementsEditor = 'ReimbursementsEditor',
  RemimbursementsViewer = 'RemimbursementsViewer',
  Self = 'Self',
  SupportEditor = 'SupportEditor',
  SupportViewer = 'SupportViewer',
  System = 'System'
}

export type SearchResults = {
  __typename?: 'SearchResults';
  page?: Maybe<Scalars['Int']['output']>;
  plans?: Maybe<Array<Maybe<PlanDetails>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SelectedPlanDetails = {
  __typename?: 'SelectedPlanDetails';
  benefitLevel?: Maybe<Scalars['String']['output']>;
  carrier?: Maybe<Carrier>;
  deductible?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  moop?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  offMarket?: Maybe<Scalars['Boolean']['output']>;
  onMarket?: Maybe<Scalars['Boolean']['output']>;
  outOfPocketMax?: Maybe<Scalars['String']['output']>;
  planType?: Maybe<Scalars['String']['output']>;
  premium?: Maybe<Scalars['Float']['output']>;
  premiumSubsidized?: Maybe<Scalars['Float']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  rateSubsidized?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Rating>;
  selectedAt?: Maybe<Scalars['String']['output']>;
};

export type SelectedPlanDetailsInput = {
  benefitLevel?: InputMaybe<Scalars['String']['input']>;
  carrier: CarrierInput;
  deductible?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  moop?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  offMarket?: InputMaybe<Scalars['Boolean']['input']>;
  onMarket?: InputMaybe<Scalars['Boolean']['input']>;
  outOfPocketMax?: InputMaybe<Scalars['String']['input']>;
  planType: Scalars['String']['input'];
  premium?: InputMaybe<Scalars['Float']['input']>;
  premiumSubsidized?: InputMaybe<Scalars['Float']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  rateSubsidized?: InputMaybe<Scalars['Float']['input']>;
  rating?: InputMaybe<RatingInput>;
  selectedAt?: InputMaybe<Scalars['String']['input']>;
};

export type SendProcessedApplicationEmailResponse = {
  __typename?: 'SendProcessedApplicationEmailResponse';
  error?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ServicePhoto = {
  __typename?: 'ServicePhoto';
  name?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum ServiceType {
  Aas = 'AAS',
  DesignatedCsm = 'DESIGNATED_CSM',
  Pac = 'PAC',
  WhiteGlove = 'WHITE_GLOVE'
}

export enum SharedStatus {
  NotShared = 'NOT_SHARED',
  Scheduled = 'SCHEDULED',
  Shared = 'SHARED'
}

export type Specialty = {
  __typename?: 'Specialty';
  category?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  primary?: Maybe<Scalars['Boolean']['output']>;
  sub_specialty?: Maybe<Scalars['String']['output']>;
  taxonomy_code?: Maybe<Scalars['String']['output']>;
};

export type StepCompletion = {
  __typename?: 'StepCompletion';
  completedOn?: Maybe<Scalars['DateTime']['output']>;
  completionDate?: Maybe<Scalars['DateTime']['output']>;
  isCompleted?: Maybe<Scalars['Boolean']['output']>;
};

export type StepCompletionInput = {
  completedOn?: InputMaybe<Scalars['DateTime']['input']>;
  completionDate?: InputMaybe<Scalars['DateTime']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StringQueryOperatorInput = {
  eq?: InputMaybe<Scalars['String']['input']>;
  glob?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['String']['input']>;
};

export type SyncUser = {
  __typename?: 'SyncUser';
  date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export enum TerminationTypes {
  CobraOe = 'COBRA_OE',
  Death = 'DEATH',
  DependentLossOfCoverage = 'DEPENDENT_LOSS_OF_COVERAGE',
  EarlyRetirement = 'EARLY_RETIREMENT',
  FamilySeparation = 'FAMILY_SEPARATION',
  FriendsAndFamily = 'FRIENDS_AND_FAMILY',
  Hire = 'HIRE',
  HoursReduction = 'HOURS_REDUCTION',
  Involuntary = 'INVOLUNTARY',
  InvoluntaryTermination = 'INVOLUNTARY_TERMINATION',
  Layoff = 'LAYOFF',
  LossOfCoverage = 'LOSS_OF_COVERAGE',
  MedicareEligible = 'MEDICARE_ELIGIBLE',
  Onboarding = 'ONBOARDING',
  OpenEnrollment = 'OPEN_ENROLLMENT',
  Retirement = 'RETIREMENT',
  Rif = 'RIF',
  StudentLossOfCoverage = 'STUDENT_LOSS_OF_COVERAGE',
  Voluntary = 'VOLUNTARY',
  VoluntaryTermination = 'VOLUNTARY_TERMINATION'
}

export type TimingValue = {
  __typename?: 'TimingValue';
  measure: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type TimingValueInput = {
  measure: Scalars['String']['input'];
  value: Scalars['Int']['input'];
};

export type Total = {
  __typename?: 'Total';
  total?: Maybe<Scalars['Int']['output']>;
};

export enum UnusedFundsType {
  Expire = 'EXPIRE',
  Rollover = 'ROLLOVER'
}

export type UpdateApplicationAlgoliaRecordResult = {
  __typename?: 'UpdateApplicationAlgoliaRecordResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateCompanyInput = {
  activationDate?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<ExtendedAddressInput>;
  automation?: InputMaybe<CompanyAutomationInput>;
  branding?: InputMaybe<CompanyBrandingInput>;
  cobraAdministrationProvider?: InputMaybe<Scalars['String']['input']>;
  companyPointOfContact?: InputMaybe<CompanyContactInput>;
  customerSuccessManager?: InputMaybe<Scalars['String']['input']>;
  emailDomain?: InputMaybe<Array<Scalars['String']['input']>>;
  employeeCount?: InputMaybe<Scalars['Int']['input']>;
  externalCompanyIdentifier?: InputMaybe<Scalars['String']['input']>;
  fein?: InputMaybe<Scalars['String']['input']>;
  headquarterState?: InputMaybe<Scalars['String']['input']>;
  healthInsurancePlanRenewalMonth?: InputMaybe<Scalars['String']['input']>;
  hrisSetup?: InputMaybe<Scalars['Boolean']['input']>;
  landingPages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logo?: InputMaybe<Scalars['String']['input']>;
  monthlyWhenBenefitSettings?: InputMaybe<CompanyMonthlyWhenBenefitSettingsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  planRenewalMonth?: InputMaybe<Scalars['String']['input']>;
  servicesEnabled?: InputMaybe<Array<ServiceType>>;
  terminationDate?: InputMaybe<Scalars['String']['input']>;
  timing?: InputMaybe<CompanyTimingInput>;
  verificationStep?: InputMaybe<Scalars['Boolean']['input']>;
  whenBenefitUseOnCobra?: InputMaybe<Scalars['String']['input']>;
  zendeskOrganizationId?: InputMaybe<Scalars['Float']['input']>;
};

export type UploadCarrierAppointmentsResponse = {
  __typename?: 'UploadCarrierAppointmentsResponse';
  count: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type User = {
  __typename?: 'User';
  acceptedPrivacyPolicy?: Maybe<Scalars['String']['output']>;
  acceptedTermsOfService?: Maybe<Scalars['String']['output']>;
  address?: Maybe<ExtendedAddress>;
  admin?: Maybe<Scalars['Boolean']['output']>;
  companies?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  companyId?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  directDeposit?: Maybe<DirectDeposit>;
  email?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  mfa?: Maybe<Mfa>;
  name?: Maybe<UserName>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneType?: Maybe<Scalars['String']['output']>;
  preferredContact?: Maybe<Scalars['String']['output']>;
  uid?: Maybe<Scalars['String']['output']>;
};

export type UserAccess = {
  __typename?: 'UserAccess';
  companyId?: Maybe<Scalars['String']['output']>;
  expiration?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserActivityInput = {
  activity: Scalars['String']['input'];
  data?: InputMaybe<Scalars['String']['input']>;
  device?: InputMaybe<DeviceDataInput>;
  message?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UserInput = {
  acceptedPrivacyPolicy?: InputMaybe<Scalars['String']['input']>;
  acceptedTermsOfService?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<ExtendedAddressInput>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  directDeposit?: InputMaybe<DirectDepositInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  mfa?: InputMaybe<MfaInput>;
  name?: InputMaybe<UserNameInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneType?: InputMaybe<Scalars['String']['input']>;
  preferredContact?: InputMaybe<Scalars['String']['input']>;
};

export type UserName = {
  __typename?: 'UserName';
  display?: Maybe<Scalars['String']['output']>;
  first?: Maybe<Scalars['String']['output']>;
  last?: Maybe<Scalars['String']['output']>;
  lowercase?: Maybe<Scalars['String']['output']>;
};

export type UserNameInput = {
  display?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['String']['input']>;
};

export type UsersSearchResults = {
  __typename?: 'UsersSearchResults';
  users?: Maybe<Array<Maybe<User>>>;
};

export enum WhenBenefitSubstatusType {
  Allocated = 'ALLOCATED',
  Available = 'AVAILABLE',
  Closed = 'CLOSED',
  Forfeited = 'FORFEITED',
  InProgress = 'IN_PROGRESS',
  NotApplicable = 'NOT_APPLICABLE',
  Returned = 'RETURNED'
}

export type WhenBenefitWithCaseInfo = {
  __typename?: 'WhenBenefitWithCaseInfo';
  benefit?: Maybe<CaseWhenBenefit>;
  caseId?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
};

export type CsvUploadMutations = {
  __typename?: 'csvUploadMutations';
  uploadBatch?: Maybe<Scalars['Boolean']['output']>;
};


export type CsvUploadMutationsUploadBatchArgs = {
  companyId: Scalars['String']['input'];
  employees?: InputMaybe<Array<InputMaybe<EmployeeInput>>>;
};

export type FederalSubsidyAmount = {
  __typename?: 'federalSubsidyAmount';
  federalSubsidyAmount?: Maybe<Scalars['Float']['output']>;
};

export type CreateCompanyMutationVariables = Exact<{
  companyInput: CompanyInput;
}>;


export type CreateCompanyMutation = { __typename?: 'Mutation', createCompany?: { __typename?: 'CompanyMutationResponse', success: boolean, company?: { __typename?: 'Company', code: string } | null } | null };

export type ShareCaseMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  caseId: Scalars['String']['input'];
  shareDate: Scalars['Date']['input'];
}>;


export type ShareCaseMutation = { __typename?: 'Mutation', shareCase?: { __typename?: 'Case', id: string } | null };

export type AddCaseMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  caseInput: CaseInput;
}>;


export type AddCaseMutation = { __typename?: 'Mutation', addCase?: { __typename?: 'Case', id: string } | null };

export type UpdateCaseMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  caseId: Scalars['String']['input'];
  caseInput: CaseUpdateInput;
}>;


export type UpdateCaseMutation = { __typename?: 'Mutation', updateCase?: { __typename?: 'Case', id: string } | null };

export type UpdateCaseHealthInsuranceDecisionMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  caseId: Scalars['String']['input'];
  healthInsuranceDecision: HealthInsuranceDecisionType;
  cobraElectionReason?: InputMaybe<CobraElectionReasonType>;
}>;


export type UpdateCaseHealthInsuranceDecisionMutation = { __typename?: 'Mutation', updateCaseHealthInsuranceDecision?: { __typename?: 'Case', id: string } | null };

export type ConnectSimpleHrisMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  connectionMethod: Scalars['String']['input'];
  connectionDetails: Scalars['String']['input'];
}>;


export type ConnectSimpleHrisMutation = { __typename?: 'Mutation', connectSimpleHris?: boolean | null };

export type TriggerPipelineMutationVariables = Exact<{
  type: Scalars['String']['input'];
  parameters?: InputMaybe<Scalars['String']['input']>;
}>;


export type TriggerPipelineMutation = { __typename?: 'Mutation', triggerPipeline?: boolean | null };

export type SendMessageMutationVariables = Exact<{
  message: Scalars['String']['input'];
}>;


export type SendMessageMutation = { __typename?: 'Mutation', sendMessage: boolean };

export type CancelMessageMutationVariables = Exact<{ [key: string]: never; }>;


export type CancelMessageMutation = { __typename?: 'Mutation', cancelMessage?: boolean | null };

export type ClearMessagesMutationVariables = Exact<{ [key: string]: never; }>;


export type ClearMessagesMutation = { __typename?: 'Mutation', clearMessages?: boolean | null };

export type SetHouseholdMutationVariables = Exact<{
  uid?: InputMaybe<Scalars['String']['input']>;
  members?: InputMaybe<Array<InputMaybe<HouseholdMemberInput>> | InputMaybe<HouseholdMemberInput>>;
}>;


export type SetHouseholdMutation = { __typename?: 'Mutation', setHousehold?: boolean | null };

export type SetInsuranceDetailsMutationVariables = Exact<{
  uid?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<InsuranceDetailsInput>;
}>;


export type SetInsuranceDetailsMutation = { __typename?: 'Mutation', setInsuranceDetails?: boolean | null };

export type BeginJamieChatMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type BeginJamieChatMutation = { __typename?: 'Mutation', beginJamieChat: boolean };

export type CreateApplicationMutationVariables = Exact<{
  planId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type CreateApplicationMutation = { __typename?: 'Mutation', createApplication: { __typename?: 'ApplicationResponse', applicationId?: string | null, success: boolean, message?: string | null } };

export type AdminCreateApplicationMutationVariables = Exact<{
  applicantUserId: Scalars['String']['input'];
  applicationPlanData: ApplicationPlanDataInput;
}>;


export type AdminCreateApplicationMutation = { __typename?: 'Mutation', adminCreateApplication: { __typename?: 'ApplicationResponse', applicationId?: string | null, success: boolean, message?: string | null } };

export type SubmitApplicationMutationVariables = Exact<{
  uid?: InputMaybe<Scalars['String']['input']>;
  applicationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SubmitApplicationMutation = { __typename?: 'Mutation', submitApplication?: boolean | null };

export type SaveApplicationSsnMutationVariables = Exact<{
  uid: Scalars['String']['input'];
  applicationId: Scalars['ID']['input'];
  ssn: Scalars['String']['input'];
  householdMemberId: Scalars['String']['input'];
}>;


export type SaveApplicationSsnMutation = { __typename?: 'Mutation', saveApplicationSSN?: boolean | null };

export type AddApplicationNoteMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
  applicationUserId: Scalars['String']['input'];
  note: ApplicationNoteInput;
}>;


export type AddApplicationNoteMutation = { __typename?: 'Mutation', addApplicationNote?: boolean | null };

export type UpdateApplicationAlgoliaRecordMutationVariables = Exact<{
  uid: Scalars['String']['input'];
  applicationId: Scalars['ID']['input'];
  applicationData: ApplicationUpdateInput;
}>;


export type UpdateApplicationAlgoliaRecordMutation = { __typename?: 'Mutation', updateApplicationAlgoliaRecord?: { __typename?: 'UpdateApplicationAlgoliaRecordResult', success: boolean, errorMessage?: string | null } | null };

export type SendProcessedApplicationEmailMutationVariables = Exact<{
  applicantUserId: Scalars['String']['input'];
}>;


export type SendProcessedApplicationEmailMutation = { __typename?: 'Mutation', sendProcessedApplicationEmail: { __typename?: 'SendProcessedApplicationEmailResponse', success: boolean, message: string, error?: string | null } };

export type SetPreferencesMutationVariables = Exact<{
  uid?: InputMaybe<Scalars['String']['input']>;
  preferences?: InputMaybe<PreferencesInput>;
}>;


export type SetPreferencesMutation = { __typename?: 'Mutation', setPreferences?: boolean | null };

export type SubmitReimbursementRequestMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  whenBenefitId: Scalars['String']['input'];
  files: Array<ReimbursementFileInput> | ReimbursementFileInput;
  amount: Scalars['Float']['input'];
  months: Array<Scalars['String']['input']> | Scalars['String']['input'];
  companyId?: InputMaybe<Scalars['String']['input']>;
  caseId?: InputMaybe<Scalars['String']['input']>;
  coverageStartDate?: InputMaybe<Scalars['String']['input']>;
  coverageEndDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type SubmitReimbursementRequestMutation = { __typename?: 'Mutation', submitReimbursementRequest?: boolean | null };

export type CancelReimbursementRequestMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  whenBenefitId: Scalars['String']['input'];
}>;


export type CancelReimbursementRequestMutation = { __typename?: 'Mutation', cancelReimbursementRequest?: boolean | null };

export type ApproveReimbursementRequestMutationVariables = Exact<{
  requestId: Scalars['String']['input'];
  requestUserId: Scalars['String']['input'];
  requestBenefitId: Scalars['String']['input'];
  approvedAmount: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  status: Scalars['String']['input'];
}>;


export type ApproveReimbursementRequestMutation = { __typename?: 'Mutation', approveReimbursementRequest?: boolean | null };

export type DenyReimbursementRequestMutationVariables = Exact<{
  requestUserId: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
  requestBenefitId: Scalars['String']['input'];
  denialReason: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
}>;


export type DenyReimbursementRequestMutation = { __typename?: 'Mutation', denyReimbursementRequest?: boolean | null };

export type AdditionalInfoRequestMutationVariables = Exact<{
  requestUserId: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
  requestBenefitId: Scalars['String']['input'];
  msg?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
}>;


export type AdditionalInfoRequestMutation = { __typename?: 'Mutation', additionalInfoRequest?: boolean | null };

export type SyncDataForExitCodeMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  exitCode: Scalars['String']['input'];
  birthDate: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  userUid?: InputMaybe<Scalars['String']['input']>;
}>;


export type SyncDataForExitCodeMutation = { __typename?: 'Mutation', syncDataForExitCode?: boolean | null };

export type ContactUsMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContactUsMutation = { __typename?: 'Mutation', contactUs?: boolean | null };

export type ReleaseCaseBenefitMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  caseId: Scalars['String']['input'];
}>;


export type ReleaseCaseBenefitMutation = { __typename?: 'Mutation', releaseCaseBenefit?: boolean | null };

export type DeleteUserDirectDepositMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type DeleteUserDirectDepositMutation = { __typename?: 'Mutation', deleteUserDirectDeposit?: boolean | null };

export type UserSignOutMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type UserSignOutMutation = { __typename?: 'Mutation', userSignOut?: boolean | null };

export type CreateCaseMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  employeeId: Scalars['String']['input'];
  checklistId: Scalars['String']['input'];
  terminationDate: Scalars['String']['input'];
  lastDay?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
  terminationType: Scalars['String']['input'];
  benefitTier: BenefitTier;
  secure: Scalars['Boolean']['input'];
}>;


export type CreateCaseMutation = { __typename?: 'Mutation', createCase?: string | null };

export type UploadBatchMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  employees?: InputMaybe<Array<InputMaybe<EmployeeInput>> | InputMaybe<EmployeeInput>>;
}>;


export type UploadBatchMutation = { __typename?: 'Mutation', hris: { __typename?: 'HRISMutations', csvUpload?: { __typename?: 'csvUploadMutations', uploadBatch?: boolean | null } | null } };

export type BulkCaseCreateMutationVariables = Exact<{
  cases: Array<BulkCaseCreateInput> | BulkCaseCreateInput;
}>;


export type BulkCaseCreateMutation = { __typename?: 'Mutation', bulkCaseCreate?: { __typename?: 'BulkCaseCreateResult', success: boolean, error?: string | null } | null };

export type SetupCompanyMutationVariables = Exact<{
  companyName: Scalars['String']['input'];
  employeeCount: Scalars['Int']['input'];
  country: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  emailAddress: Scalars['String']['input'];
  title: Scalars['String']['input'];
  phone: Scalars['String']['input'];
}>;


export type SetupCompanyMutation = { __typename?: 'Mutation', setupCompany?: boolean | null };

export type ResendConnectEmailMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  inviteId: Scalars['String']['input'];
}>;


export type ResendConnectEmailMutation = { __typename?: 'Mutation', resendConnectEmail?: boolean | null };

export type ConnectUserToCompanyMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  inviteId: Scalars['String']['input'];
}>;


export type ConnectUserToCompanyMutation = { __typename?: 'Mutation', connectUserToCompany?: boolean | null };

export type SyncHrisMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type SyncHrisMutation = { __typename?: 'Mutation', queueHrisSync?: boolean | null };

export type SetPublicTokenMutationVariables = Exact<{
  publicToken: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
}>;


export type SetPublicTokenMutation = { __typename?: 'Mutation', hris: { __typename?: 'HRISMutations', merge: { __typename?: 'MergeMutations', setPublicToken?: boolean | null } } };

export type SetUserClaimsMutationVariables = Exact<{
  uid?: InputMaybe<Scalars['String']['input']>;
  admin?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SetUserClaimsMutation = { __typename?: 'Mutation', setUserClaims?: { __typename?: 'User', uid?: string | null, email?: string | null, admin?: boolean | null } | null };

export type SetUserDirectDepositMutationVariables = Exact<{
  accountNumber: Scalars['String']['input'];
  nameOnAccount: Scalars['String']['input'];
  routingNumber: Scalars['String']['input'];
}>;


export type SetUserDirectDepositMutation = { __typename?: 'Mutation', setUserDirectDeposit?: boolean | null };

export type QueueHrisSyncMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type QueueHrisSyncMutation = { __typename?: 'Mutation', queueHrisSync?: boolean | null };

export type ConnectFinchMutationVariables = Exact<{
  clientCode: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
}>;


export type ConnectFinchMutation = { __typename?: 'Mutation', hris: { __typename?: 'HRISMutations', finch: { __typename?: 'FinchMutations', connectFinch?: boolean | null } } };

export type UploadCarrierAppointmentsMutationVariables = Exact<{
  csvData: Array<CarrierAppointmentsCsvInput> | CarrierAppointmentsCsvInput;
}>;


export type UploadCarrierAppointmentsMutation = { __typename?: 'Mutation', uploadCarrierAppointments?: { __typename?: 'UploadCarrierAppointmentsResponse', success: boolean, count: number } | null };

export type AdminCreateUserFromCaseMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  caseId: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  dateOfBirth: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
}>;


export type AdminCreateUserFromCaseMutation = { __typename?: 'Mutation', adminCreateUserFromCase?: { __typename?: 'User', uid?: string | null, email?: string | null, admin?: boolean | null } | null };

export type UpdateCompanySettingsMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  companyInput: UpdateCompanyInput;
}>;


export type UpdateCompanySettingsMutation = { __typename?: 'Mutation', updateCompany?: { __typename?: 'CompanyMutationResponse', success: boolean, error?: string | null } | null };

export type ConfigureDemoCaseMutationVariables = Exact<{
  caseType: CaseTypes;
  whenBenefit?: InputMaybe<CaseWhenBenefitInput>;
}>;


export type ConfigureDemoCaseMutation = { __typename?: 'Mutation', configureDemoCase?: { __typename?: 'Case', id: string, companyId: string, caseId: string, contact?: { __typename?: 'CaseContact', firstName?: string | null, lastName?: string | null, dateOfBirth?: Moment | null, address?: { __typename?: 'ExtendedAddress', zip?: string | null } | null } | null, whenBenefit?: { __typename?: 'CaseWhenBenefit', amount?: number | null } | null } | null };

export type UpdateUserMutationVariables = Exact<{
  uid?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserInput>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'User', uid?: string | null, email?: string | null, phoneNumber?: string | null, created?: Moment | null, lastLogin?: Moment | null, admin?: boolean | null, dateOfBirth?: string | null, gender?: string | null, acceptedPrivacyPolicy?: string | null, acceptedTermsOfService?: string | null, name?: { __typename?: 'UserName', first?: string | null, last?: string | null, display?: string | null, lowercase?: string | null } | null, address?: { __typename?: 'ExtendedAddress', street1?: string | null, street2?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, directDeposit?: { __typename?: 'DirectDeposit', last4?: string | null, accountType?: string | null, accountHolderName?: string | null } | null } | null };

export type CompanyQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type CompanyQuery = { __typename?: 'Query', company?: { __typename?: 'Company', code: string, emailDomain?: Array<string> | null, servicesEnabled?: Array<ServiceType> | null, hrisSetup?: boolean | null, landingPages?: Array<string | null> | null, logo?: string | null, name: string, terminationDate?: string | null, zendeskOrganizationId?: number | null, createdOn: Moment, address?: { __typename?: 'ExtendedAddress', street1?: string | null, street2?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null };

export type CaseQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  caseId: Scalars['String']['input'];
}>;


export type CaseQuery = { __typename?: 'Query', case: { __typename?: 'Case', id: string, caseId: string, name?: string | null, caseType?: CaseTypes | null, companyId: string, status: CaseStatus, createdAt: Moment, createdBy?: string | null, updatedAt: Moment, updatedBy?: string | null, closeDate?: Moment | null, secure?: boolean | null, shareDate?: Moment | null, sharedOn?: Moment | null, scheduled?: boolean | null, shared?: Moment | null, sharedStatus?: SharedStatus | null, klaviyoCaseShared?: boolean | null, zendeskTicket?: boolean | null, healthInsuranceDecision?: HealthInsuranceDecisionType | null, cobraElectionReason?: CobraElectionReasonType | null, exitMeetingDate?: Moment | null, released?: Moment | null, ref?: string | null, benefitTier?: string | null, lastDay?: Moment | null, terminationDate?: Moment | null, reason?: string | null, terminationType?: TerminationTypes | null, dataVersion: string, healthInsuranceDecisionDetail?: HealthInsuranceDecisionDetailType | null, assignee?: string | null, syncStatus?: boolean | null, syncedAt?: Moment | null, servicesEnabled?: Array<ServiceType> | null, klaviyo?: { __typename?: 'CaseKlaviyo', caseShared?: { __typename?: 'CaseKlaviyoCaseShared', date?: Moment | null } | null } | null, zendesk?: { __typename?: 'CaseZendesk', ticketId?: number | null, date?: Moment | null } | null, tasks?: { __typename?: 'CaseTasks', open?: number | null, closed?: number | null, total?: number | null } | null, syncUser?: { __typename?: 'SyncUser', id?: string | null, date?: Moment | null } | null, contact?: { __typename?: 'CaseContact', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, dateOfBirth?: Moment | null, salary?: number | null, gender?: string | null, status?: string | null, ethnicity?: string | null, maritalStatus?: string | null, flsaStatus?: string | null, payFrequency?: string | null, payRate?: number | null, payCurrency?: string | null, title?: string | null, hireDate?: Moment | null, terminationDate?: Moment | null, address?: { __typename?: 'ExtendedAddress', street1?: string | null, street2?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null, cobranding?: { __typename?: 'CaseCobranding', logo?: string | null, name?: string | null, companyCode?: string | null } | null, childCompany?: { __typename?: 'CaseCompany', id?: string | null, name?: string | null, logoUrl?: string | null, contact?: { __typename?: 'CaseCompanyContact', name?: string | null, email?: string | null, phone?: string | null } | null } | null, event?: { __typename?: 'CaseEvent', type?: CaseEventTypes | null, date?: Moment | null, termination?: { __typename?: 'CaseTermination', type?: TerminationTypes | null, reason?: string | null } | null, cobra?: { __typename?: 'CaseCobra', qualifyingEvent?: string | null, estimate?: number | null, currentContribution?: number | null } | null } | null, household?: Array<{ __typename?: 'CaseHouseholdMember', firstName?: string | null, lastName?: string | null, dateOfBirth?: Moment | null, relationship?: string | null } | null> | null, benefits?: Array<{ __typename?: 'CaseBenefit', type?: string | null, name?: string | null, carrier?: string | null, monthlyEmployeeContribution?: number | null, monthlyEmployerContribution?: number | null, benefitEndDate?: Moment | null, dependents?: Array<{ __typename?: 'CaseDependent', firstName?: string | null, lastName?: string | null, dateOfBirth?: Moment | null, relationship?: string | null } | null> | null } | null> | null, services?: Array<{ __typename?: 'CaseService', type?: string | null, whenBenefitAmount?: number | null } | null> | null, whenBenefit?: { __typename?: 'CaseWhenBenefit', status?: WhenBenefitSubstatusType | null, hasBenefit?: boolean | null, benefitTier?: string | null, amount?: number | null, releasedDate?: Moment | null, distributionType?: DistributionType | null, unusedFunds?: UnusedFundsType | null, monthsToAllocate?: number | null, detail?: { __typename?: 'CaseWhenBenefitDetail', total?: number | null, amountSpent?: number | null, amountPending?: number | null, amountRemaining?: number | null, amountForfeited?: number | null } | null } | null } };

export type CasesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<CasesFiltersInput>;
}>;


export type CasesQuery = { __typename?: 'Query', cases?: Array<{ __typename?: 'Case', id: string, caseId: string, name?: string | null, caseType?: CaseTypes | null, companyId: string, status: CaseStatus, createdAt: Moment, createdBy?: string | null, updatedAt: Moment, updatedBy?: string | null, closeDate?: Moment | null, secure?: boolean | null, shareDate?: Moment | null, sharedOn?: Moment | null, scheduled?: boolean | null, shared?: Moment | null, sharedStatus?: SharedStatus | null, klaviyoCaseShared?: boolean | null, zendeskTicket?: boolean | null, healthInsuranceDecision?: HealthInsuranceDecisionType | null, cobraElectionReason?: CobraElectionReasonType | null, exitMeetingDate?: Moment | null, released?: Moment | null, ref?: string | null, benefitTier?: string | null, lastDay?: Moment | null, terminationDate?: Moment | null, reason?: string | null, terminationType?: TerminationTypes | null, dataVersion: string, healthInsuranceDecisionDetail?: HealthInsuranceDecisionDetailType | null, assignee?: string | null, syncStatus?: boolean | null, syncedAt?: Moment | null, klaviyo?: { __typename?: 'CaseKlaviyo', caseShared?: { __typename?: 'CaseKlaviyoCaseShared', date?: Moment | null } | null } | null, zendesk?: { __typename?: 'CaseZendesk', ticketId?: number | null, date?: Moment | null } | null, tasks?: { __typename?: 'CaseTasks', open?: number | null, closed?: number | null, total?: number | null } | null, syncUser?: { __typename?: 'SyncUser', id?: string | null, date?: Moment | null } | null, contact?: { __typename?: 'CaseContact', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, dateOfBirth?: Moment | null, salary?: number | null, gender?: string | null, status?: string | null, ethnicity?: string | null, maritalStatus?: string | null, flsaStatus?: string | null, payFrequency?: string | null, payRate?: number | null, payCurrency?: string | null, title?: string | null, hireDate?: Moment | null, terminationDate?: Moment | null, address?: { __typename?: 'ExtendedAddress', street1?: string | null, street2?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null, cobranding?: { __typename?: 'CaseCobranding', logo?: string | null, name?: string | null, companyCode?: string | null } | null, childCompany?: { __typename?: 'CaseCompany', id?: string | null, name?: string | null, logoUrl?: string | null, contact?: { __typename?: 'CaseCompanyContact', name?: string | null, email?: string | null, phone?: string | null } | null } | null, event?: { __typename?: 'CaseEvent', type?: CaseEventTypes | null, date?: Moment | null, termination?: { __typename?: 'CaseTermination', type?: TerminationTypes | null, reason?: string | null } | null, cobra?: { __typename?: 'CaseCobra', qualifyingEvent?: string | null, estimate?: number | null, currentContribution?: number | null } | null } | null, household?: Array<{ __typename?: 'CaseHouseholdMember', firstName?: string | null, lastName?: string | null, dateOfBirth?: Moment | null, relationship?: string | null } | null> | null, benefits?: Array<{ __typename?: 'CaseBenefit', type?: string | null, name?: string | null, carrier?: string | null, monthlyEmployeeContribution?: number | null, monthlyEmployerContribution?: number | null, benefitEndDate?: Moment | null, dependents?: Array<{ __typename?: 'CaseDependent', firstName?: string | null, lastName?: string | null, dateOfBirth?: Moment | null, relationship?: string | null } | null> | null } | null> | null, services?: Array<{ __typename?: 'CaseService', type?: string | null, whenBenefitAmount?: number | null } | null> | null, whenBenefit?: { __typename?: 'CaseWhenBenefit', status?: WhenBenefitSubstatusType | null, hasBenefit?: boolean | null, benefitTier?: string | null, amount?: number | null, releasedDate?: Moment | null, distributionType?: DistributionType | null, unusedFunds?: UnusedFundsType | null, monthsToAllocate?: number | null, detail?: { __typename?: 'CaseWhenBenefitDetail', total?: number | null, amountSpent?: number | null, amountPending?: number | null, amountRemaining?: number | null, amountForfeited?: number | null } | null } | null }> | null };

export type GetUserBankInfoQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetUserBankInfoQuery = { __typename?: 'Query', getUserBankInfo?: { __typename?: 'BankInfo', accountNumber?: string | null, routingNumber?: string | null, nameOnAccount?: string | null } | null };

export type ExitCodeInfoQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  exitCode: Scalars['String']['input'];
}>;


export type ExitCodeInfoQuery = { __typename?: 'Query', exitCodeInfo?: { __typename?: 'ExitCodeInfo', firstName: string, documents?: number | null, whenBenefit?: number | null, servicesEnabled?: Array<ServiceType> | null } | null };

export type MessagesQueryVariables = Exact<{ [key: string]: never; }>;


export type MessagesQuery = { __typename?: 'Query', messages: Array<{ __typename?: 'Message', id: string, text: string, user: boolean, timestamp: string }> };

export type AdminGetCaseQueryVariables = Exact<{
  caseId: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  reason?: InputMaybe<HipaaViewReasons>;
}>;


export type AdminGetCaseQuery = { __typename?: 'Query', adminGetCase?: { __typename?: 'CaseAccess', caseId?: string | null, companyId?: string | null, expiration?: string | null } | null };

export type AdminGetUserQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  reason?: InputMaybe<HipaaViewReasons>;
}>;


export type AdminGetUserQuery = { __typename?: 'Query', adminGetUser?: { __typename?: 'UserAccess', userId?: string | null, companyId?: string | null, expiration?: string | null } | null };

export type HrisQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type HrisQuery = { __typename?: 'Query', hris: { __typename?: 'HRISQueries', csvUpload: { __typename?: 'CSVUploadQueries', estimateImpact?: { __typename?: 'EstimateImpactResult', missing: number, new: number, total: number, existing: number } | null } } };

export type CaseEstimateImpactQueryVariables = Exact<{
  csvData: Array<BulkCaseCreateInput> | BulkCaseCreateInput;
}>;


export type CaseEstimateImpactQuery = { __typename?: 'Query', caseEstimateImpact: { __typename?: 'CaseImpactResult', employeesToBeCreated: number, employeesExists: number, casesToBeCreated: number, caseExistsNoUpdates: number, casesToBeUpdated: number } };

export type GetSearchTokenQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['String']['input']>;
  adminSearch?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetSearchTokenQuery = { __typename?: 'Query', getSearchToken?: string | null };

export type FetchDecryptedSsnQueryVariables = Exact<{
  applicationUserId: Scalars['String']['input'];
  applicationId: Scalars['ID']['input'];
  householdMemberId: Scalars['String']['input'];
}>;


export type FetchDecryptedSsnQuery = { __typename?: 'Query', fetchDecryptedSSN?: string | null };

export type GetApplicationNotesQueryVariables = Exact<{
  applicationUserId: Scalars['String']['input'];
  applicationId: Scalars['ID']['input'];
}>;


export type GetApplicationNotesQuery = { __typename?: 'Query', getApplicationNotes?: Array<{ __typename?: 'ApplicationNote', id: string, userName: string, date: string, note: string } | null> | null };

export type HrisConnectionDetailsQueryVariables = Exact<{
  connectionId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type HrisConnectionDetailsQuery = { __typename?: 'Query', hrisConnectionDetails?: { __typename?: 'HrisConnectionDetails', name?: string | null, logo?: string | null, squareLogo?: string | null, status?: string | null, lastImport?: string | null, createdOn?: string | null } | null };

export type ConfirmExitCodeIdentityQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  exitCode?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  birthDate: Scalars['String']['input'];
  zipCode?: InputMaybe<Scalars['String']['input']>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
  terminationDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConfirmExitCodeIdentityQuery = { __typename?: 'Query', confirmExitCodeIdentity?: boolean | null };

export type ReScorePlansQueryVariables = Exact<{
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReScorePlansQuery = { __typename?: 'Query', reScorePlans?: { __typename?: 'Total', total?: number | null } | null };

export type AiRecommendationQueryVariables = Exact<{
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AiRecommendationQuery = { __typename?: 'Query', aiRecommendation?: { __typename?: 'AiRecommendationResult', aiScore?: number | null, pros?: Array<string | null> | null, cons?: Array<string | null> | null, headline?: string | null, explanation?: string | null } | null };

export type GenerateEnrollmentUrlQueryVariables = Exact<{
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['String']['input']>;
  carrierId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GenerateEnrollmentUrlQuery = { __typename?: 'Query', generateEnrollmentUrl?: { __typename?: 'EnrollmentUrl', redirectUrl?: string | null } | null };

export type GetLinkTokenQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  emailAddress: Scalars['String']['input'];
  integrationMethodId: Scalars['String']['input'];
}>;


export type GetLinkTokenQuery = { __typename?: 'Query', hris: { __typename?: 'HRISQueries', merge: { __typename?: 'MergeQueries', getLinkToken?: { __typename?: 'LinkTokenResponse', token: string } | null } } };

export type GetRatesQueryVariables = Exact<{
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRatesQuery = { __typename?: 'Query', getRates?: { __typename?: 'Total', total?: number | null } | null };

export type SubsidyCheckQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type SubsidyCheckQuery = { __typename?: 'Query', subsidyCheck?: { __typename?: 'federalSubsidyAmount', federalSubsidyAmount?: number | null } | null };

export type GetCompanySettingsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type GetCompanySettingsQuery = { __typename?: 'Query', company?: { __typename?: 'Company', name: string, headquarterState?: string | null, planRenewalMonth?: string | null, activationDate?: string | null, terminationDate?: string | null, customerSuccessManager?: string | null, cobraAdministrationProvider?: string | null, emailDomain?: Array<string> | null, logo?: string | null, fein?: string | null, employeeCount?: number | null, externalCompanyIdentifier?: string | null, servicesEnabled?: Array<ServiceType> | null, whenBenefitUseOnCobra?: string | null, address?: { __typename?: 'ExtendedAddress', street1?: string | null, street2?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null, companyPointOfContact?: { __typename?: 'CompanyContact', name?: string | null, email?: string | null, phone?: string | null, title?: string | null } | null, automation?: { __typename?: 'CompanyAutomation', employerPlatformLessWorkflowEnable: boolean, numberOfDays: number, errorNotificationContactEmail: string } | null, timing?: { __typename?: 'CompanyTiming', betweenRequests?: { __typename?: 'TimingValue', value: number, measure: string } | null, firstRequest?: { __typename?: 'TimingValue', value: number, measure: string } | null } | null, monthlyWhenBenefitSettings?: { __typename?: 'CompanyMonthlyWhenBenefitSettings', unusedFunds?: UnusedFundsType | null, perMonthDeadline?: { __typename?: 'MonthlyBenefitTiming', dayOfMonth?: number | null, monthsAfter?: number | null } | null, monthlyBenefitInitialGracePeriod?: { __typename?: 'MonthlyBenefitTiming', dayOfMonth?: number | null, monthsAfter?: number | null } | null } | null } | null };

export type GetMixpanelDataQueryVariables = Exact<{
  events: Scalars['String']['input'];
  fromDate: Scalars['String']['input'];
  toDate: Scalars['String']['input'];
}>;


export type GetMixpanelDataQuery = { __typename?: 'Query', getMixpanelData?: { __typename?: 'MixpanelData', data?: { __typename?: 'MixpanelEventData', events: Array<{ __typename?: 'MixpanelEvent', event: string, values: Array<{ __typename?: 'MixpanelDateValue', date: string, value: number }> }> } | null } | null };

export type GetAllTimeReportQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllTimeReportQuery = { __typename?: 'Query', getAllTimeReport?: { __typename?: 'AllTimeReport', totalCases?: number | null, wbTotal?: number | null, wbRemaining?: number | null, wbSpent?: number | null, wbForfeited?: number | null, activeCases?: number | null, openCases?: number | null, closedCases?: number | null, closedInactiveCases?: number | null, closedResolvedCases?: number | null, cancelledResolvedCases?: number | null, activatedCases?: number | null, healthDecisionACA?: number | null, healthDecisionCobra?: number | null, healthDecisionUnknown?: number | null, healthDecisionOther?: number | null, HID_ACA_ON_EXCHANGE_EXTERNAL?: number | null, HID_ACA_ON_EXCHANGE_VELAPOINT?: number | null, HID_ACA_ON_EXCHANGE_WHEN?: number | null, HID_COBRA?: number | null, HID_DECLINE_TO_DISCLOSE?: number | null, HID_MEDICAID_EXTERNAL?: number | null, HID_MEDICARE_EXTERNAL?: number | null, HID_MEDICARE_VELAPOINT?: number | null, HID_MEDICARE_WHEN?: number | null, HID_NEW_EMPLOYMENT?: number | null, HID_OFF_EXCHANGE_EXTERNAL?: number | null, HID_OFF_EXCHANGE_VELAPOINT?: number | null, HID_OFF_EXCHANGE_WHEN?: number | null, HID_OTHER_EXTERNAL_COVERAGE?: number | null, HID_PARENTS?: number | null, HID_PENDING?: number | null, HID_SHORT_TERM_EXTERNAL?: number | null, HID_SHORT_TERM_VELAPOINT?: number | null, HID_SHORT_TERM_WHEN?: number | null, HID_SPOUSE?: number | null, HID_UNINSURED?: number | null, HID_UNKNOWN_CASE_CLOSED?: number | null } | null };

export type GetCaseStateByCreatedAtQueryVariables = Exact<{
  fromDate: Scalars['String']['input'];
  toDate: Scalars['String']['input'];
}>;


export type GetCaseStateByCreatedAtQuery = { __typename?: 'Query', getCaseStateByCreatedAt?: { __typename?: 'CaseStateByCreatedAtData', lastUpdated?: string | null, data?: Array<{ __typename?: 'CaseStateByCreatedAt', createdAt: string, totalCases?: number | null, totalCompanies?: number | null, companyIds?: Array<string | null> | null, wbTotal?: number | null, wbRemaining?: number | null, wbSpent?: number | null, wbForfeited?: number | null, activeCases?: number | null, openCases?: number | null, casesSharedOnTime?: number | null, klaviyoCasesShared?: number | null, zendeskCasesShared?: number | null, closedCases?: number | null, closedInactiveCases?: number | null, closedResolvedCases?: number | null, cancelledResolvedCases?: number | null, activatedCases?: number | null, healthDecisionACA?: number | null, healthDecisionCobra?: number | null, healthDecisionUnknown?: number | null, healthDecisionOther?: number | null } | null> | null } | null };

export type GetCobraAdminDetailsQueryVariables = Exact<{
  cobraAdminName: Scalars['String']['input'];
}>;


export type GetCobraAdminDetailsQuery = { __typename?: 'Query', getCobraAdminDetails?: { __typename?: 'CobraAdministrator', name: string, phone?: string | null, website?: string | null } | null };

export type ListUsersQueryVariables = Exact<{
  filters?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListUsersQuery = { __typename?: 'Query', listUsers?: { __typename?: 'UsersSearchResults', users?: Array<{ __typename?: 'User', uid?: string | null, email?: string | null, admin?: boolean | null } | null> | null } | null };

export type GeographyByZipQueryVariables = Exact<{
  zipcode?: InputMaybe<Scalars['String']['input']>;
}>;


export type GeographyByZipQuery = { __typename?: 'Query', geographyByZip?: Array<{ __typename?: 'Counties', zipcode?: string | null, name?: string | null, fips?: string | null, state?: string | null } | null> | null };

export type SearchPlansQueryQueryVariables = Exact<{
  filters?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchPlansQueryQuery = { __typename?: 'Query', searchPlans?: { __typename?: 'SearchResults', total?: number | null, plans?: Array<{ __typename?: 'PlanDetails', premium?: number | null, name?: string | null, provider?: string | null, id?: string | null, source?: string | null, type?: string | null, maxOutOfPocket?: number | null, deductible?: number | null, metal?: string | null, rating?: number | null, market?: string | null, diseasePrograms?: Array<string | null> | null, benefitUrl?: string | null, formularyUrl?: string | null, brochureUrl?: string | null, networkUrl?: string | null, benefits?: Array<{ __typename?: 'HealthBenefit', name?: string | null, covered?: boolean | null, inNetwork?: string | null, outOfNetwork?: string | null } | null> | null } | null> | null } | null };

export type ApproveMonthlyReimbursementMutationVariables = Exact<{
  requestId: Scalars['String']['input'];
  requestUserId: Scalars['String']['input'];
  requestBenefitId: Scalars['String']['input'];
  approvedAmount: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  status: Scalars['String']['input'];
  companyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ApproveMonthlyReimbursementMutation = { __typename?: 'Mutation', approveReimbursementRequest?: boolean | null };

export type DenyMonthlyReimbursementMutationVariables = Exact<{
  requestId: Scalars['String']['input'];
  requestUserId: Scalars['String']['input'];
  requestBenefitId: Scalars['String']['input'];
  denialReason: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  companyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DenyMonthlyReimbursementMutation = { __typename?: 'Mutation', denyReimbursementRequest?: boolean | null };

export type AdminCaseWhenBenefitsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  caseId: Scalars['String']['input'];
}>;


export type AdminCaseWhenBenefitsQuery = { __typename?: 'Query', case: { __typename?: 'Case', caseId: string, companyId: string, whenBenefit?: { __typename?: 'CaseWhenBenefit', status?: WhenBenefitSubstatusType | null, hasBenefit?: boolean | null, benefitTier?: string | null, amount?: number | null, releasedDate?: Moment | null, distributionType?: DistributionType | null, unusedFunds?: UnusedFundsType | null, monthsToAllocate?: number | null, useOnCobra?: boolean | null, detail?: { __typename?: 'CaseWhenBenefitDetail', total?: number | null, amountSpent?: number | null, amountPending?: number | null, amountRemaining?: number | null, amountForfeited?: number | null } | null, reimbursementRequests?: Array<{ __typename?: 'ReimbursementRequest', reimbursementRequestId: string, amount: number, status: ReimbursementRequestStatus, userId: string, approvedAmount?: number | null, approvedAt?: Moment | null, approvedBy?: string | null, deniedAt?: Moment | null, deniedBy?: string | null, coverageMonths: Array<string>, createdAt: Moment, updatedAt: Moment, notes?: string | null, files: Array<{ __typename?: 'ReimbursementFile', name: string, type: string, path: string }> }> | null, months?: Array<{ __typename?: 'CaseWhenBenefitMonth', month: string, amount?: number | null, deadline?: Moment | null, requested?: number | null, reimbursedAmount?: number | null, expired?: number | null, returned?: number | null }> | null, perMonthDeadline?: { __typename?: 'MonthlyBenefitTiming', dayOfMonth?: number | null, monthsAfter?: number | null } | null, monthlyBenefitInitialGracePeriod?: { __typename?: 'MonthlyBenefitTiming', dayOfMonth?: number | null, monthsAfter?: number | null } | null } | null } };

export type GetUserQueryVariables = Exact<{
  uid?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', uid?: string | null, email?: string | null, phoneNumber?: string | null, created?: Moment | null, lastLogin?: Moment | null, admin?: boolean | null, companies?: Array<string | null> | null, dateOfBirth?: string | null, gender?: string | null, acceptedPrivacyPolicy?: string | null, acceptedTermsOfService?: string | null, name?: { __typename?: 'UserName', first?: string | null, last?: string | null, display?: string | null, lowercase?: string | null } | null, address?: { __typename?: 'ExtendedAddress', street1?: string | null, street2?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, directDeposit?: { __typename?: 'DirectDeposit', last4?: string | null, accountType?: string | null, accountHolderName?: string | null } | null } | null };

export type GetMarketplaceServicesQueryVariables = Exact<{
  uid?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMarketplaceServicesQuery = { __typename?: 'Query', marketplaceServices?: Array<{ __typename?: 'MarketplaceService', id?: string | null, serviceName?: string | null, serviceCategory?: Array<string | null> | null, serviceProvider?: string | null, tileHeader?: string | null, tileBodyText?: string | null, CTAButton?: boolean | null, CTAButtonText?: string | null, CTAButtonURL?: string | null, redeemCode?: string | null, phoneButton?: boolean | null, phoneNumber?: string | null, fontColor?: string | null, tilesVisibility?: string | null, isActive?: boolean | null, createdAt?: Moment | null, headerPhoto?: { __typename?: 'ServicePhoto', name?: string | null, path?: string | null, type?: string | null } | null, logoFile?: { __typename?: 'ServicePhoto', name?: string | null, path?: string | null, type?: string | null } | null } | null> | null };

export type WhenBenefitsQueryVariables = Exact<{
  uid?: InputMaybe<Scalars['String']['input']>;
}>;


export type WhenBenefitsQuery = { __typename?: 'Query', whenBenefits?: Array<{ __typename?: 'WhenBenefitWithCaseInfo', caseId?: string | null, companyId?: string | null, benefit?: { __typename?: 'CaseWhenBenefit', status?: WhenBenefitSubstatusType | null, hasBenefit?: boolean | null, benefitTier?: string | null, amount?: number | null, releasedDate?: Moment | null, distributionType?: DistributionType | null, unusedFunds?: UnusedFundsType | null, monthsToAllocate?: number | null, detail?: { __typename?: 'CaseWhenBenefitDetail', total?: number | null, amountSpent?: number | null, amountPending?: number | null, amountRemaining?: number | null, amountForfeited?: number | null } | null, reimbursementRequests?: Array<{ __typename?: 'ReimbursementRequest', reimbursementRequestId: string, amount: number, status: ReimbursementRequestStatus, userId: string, approvedAmount?: number | null, coverageMonths: Array<string>, createdAt: Moment, updatedAt: Moment, files: Array<{ __typename?: 'ReimbursementFile', name: string, type: string, path: string }> }> | null, months?: Array<{ __typename?: 'CaseWhenBenefitMonth', month: string, amount?: number | null, deadline?: Moment | null, requested?: number | null, reimbursedAmount?: number | null, expired?: number | null, returned?: number | null }> | null, perMonthDeadline?: { __typename?: 'MonthlyBenefitTiming', dayOfMonth?: number | null, monthsAfter?: number | null } | null, monthlyBenefitInitialGracePeriod?: { __typename?: 'MonthlyBenefitTiming', dayOfMonth?: number | null, monthsAfter?: number | null } | null } | null } | null> | null };


export const CreateCompanyDocument = gql`
    mutation createCompany($companyInput: CompanyInput!) {
  createCompany(companyInput: $companyInput) {
    success
    company {
      code
    }
  }
}
    `;
export type CreateCompanyMutationFn = Apollo.MutationFunction<CreateCompanyMutation, CreateCompanyMutationVariables>;

/**
 * __useCreateCompanyMutation__
 *
 * To run a mutation, you first call `useCreateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyMutation, { data, loading, error }] = useCreateCompanyMutation({
 *   variables: {
 *      companyInput: // value for 'companyInput'
 *   },
 * });
 */
export function useCreateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyMutation, CreateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyMutation, CreateCompanyMutationVariables>(CreateCompanyDocument, options);
      }
export type CreateCompanyMutationHookResult = ReturnType<typeof useCreateCompanyMutation>;
export type CreateCompanyMutationResult = Apollo.MutationResult<CreateCompanyMutation>;
export type CreateCompanyMutationOptions = Apollo.BaseMutationOptions<CreateCompanyMutation, CreateCompanyMutationVariables>;
export const ShareCaseDocument = gql`
    mutation shareCase($companyId: String!, $caseId: String!, $shareDate: Date!) {
  shareCase(companyId: $companyId, caseId: $caseId, shareDate: $shareDate) {
    id
  }
}
    `;
export type ShareCaseMutationFn = Apollo.MutationFunction<ShareCaseMutation, ShareCaseMutationVariables>;

/**
 * __useShareCaseMutation__
 *
 * To run a mutation, you first call `useShareCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareCaseMutation, { data, loading, error }] = useShareCaseMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      caseId: // value for 'caseId'
 *      shareDate: // value for 'shareDate'
 *   },
 * });
 */
export function useShareCaseMutation(baseOptions?: Apollo.MutationHookOptions<ShareCaseMutation, ShareCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareCaseMutation, ShareCaseMutationVariables>(ShareCaseDocument, options);
      }
export type ShareCaseMutationHookResult = ReturnType<typeof useShareCaseMutation>;
export type ShareCaseMutationResult = Apollo.MutationResult<ShareCaseMutation>;
export type ShareCaseMutationOptions = Apollo.BaseMutationOptions<ShareCaseMutation, ShareCaseMutationVariables>;
export const AddCaseDocument = gql`
    mutation addCase($companyId: String!, $caseInput: CaseInput!) {
  addCase(companyId: $companyId, caseInput: $caseInput) {
    id
  }
}
    `;
export type AddCaseMutationFn = Apollo.MutationFunction<AddCaseMutation, AddCaseMutationVariables>;

/**
 * __useAddCaseMutation__
 *
 * To run a mutation, you first call `useAddCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCaseMutation, { data, loading, error }] = useAddCaseMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      caseInput: // value for 'caseInput'
 *   },
 * });
 */
export function useAddCaseMutation(baseOptions?: Apollo.MutationHookOptions<AddCaseMutation, AddCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCaseMutation, AddCaseMutationVariables>(AddCaseDocument, options);
      }
export type AddCaseMutationHookResult = ReturnType<typeof useAddCaseMutation>;
export type AddCaseMutationResult = Apollo.MutationResult<AddCaseMutation>;
export type AddCaseMutationOptions = Apollo.BaseMutationOptions<AddCaseMutation, AddCaseMutationVariables>;
export const UpdateCaseDocument = gql`
    mutation updateCase($companyId: String!, $caseId: String!, $caseInput: CaseUpdateInput!) {
  updateCase(companyId: $companyId, caseId: $caseId, caseInput: $caseInput) {
    id
  }
}
    `;
export type UpdateCaseMutationFn = Apollo.MutationFunction<UpdateCaseMutation, UpdateCaseMutationVariables>;

/**
 * __useUpdateCaseMutation__
 *
 * To run a mutation, you first call `useUpdateCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseMutation, { data, loading, error }] = useUpdateCaseMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      caseId: // value for 'caseId'
 *      caseInput: // value for 'caseInput'
 *   },
 * });
 */
export function useUpdateCaseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaseMutation, UpdateCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaseMutation, UpdateCaseMutationVariables>(UpdateCaseDocument, options);
      }
export type UpdateCaseMutationHookResult = ReturnType<typeof useUpdateCaseMutation>;
export type UpdateCaseMutationResult = Apollo.MutationResult<UpdateCaseMutation>;
export type UpdateCaseMutationOptions = Apollo.BaseMutationOptions<UpdateCaseMutation, UpdateCaseMutationVariables>;
export const UpdateCaseHealthInsuranceDecisionDocument = gql`
    mutation updateCaseHealthInsuranceDecision($companyId: String!, $caseId: String!, $healthInsuranceDecision: HealthInsuranceDecisionType!, $cobraElectionReason: CobraElectionReasonType) {
  updateCaseHealthInsuranceDecision(
    companyId: $companyId
    caseId: $caseId
    healthInsuranceDecision: $healthInsuranceDecision
    cobraElectionReason: $cobraElectionReason
  ) {
    id
  }
}
    `;
export type UpdateCaseHealthInsuranceDecisionMutationFn = Apollo.MutationFunction<UpdateCaseHealthInsuranceDecisionMutation, UpdateCaseHealthInsuranceDecisionMutationVariables>;

/**
 * __useUpdateCaseHealthInsuranceDecisionMutation__
 *
 * To run a mutation, you first call `useUpdateCaseHealthInsuranceDecisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseHealthInsuranceDecisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseHealthInsuranceDecisionMutation, { data, loading, error }] = useUpdateCaseHealthInsuranceDecisionMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      caseId: // value for 'caseId'
 *      healthInsuranceDecision: // value for 'healthInsuranceDecision'
 *      cobraElectionReason: // value for 'cobraElectionReason'
 *   },
 * });
 */
export function useUpdateCaseHealthInsuranceDecisionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaseHealthInsuranceDecisionMutation, UpdateCaseHealthInsuranceDecisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaseHealthInsuranceDecisionMutation, UpdateCaseHealthInsuranceDecisionMutationVariables>(UpdateCaseHealthInsuranceDecisionDocument, options);
      }
export type UpdateCaseHealthInsuranceDecisionMutationHookResult = ReturnType<typeof useUpdateCaseHealthInsuranceDecisionMutation>;
export type UpdateCaseHealthInsuranceDecisionMutationResult = Apollo.MutationResult<UpdateCaseHealthInsuranceDecisionMutation>;
export type UpdateCaseHealthInsuranceDecisionMutationOptions = Apollo.BaseMutationOptions<UpdateCaseHealthInsuranceDecisionMutation, UpdateCaseHealthInsuranceDecisionMutationVariables>;
export const ConnectSimpleHrisDocument = gql`
    mutation connectSimpleHris($companyId: String!, $connectionMethod: String!, $connectionDetails: String!) {
  connectSimpleHris(
    companyId: $companyId
    connectionMethod: $connectionMethod
    connectionDetails: $connectionDetails
  )
}
    `;
export type ConnectSimpleHrisMutationFn = Apollo.MutationFunction<ConnectSimpleHrisMutation, ConnectSimpleHrisMutationVariables>;

/**
 * __useConnectSimpleHrisMutation__
 *
 * To run a mutation, you first call `useConnectSimpleHrisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectSimpleHrisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectSimpleHrisMutation, { data, loading, error }] = useConnectSimpleHrisMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      connectionMethod: // value for 'connectionMethod'
 *      connectionDetails: // value for 'connectionDetails'
 *   },
 * });
 */
export function useConnectSimpleHrisMutation(baseOptions?: Apollo.MutationHookOptions<ConnectSimpleHrisMutation, ConnectSimpleHrisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectSimpleHrisMutation, ConnectSimpleHrisMutationVariables>(ConnectSimpleHrisDocument, options);
      }
export type ConnectSimpleHrisMutationHookResult = ReturnType<typeof useConnectSimpleHrisMutation>;
export type ConnectSimpleHrisMutationResult = Apollo.MutationResult<ConnectSimpleHrisMutation>;
export type ConnectSimpleHrisMutationOptions = Apollo.BaseMutationOptions<ConnectSimpleHrisMutation, ConnectSimpleHrisMutationVariables>;
export const TriggerPipelineDocument = gql`
    mutation triggerPipeline($type: String!, $parameters: String) {
  triggerPipeline(type: $type, parameters: $parameters)
}
    `;
export type TriggerPipelineMutationFn = Apollo.MutationFunction<TriggerPipelineMutation, TriggerPipelineMutationVariables>;

/**
 * __useTriggerPipelineMutation__
 *
 * To run a mutation, you first call `useTriggerPipelineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerPipelineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerPipelineMutation, { data, loading, error }] = useTriggerPipelineMutation({
 *   variables: {
 *      type: // value for 'type'
 *      parameters: // value for 'parameters'
 *   },
 * });
 */
export function useTriggerPipelineMutation(baseOptions?: Apollo.MutationHookOptions<TriggerPipelineMutation, TriggerPipelineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerPipelineMutation, TriggerPipelineMutationVariables>(TriggerPipelineDocument, options);
      }
export type TriggerPipelineMutationHookResult = ReturnType<typeof useTriggerPipelineMutation>;
export type TriggerPipelineMutationResult = Apollo.MutationResult<TriggerPipelineMutation>;
export type TriggerPipelineMutationOptions = Apollo.BaseMutationOptions<TriggerPipelineMutation, TriggerPipelineMutationVariables>;
export const SendMessageDocument = gql`
    mutation sendMessage($message: String!) {
  sendMessage(message: $message)
}
    `;
export type SendMessageMutationFn = Apollo.MutationFunction<SendMessageMutation, SendMessageMutationVariables>;

/**
 * __useSendMessageMutation__
 *
 * To run a mutation, you first call `useSendMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageMutation, { data, loading, error }] = useSendMessageMutation({
 *   variables: {
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSendMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendMessageMutation, SendMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMessageMutation, SendMessageMutationVariables>(SendMessageDocument, options);
      }
export type SendMessageMutationHookResult = ReturnType<typeof useSendMessageMutation>;
export type SendMessageMutationResult = Apollo.MutationResult<SendMessageMutation>;
export type SendMessageMutationOptions = Apollo.BaseMutationOptions<SendMessageMutation, SendMessageMutationVariables>;
export const CancelMessageDocument = gql`
    mutation cancelMessage {
  cancelMessage
}
    `;
export type CancelMessageMutationFn = Apollo.MutationFunction<CancelMessageMutation, CancelMessageMutationVariables>;

/**
 * __useCancelMessageMutation__
 *
 * To run a mutation, you first call `useCancelMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelMessageMutation, { data, loading, error }] = useCancelMessageMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelMessageMutation(baseOptions?: Apollo.MutationHookOptions<CancelMessageMutation, CancelMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelMessageMutation, CancelMessageMutationVariables>(CancelMessageDocument, options);
      }
export type CancelMessageMutationHookResult = ReturnType<typeof useCancelMessageMutation>;
export type CancelMessageMutationResult = Apollo.MutationResult<CancelMessageMutation>;
export type CancelMessageMutationOptions = Apollo.BaseMutationOptions<CancelMessageMutation, CancelMessageMutationVariables>;
export const ClearMessagesDocument = gql`
    mutation clearMessages {
  clearMessages
}
    `;
export type ClearMessagesMutationFn = Apollo.MutationFunction<ClearMessagesMutation, ClearMessagesMutationVariables>;

/**
 * __useClearMessagesMutation__
 *
 * To run a mutation, you first call `useClearMessagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearMessagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearMessagesMutation, { data, loading, error }] = useClearMessagesMutation({
 *   variables: {
 *   },
 * });
 */
export function useClearMessagesMutation(baseOptions?: Apollo.MutationHookOptions<ClearMessagesMutation, ClearMessagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearMessagesMutation, ClearMessagesMutationVariables>(ClearMessagesDocument, options);
      }
export type ClearMessagesMutationHookResult = ReturnType<typeof useClearMessagesMutation>;
export type ClearMessagesMutationResult = Apollo.MutationResult<ClearMessagesMutation>;
export type ClearMessagesMutationOptions = Apollo.BaseMutationOptions<ClearMessagesMutation, ClearMessagesMutationVariables>;
export const SetHouseholdDocument = gql`
    mutation setHousehold($uid: String, $members: [HouseholdMemberInput]) {
  setHousehold(uid: $uid, members: $members)
}
    `;
export type SetHouseholdMutationFn = Apollo.MutationFunction<SetHouseholdMutation, SetHouseholdMutationVariables>;

/**
 * __useSetHouseholdMutation__
 *
 * To run a mutation, you first call `useSetHouseholdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetHouseholdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setHouseholdMutation, { data, loading, error }] = useSetHouseholdMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      members: // value for 'members'
 *   },
 * });
 */
export function useSetHouseholdMutation(baseOptions?: Apollo.MutationHookOptions<SetHouseholdMutation, SetHouseholdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetHouseholdMutation, SetHouseholdMutationVariables>(SetHouseholdDocument, options);
      }
export type SetHouseholdMutationHookResult = ReturnType<typeof useSetHouseholdMutation>;
export type SetHouseholdMutationResult = Apollo.MutationResult<SetHouseholdMutation>;
export type SetHouseholdMutationOptions = Apollo.BaseMutationOptions<SetHouseholdMutation, SetHouseholdMutationVariables>;
export const SetInsuranceDetailsDocument = gql`
    mutation setInsuranceDetails($uid: String, $details: InsuranceDetailsInput) {
  setInsuranceDetails(uid: $uid, details: $details)
}
    `;
export type SetInsuranceDetailsMutationFn = Apollo.MutationFunction<SetInsuranceDetailsMutation, SetInsuranceDetailsMutationVariables>;

/**
 * __useSetInsuranceDetailsMutation__
 *
 * To run a mutation, you first call `useSetInsuranceDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetInsuranceDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setInsuranceDetailsMutation, { data, loading, error }] = useSetInsuranceDetailsMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      details: // value for 'details'
 *   },
 * });
 */
export function useSetInsuranceDetailsMutation(baseOptions?: Apollo.MutationHookOptions<SetInsuranceDetailsMutation, SetInsuranceDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetInsuranceDetailsMutation, SetInsuranceDetailsMutationVariables>(SetInsuranceDetailsDocument, options);
      }
export type SetInsuranceDetailsMutationHookResult = ReturnType<typeof useSetInsuranceDetailsMutation>;
export type SetInsuranceDetailsMutationResult = Apollo.MutationResult<SetInsuranceDetailsMutation>;
export type SetInsuranceDetailsMutationOptions = Apollo.BaseMutationOptions<SetInsuranceDetailsMutation, SetInsuranceDetailsMutationVariables>;
export const BeginJamieChatDocument = gql`
    mutation beginJamieChat($userId: String!) {
  beginJamieChat(userId: $userId)
}
    `;
export type BeginJamieChatMutationFn = Apollo.MutationFunction<BeginJamieChatMutation, BeginJamieChatMutationVariables>;

/**
 * __useBeginJamieChatMutation__
 *
 * To run a mutation, you first call `useBeginJamieChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBeginJamieChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [beginJamieChatMutation, { data, loading, error }] = useBeginJamieChatMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useBeginJamieChatMutation(baseOptions?: Apollo.MutationHookOptions<BeginJamieChatMutation, BeginJamieChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BeginJamieChatMutation, BeginJamieChatMutationVariables>(BeginJamieChatDocument, options);
      }
export type BeginJamieChatMutationHookResult = ReturnType<typeof useBeginJamieChatMutation>;
export type BeginJamieChatMutationResult = Apollo.MutationResult<BeginJamieChatMutation>;
export type BeginJamieChatMutationOptions = Apollo.BaseMutationOptions<BeginJamieChatMutation, BeginJamieChatMutationVariables>;
export const CreateApplicationDocument = gql`
    mutation createApplication($planId: ID!, $userId: ID!) {
  createApplication(planId: $planId, userId: $userId) {
    applicationId
    success
    message
  }
}
    `;
export type CreateApplicationMutationFn = Apollo.MutationFunction<CreateApplicationMutation, CreateApplicationMutationVariables>;

/**
 * __useCreateApplicationMutation__
 *
 * To run a mutation, you first call `useCreateApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApplicationMutation, { data, loading, error }] = useCreateApplicationMutation({
 *   variables: {
 *      planId: // value for 'planId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCreateApplicationMutation(baseOptions?: Apollo.MutationHookOptions<CreateApplicationMutation, CreateApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApplicationMutation, CreateApplicationMutationVariables>(CreateApplicationDocument, options);
      }
export type CreateApplicationMutationHookResult = ReturnType<typeof useCreateApplicationMutation>;
export type CreateApplicationMutationResult = Apollo.MutationResult<CreateApplicationMutation>;
export type CreateApplicationMutationOptions = Apollo.BaseMutationOptions<CreateApplicationMutation, CreateApplicationMutationVariables>;
export const AdminCreateApplicationDocument = gql`
    mutation adminCreateApplication($applicantUserId: String!, $applicationPlanData: ApplicationPlanDataInput!) {
  adminCreateApplication(
    applicantUserId: $applicantUserId
    applicationPlanData: $applicationPlanData
  ) {
    applicationId
    success
    message
  }
}
    `;
export type AdminCreateApplicationMutationFn = Apollo.MutationFunction<AdminCreateApplicationMutation, AdminCreateApplicationMutationVariables>;

/**
 * __useAdminCreateApplicationMutation__
 *
 * To run a mutation, you first call `useAdminCreateApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateApplicationMutation, { data, loading, error }] = useAdminCreateApplicationMutation({
 *   variables: {
 *      applicantUserId: // value for 'applicantUserId'
 *      applicationPlanData: // value for 'applicationPlanData'
 *   },
 * });
 */
export function useAdminCreateApplicationMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateApplicationMutation, AdminCreateApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateApplicationMutation, AdminCreateApplicationMutationVariables>(AdminCreateApplicationDocument, options);
      }
export type AdminCreateApplicationMutationHookResult = ReturnType<typeof useAdminCreateApplicationMutation>;
export type AdminCreateApplicationMutationResult = Apollo.MutationResult<AdminCreateApplicationMutation>;
export type AdminCreateApplicationMutationOptions = Apollo.BaseMutationOptions<AdminCreateApplicationMutation, AdminCreateApplicationMutationVariables>;
export const SubmitApplicationDocument = gql`
    mutation submitApplication($uid: String, $applicationId: String) {
  submitApplication(uid: $uid, applicationId: $applicationId)
}
    `;
export type SubmitApplicationMutationFn = Apollo.MutationFunction<SubmitApplicationMutation, SubmitApplicationMutationVariables>;

/**
 * __useSubmitApplicationMutation__
 *
 * To run a mutation, you first call `useSubmitApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitApplicationMutation, { data, loading, error }] = useSubmitApplicationMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useSubmitApplicationMutation(baseOptions?: Apollo.MutationHookOptions<SubmitApplicationMutation, SubmitApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitApplicationMutation, SubmitApplicationMutationVariables>(SubmitApplicationDocument, options);
      }
export type SubmitApplicationMutationHookResult = ReturnType<typeof useSubmitApplicationMutation>;
export type SubmitApplicationMutationResult = Apollo.MutationResult<SubmitApplicationMutation>;
export type SubmitApplicationMutationOptions = Apollo.BaseMutationOptions<SubmitApplicationMutation, SubmitApplicationMutationVariables>;
export const SaveApplicationSsnDocument = gql`
    mutation saveApplicationSSN($uid: String!, $applicationId: ID!, $ssn: String!, $householdMemberId: String!) {
  saveApplicationSSN(
    uid: $uid
    applicationId: $applicationId
    ssn: $ssn
    householdMemberId: $householdMemberId
  )
}
    `;
export type SaveApplicationSsnMutationFn = Apollo.MutationFunction<SaveApplicationSsnMutation, SaveApplicationSsnMutationVariables>;

/**
 * __useSaveApplicationSsnMutation__
 *
 * To run a mutation, you first call `useSaveApplicationSsnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveApplicationSsnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveApplicationSsnMutation, { data, loading, error }] = useSaveApplicationSsnMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      applicationId: // value for 'applicationId'
 *      ssn: // value for 'ssn'
 *      householdMemberId: // value for 'householdMemberId'
 *   },
 * });
 */
export function useSaveApplicationSsnMutation(baseOptions?: Apollo.MutationHookOptions<SaveApplicationSsnMutation, SaveApplicationSsnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveApplicationSsnMutation, SaveApplicationSsnMutationVariables>(SaveApplicationSsnDocument, options);
      }
export type SaveApplicationSsnMutationHookResult = ReturnType<typeof useSaveApplicationSsnMutation>;
export type SaveApplicationSsnMutationResult = Apollo.MutationResult<SaveApplicationSsnMutation>;
export type SaveApplicationSsnMutationOptions = Apollo.BaseMutationOptions<SaveApplicationSsnMutation, SaveApplicationSsnMutationVariables>;
export const AddApplicationNoteDocument = gql`
    mutation addApplicationNote($applicationId: ID!, $applicationUserId: String!, $note: ApplicationNoteInput!) {
  addApplicationNote(
    applicationId: $applicationId
    applicationUserId: $applicationUserId
    note: $note
  )
}
    `;
export type AddApplicationNoteMutationFn = Apollo.MutationFunction<AddApplicationNoteMutation, AddApplicationNoteMutationVariables>;

/**
 * __useAddApplicationNoteMutation__
 *
 * To run a mutation, you first call `useAddApplicationNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddApplicationNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addApplicationNoteMutation, { data, loading, error }] = useAddApplicationNoteMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      applicationUserId: // value for 'applicationUserId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useAddApplicationNoteMutation(baseOptions?: Apollo.MutationHookOptions<AddApplicationNoteMutation, AddApplicationNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddApplicationNoteMutation, AddApplicationNoteMutationVariables>(AddApplicationNoteDocument, options);
      }
export type AddApplicationNoteMutationHookResult = ReturnType<typeof useAddApplicationNoteMutation>;
export type AddApplicationNoteMutationResult = Apollo.MutationResult<AddApplicationNoteMutation>;
export type AddApplicationNoteMutationOptions = Apollo.BaseMutationOptions<AddApplicationNoteMutation, AddApplicationNoteMutationVariables>;
export const UpdateApplicationAlgoliaRecordDocument = gql`
    mutation updateApplicationAlgoliaRecord($uid: String!, $applicationId: ID!, $applicationData: ApplicationUpdateInput!) {
  updateApplicationAlgoliaRecord(
    uid: $uid
    applicationId: $applicationId
    applicationData: $applicationData
  ) {
    success
    errorMessage
  }
}
    `;
export type UpdateApplicationAlgoliaRecordMutationFn = Apollo.MutationFunction<UpdateApplicationAlgoliaRecordMutation, UpdateApplicationAlgoliaRecordMutationVariables>;

/**
 * __useUpdateApplicationAlgoliaRecordMutation__
 *
 * To run a mutation, you first call `useUpdateApplicationAlgoliaRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApplicationAlgoliaRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApplicationAlgoliaRecordMutation, { data, loading, error }] = useUpdateApplicationAlgoliaRecordMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      applicationId: // value for 'applicationId'
 *      applicationData: // value for 'applicationData'
 *   },
 * });
 */
export function useUpdateApplicationAlgoliaRecordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApplicationAlgoliaRecordMutation, UpdateApplicationAlgoliaRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApplicationAlgoliaRecordMutation, UpdateApplicationAlgoliaRecordMutationVariables>(UpdateApplicationAlgoliaRecordDocument, options);
      }
export type UpdateApplicationAlgoliaRecordMutationHookResult = ReturnType<typeof useUpdateApplicationAlgoliaRecordMutation>;
export type UpdateApplicationAlgoliaRecordMutationResult = Apollo.MutationResult<UpdateApplicationAlgoliaRecordMutation>;
export type UpdateApplicationAlgoliaRecordMutationOptions = Apollo.BaseMutationOptions<UpdateApplicationAlgoliaRecordMutation, UpdateApplicationAlgoliaRecordMutationVariables>;
export const SendProcessedApplicationEmailDocument = gql`
    mutation sendProcessedApplicationEmail($applicantUserId: String!) {
  sendProcessedApplicationEmail(applicantUserId: $applicantUserId) {
    success
    message
    error
  }
}
    `;
export type SendProcessedApplicationEmailMutationFn = Apollo.MutationFunction<SendProcessedApplicationEmailMutation, SendProcessedApplicationEmailMutationVariables>;

/**
 * __useSendProcessedApplicationEmailMutation__
 *
 * To run a mutation, you first call `useSendProcessedApplicationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendProcessedApplicationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendProcessedApplicationEmailMutation, { data, loading, error }] = useSendProcessedApplicationEmailMutation({
 *   variables: {
 *      applicantUserId: // value for 'applicantUserId'
 *   },
 * });
 */
export function useSendProcessedApplicationEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendProcessedApplicationEmailMutation, SendProcessedApplicationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendProcessedApplicationEmailMutation, SendProcessedApplicationEmailMutationVariables>(SendProcessedApplicationEmailDocument, options);
      }
export type SendProcessedApplicationEmailMutationHookResult = ReturnType<typeof useSendProcessedApplicationEmailMutation>;
export type SendProcessedApplicationEmailMutationResult = Apollo.MutationResult<SendProcessedApplicationEmailMutation>;
export type SendProcessedApplicationEmailMutationOptions = Apollo.BaseMutationOptions<SendProcessedApplicationEmailMutation, SendProcessedApplicationEmailMutationVariables>;
export const SetPreferencesDocument = gql`
    mutation setPreferences($uid: String, $preferences: PreferencesInput) {
  setPreferences(uid: $uid, preferences: $preferences)
}
    `;
export type SetPreferencesMutationFn = Apollo.MutationFunction<SetPreferencesMutation, SetPreferencesMutationVariables>;

/**
 * __useSetPreferencesMutation__
 *
 * To run a mutation, you first call `useSetPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPreferencesMutation, { data, loading, error }] = useSetPreferencesMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      preferences: // value for 'preferences'
 *   },
 * });
 */
export function useSetPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<SetPreferencesMutation, SetPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPreferencesMutation, SetPreferencesMutationVariables>(SetPreferencesDocument, options);
      }
export type SetPreferencesMutationHookResult = ReturnType<typeof useSetPreferencesMutation>;
export type SetPreferencesMutationResult = Apollo.MutationResult<SetPreferencesMutation>;
export type SetPreferencesMutationOptions = Apollo.BaseMutationOptions<SetPreferencesMutation, SetPreferencesMutationVariables>;
export const SubmitReimbursementRequestDocument = gql`
    mutation submitReimbursementRequest($userId: String!, $whenBenefitId: String!, $files: [ReimbursementFileInput!]!, $amount: Float!, $months: [String!]!, $companyId: String, $caseId: String, $coverageStartDate: String, $coverageEndDate: String) {
  submitReimbursementRequest(
    userId: $userId
    whenBenefitId: $whenBenefitId
    files: $files
    amount: $amount
    months: $months
    companyId: $companyId
    caseId: $caseId
    coverageStartDate: $coverageStartDate
    coverageEndDate: $coverageEndDate
  )
}
    `;
export type SubmitReimbursementRequestMutationFn = Apollo.MutationFunction<SubmitReimbursementRequestMutation, SubmitReimbursementRequestMutationVariables>;

/**
 * __useSubmitReimbursementRequestMutation__
 *
 * To run a mutation, you first call `useSubmitReimbursementRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitReimbursementRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitReimbursementRequestMutation, { data, loading, error }] = useSubmitReimbursementRequestMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      whenBenefitId: // value for 'whenBenefitId'
 *      files: // value for 'files'
 *      amount: // value for 'amount'
 *      months: // value for 'months'
 *      companyId: // value for 'companyId'
 *      caseId: // value for 'caseId'
 *      coverageStartDate: // value for 'coverageStartDate'
 *      coverageEndDate: // value for 'coverageEndDate'
 *   },
 * });
 */
export function useSubmitReimbursementRequestMutation(baseOptions?: Apollo.MutationHookOptions<SubmitReimbursementRequestMutation, SubmitReimbursementRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitReimbursementRequestMutation, SubmitReimbursementRequestMutationVariables>(SubmitReimbursementRequestDocument, options);
      }
export type SubmitReimbursementRequestMutationHookResult = ReturnType<typeof useSubmitReimbursementRequestMutation>;
export type SubmitReimbursementRequestMutationResult = Apollo.MutationResult<SubmitReimbursementRequestMutation>;
export type SubmitReimbursementRequestMutationOptions = Apollo.BaseMutationOptions<SubmitReimbursementRequestMutation, SubmitReimbursementRequestMutationVariables>;
export const CancelReimbursementRequestDocument = gql`
    mutation cancelReimbursementRequest($userId: String!, $id: String!, $whenBenefitId: String!) {
  cancelReimbursementRequest(
    userId: $userId
    id: $id
    whenBenefitId: $whenBenefitId
  )
}
    `;
export type CancelReimbursementRequestMutationFn = Apollo.MutationFunction<CancelReimbursementRequestMutation, CancelReimbursementRequestMutationVariables>;

/**
 * __useCancelReimbursementRequestMutation__
 *
 * To run a mutation, you first call `useCancelReimbursementRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelReimbursementRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelReimbursementRequestMutation, { data, loading, error }] = useCancelReimbursementRequestMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      id: // value for 'id'
 *      whenBenefitId: // value for 'whenBenefitId'
 *   },
 * });
 */
export function useCancelReimbursementRequestMutation(baseOptions?: Apollo.MutationHookOptions<CancelReimbursementRequestMutation, CancelReimbursementRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelReimbursementRequestMutation, CancelReimbursementRequestMutationVariables>(CancelReimbursementRequestDocument, options);
      }
export type CancelReimbursementRequestMutationHookResult = ReturnType<typeof useCancelReimbursementRequestMutation>;
export type CancelReimbursementRequestMutationResult = Apollo.MutationResult<CancelReimbursementRequestMutation>;
export type CancelReimbursementRequestMutationOptions = Apollo.BaseMutationOptions<CancelReimbursementRequestMutation, CancelReimbursementRequestMutationVariables>;
export const ApproveReimbursementRequestDocument = gql`
    mutation approveReimbursementRequest($requestId: String!, $requestUserId: String!, $requestBenefitId: String!, $approvedAmount: String!, $notes: String!, $status: String!) {
  approveReimbursementRequest(
    requestId: $requestId
    requestUserId: $requestUserId
    requestBenefitId: $requestBenefitId
    approvedAmount: $approvedAmount
    notes: $notes
    status: $status
  )
}
    `;
export type ApproveReimbursementRequestMutationFn = Apollo.MutationFunction<ApproveReimbursementRequestMutation, ApproveReimbursementRequestMutationVariables>;

/**
 * __useApproveReimbursementRequestMutation__
 *
 * To run a mutation, you first call `useApproveReimbursementRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveReimbursementRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveReimbursementRequestMutation, { data, loading, error }] = useApproveReimbursementRequestMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      requestUserId: // value for 'requestUserId'
 *      requestBenefitId: // value for 'requestBenefitId'
 *      approvedAmount: // value for 'approvedAmount'
 *      notes: // value for 'notes'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useApproveReimbursementRequestMutation(baseOptions?: Apollo.MutationHookOptions<ApproveReimbursementRequestMutation, ApproveReimbursementRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveReimbursementRequestMutation, ApproveReimbursementRequestMutationVariables>(ApproveReimbursementRequestDocument, options);
      }
export type ApproveReimbursementRequestMutationHookResult = ReturnType<typeof useApproveReimbursementRequestMutation>;
export type ApproveReimbursementRequestMutationResult = Apollo.MutationResult<ApproveReimbursementRequestMutation>;
export type ApproveReimbursementRequestMutationOptions = Apollo.BaseMutationOptions<ApproveReimbursementRequestMutation, ApproveReimbursementRequestMutationVariables>;
export const DenyReimbursementRequestDocument = gql`
    mutation denyReimbursementRequest($requestUserId: String!, $requestId: String!, $requestBenefitId: String!, $denialReason: String!, $notes: String) {
  denyReimbursementRequest(
    requestId: $requestId
    requestUserId: $requestUserId
    requestBenefitId: $requestBenefitId
    denialReason: $denialReason
    notes: $notes
  )
}
    `;
export type DenyReimbursementRequestMutationFn = Apollo.MutationFunction<DenyReimbursementRequestMutation, DenyReimbursementRequestMutationVariables>;

/**
 * __useDenyReimbursementRequestMutation__
 *
 * To run a mutation, you first call `useDenyReimbursementRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDenyReimbursementRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [denyReimbursementRequestMutation, { data, loading, error }] = useDenyReimbursementRequestMutation({
 *   variables: {
 *      requestUserId: // value for 'requestUserId'
 *      requestId: // value for 'requestId'
 *      requestBenefitId: // value for 'requestBenefitId'
 *      denialReason: // value for 'denialReason'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useDenyReimbursementRequestMutation(baseOptions?: Apollo.MutationHookOptions<DenyReimbursementRequestMutation, DenyReimbursementRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DenyReimbursementRequestMutation, DenyReimbursementRequestMutationVariables>(DenyReimbursementRequestDocument, options);
      }
export type DenyReimbursementRequestMutationHookResult = ReturnType<typeof useDenyReimbursementRequestMutation>;
export type DenyReimbursementRequestMutationResult = Apollo.MutationResult<DenyReimbursementRequestMutation>;
export type DenyReimbursementRequestMutationOptions = Apollo.BaseMutationOptions<DenyReimbursementRequestMutation, DenyReimbursementRequestMutationVariables>;
export const AdditionalInfoRequestDocument = gql`
    mutation additionalInfoRequest($requestUserId: String!, $requestId: String!, $requestBenefitId: String!, $msg: String, $status: String!) {
  additionalInfoRequest(
    requestId: $requestId
    requestUserId: $requestUserId
    requestBenefitId: $requestBenefitId
    msg: $msg
    status: $status
  )
}
    `;
export type AdditionalInfoRequestMutationFn = Apollo.MutationFunction<AdditionalInfoRequestMutation, AdditionalInfoRequestMutationVariables>;

/**
 * __useAdditionalInfoRequestMutation__
 *
 * To run a mutation, you first call `useAdditionalInfoRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdditionalInfoRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [additionalInfoRequestMutation, { data, loading, error }] = useAdditionalInfoRequestMutation({
 *   variables: {
 *      requestUserId: // value for 'requestUserId'
 *      requestId: // value for 'requestId'
 *      requestBenefitId: // value for 'requestBenefitId'
 *      msg: // value for 'msg'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useAdditionalInfoRequestMutation(baseOptions?: Apollo.MutationHookOptions<AdditionalInfoRequestMutation, AdditionalInfoRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdditionalInfoRequestMutation, AdditionalInfoRequestMutationVariables>(AdditionalInfoRequestDocument, options);
      }
export type AdditionalInfoRequestMutationHookResult = ReturnType<typeof useAdditionalInfoRequestMutation>;
export type AdditionalInfoRequestMutationResult = Apollo.MutationResult<AdditionalInfoRequestMutation>;
export type AdditionalInfoRequestMutationOptions = Apollo.BaseMutationOptions<AdditionalInfoRequestMutation, AdditionalInfoRequestMutationVariables>;
export const SyncDataForExitCodeDocument = gql`
    mutation syncDataForExitCode($companyId: String!, $exitCode: String!, $birthDate: String!, $lastName: String!, $zipCode: String!, $isAdmin: Boolean, $userUid: String) {
  syncDataForExitCode(
    companyId: $companyId
    exitCode: $exitCode
    birthDate: $birthDate
    lastName: $lastName
    zipCode: $zipCode
    isAdmin: $isAdmin
    userUid: $userUid
  )
}
    `;
export type SyncDataForExitCodeMutationFn = Apollo.MutationFunction<SyncDataForExitCodeMutation, SyncDataForExitCodeMutationVariables>;

/**
 * __useSyncDataForExitCodeMutation__
 *
 * To run a mutation, you first call `useSyncDataForExitCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncDataForExitCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncDataForExitCodeMutation, { data, loading, error }] = useSyncDataForExitCodeMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      exitCode: // value for 'exitCode'
 *      birthDate: // value for 'birthDate'
 *      lastName: // value for 'lastName'
 *      zipCode: // value for 'zipCode'
 *      isAdmin: // value for 'isAdmin'
 *      userUid: // value for 'userUid'
 *   },
 * });
 */
export function useSyncDataForExitCodeMutation(baseOptions?: Apollo.MutationHookOptions<SyncDataForExitCodeMutation, SyncDataForExitCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncDataForExitCodeMutation, SyncDataForExitCodeMutationVariables>(SyncDataForExitCodeDocument, options);
      }
export type SyncDataForExitCodeMutationHookResult = ReturnType<typeof useSyncDataForExitCodeMutation>;
export type SyncDataForExitCodeMutationResult = Apollo.MutationResult<SyncDataForExitCodeMutation>;
export type SyncDataForExitCodeMutationOptions = Apollo.BaseMutationOptions<SyncDataForExitCodeMutation, SyncDataForExitCodeMutationVariables>;
export const ContactUsDocument = gql`
    mutation ContactUs($name: String, $email: String, $phone: String, $subject: String, $description: String) {
  contactUs(
    name: $name
    email: $email
    phone: $phone
    subject: $subject
    description: $description
  )
}
    `;
export type ContactUsMutationFn = Apollo.MutationFunction<ContactUsMutation, ContactUsMutationVariables>;

/**
 * __useContactUsMutation__
 *
 * To run a mutation, you first call `useContactUsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactUsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactUsMutation, { data, loading, error }] = useContactUsMutation({
 *   variables: {
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      subject: // value for 'subject'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useContactUsMutation(baseOptions?: Apollo.MutationHookOptions<ContactUsMutation, ContactUsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactUsMutation, ContactUsMutationVariables>(ContactUsDocument, options);
      }
export type ContactUsMutationHookResult = ReturnType<typeof useContactUsMutation>;
export type ContactUsMutationResult = Apollo.MutationResult<ContactUsMutation>;
export type ContactUsMutationOptions = Apollo.BaseMutationOptions<ContactUsMutation, ContactUsMutationVariables>;
export const ReleaseCaseBenefitDocument = gql`
    mutation releaseCaseBenefit($companyId: String!, $caseId: String!) {
  releaseCaseBenefit(companyId: $companyId, caseId: $caseId)
}
    `;
export type ReleaseCaseBenefitMutationFn = Apollo.MutationFunction<ReleaseCaseBenefitMutation, ReleaseCaseBenefitMutationVariables>;

/**
 * __useReleaseCaseBenefitMutation__
 *
 * To run a mutation, you first call `useReleaseCaseBenefitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleaseCaseBenefitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releaseCaseBenefitMutation, { data, loading, error }] = useReleaseCaseBenefitMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useReleaseCaseBenefitMutation(baseOptions?: Apollo.MutationHookOptions<ReleaseCaseBenefitMutation, ReleaseCaseBenefitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReleaseCaseBenefitMutation, ReleaseCaseBenefitMutationVariables>(ReleaseCaseBenefitDocument, options);
      }
export type ReleaseCaseBenefitMutationHookResult = ReturnType<typeof useReleaseCaseBenefitMutation>;
export type ReleaseCaseBenefitMutationResult = Apollo.MutationResult<ReleaseCaseBenefitMutation>;
export type ReleaseCaseBenefitMutationOptions = Apollo.BaseMutationOptions<ReleaseCaseBenefitMutation, ReleaseCaseBenefitMutationVariables>;
export const DeleteUserDirectDepositDocument = gql`
    mutation deleteUserDirectDeposit($userId: String!) {
  deleteUserDirectDeposit(userId: $userId)
}
    `;
export type DeleteUserDirectDepositMutationFn = Apollo.MutationFunction<DeleteUserDirectDepositMutation, DeleteUserDirectDepositMutationVariables>;

/**
 * __useDeleteUserDirectDepositMutation__
 *
 * To run a mutation, you first call `useDeleteUserDirectDepositMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserDirectDepositMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserDirectDepositMutation, { data, loading, error }] = useDeleteUserDirectDepositMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteUserDirectDepositMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserDirectDepositMutation, DeleteUserDirectDepositMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserDirectDepositMutation, DeleteUserDirectDepositMutationVariables>(DeleteUserDirectDepositDocument, options);
      }
export type DeleteUserDirectDepositMutationHookResult = ReturnType<typeof useDeleteUserDirectDepositMutation>;
export type DeleteUserDirectDepositMutationResult = Apollo.MutationResult<DeleteUserDirectDepositMutation>;
export type DeleteUserDirectDepositMutationOptions = Apollo.BaseMutationOptions<DeleteUserDirectDepositMutation, DeleteUserDirectDepositMutationVariables>;
export const UserSignOutDocument = gql`
    mutation userSignOut($userId: String!) {
  userSignOut(userId: $userId)
}
    `;
export type UserSignOutMutationFn = Apollo.MutationFunction<UserSignOutMutation, UserSignOutMutationVariables>;

/**
 * __useUserSignOutMutation__
 *
 * To run a mutation, you first call `useUserSignOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserSignOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userSignOutMutation, { data, loading, error }] = useUserSignOutMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserSignOutMutation(baseOptions?: Apollo.MutationHookOptions<UserSignOutMutation, UserSignOutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserSignOutMutation, UserSignOutMutationVariables>(UserSignOutDocument, options);
      }
export type UserSignOutMutationHookResult = ReturnType<typeof useUserSignOutMutation>;
export type UserSignOutMutationResult = Apollo.MutationResult<UserSignOutMutation>;
export type UserSignOutMutationOptions = Apollo.BaseMutationOptions<UserSignOutMutation, UserSignOutMutationVariables>;
export const CreateCaseDocument = gql`
    mutation createCase($companyId: String!, $employeeId: String!, $checklistId: String!, $terminationDate: String!, $lastDay: String, $reason: String!, $terminationType: String!, $benefitTier: BenefitTier!, $secure: Boolean!) {
  createCase(
    companyId: $companyId
    employeeId: $employeeId
    checklistId: $checklistId
    terminationDate: $terminationDate
    lastDay: $lastDay
    reason: $reason
    terminationType: $terminationType
    benefitTier: $benefitTier
    secure: $secure
  )
}
    `;
export type CreateCaseMutationFn = Apollo.MutationFunction<CreateCaseMutation, CreateCaseMutationVariables>;

/**
 * __useCreateCaseMutation__
 *
 * To run a mutation, you first call `useCreateCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaseMutation, { data, loading, error }] = useCreateCaseMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      employeeId: // value for 'employeeId'
 *      checklistId: // value for 'checklistId'
 *      terminationDate: // value for 'terminationDate'
 *      lastDay: // value for 'lastDay'
 *      reason: // value for 'reason'
 *      terminationType: // value for 'terminationType'
 *      benefitTier: // value for 'benefitTier'
 *      secure: // value for 'secure'
 *   },
 * });
 */
export function useCreateCaseMutation(baseOptions?: Apollo.MutationHookOptions<CreateCaseMutation, CreateCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCaseMutation, CreateCaseMutationVariables>(CreateCaseDocument, options);
      }
export type CreateCaseMutationHookResult = ReturnType<typeof useCreateCaseMutation>;
export type CreateCaseMutationResult = Apollo.MutationResult<CreateCaseMutation>;
export type CreateCaseMutationOptions = Apollo.BaseMutationOptions<CreateCaseMutation, CreateCaseMutationVariables>;
export const UploadBatchDocument = gql`
    mutation uploadBatch($companyId: String!, $employees: [EmployeeInput]) {
  hris {
    csvUpload {
      uploadBatch(companyId: $companyId, employees: $employees)
    }
  }
}
    `;
export type UploadBatchMutationFn = Apollo.MutationFunction<UploadBatchMutation, UploadBatchMutationVariables>;

/**
 * __useUploadBatchMutation__
 *
 * To run a mutation, you first call `useUploadBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadBatchMutation, { data, loading, error }] = useUploadBatchMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      employees: // value for 'employees'
 *   },
 * });
 */
export function useUploadBatchMutation(baseOptions?: Apollo.MutationHookOptions<UploadBatchMutation, UploadBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadBatchMutation, UploadBatchMutationVariables>(UploadBatchDocument, options);
      }
export type UploadBatchMutationHookResult = ReturnType<typeof useUploadBatchMutation>;
export type UploadBatchMutationResult = Apollo.MutationResult<UploadBatchMutation>;
export type UploadBatchMutationOptions = Apollo.BaseMutationOptions<UploadBatchMutation, UploadBatchMutationVariables>;
export const BulkCaseCreateDocument = gql`
    mutation bulkCaseCreate($cases: [BulkCaseCreateInput!]!) {
  bulkCaseCreate(bulkCaseData: $cases) {
    success
    error
  }
}
    `;
export type BulkCaseCreateMutationFn = Apollo.MutationFunction<BulkCaseCreateMutation, BulkCaseCreateMutationVariables>;

/**
 * __useBulkCaseCreateMutation__
 *
 * To run a mutation, you first call `useBulkCaseCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkCaseCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkCaseCreateMutation, { data, loading, error }] = useBulkCaseCreateMutation({
 *   variables: {
 *      cases: // value for 'cases'
 *   },
 * });
 */
export function useBulkCaseCreateMutation(baseOptions?: Apollo.MutationHookOptions<BulkCaseCreateMutation, BulkCaseCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkCaseCreateMutation, BulkCaseCreateMutationVariables>(BulkCaseCreateDocument, options);
      }
export type BulkCaseCreateMutationHookResult = ReturnType<typeof useBulkCaseCreateMutation>;
export type BulkCaseCreateMutationResult = Apollo.MutationResult<BulkCaseCreateMutation>;
export type BulkCaseCreateMutationOptions = Apollo.BaseMutationOptions<BulkCaseCreateMutation, BulkCaseCreateMutationVariables>;
export const SetupCompanyDocument = gql`
    mutation setupCompany($companyName: String!, $employeeCount: Int!, $country: String!, $firstName: String!, $lastName: String!, $emailAddress: String!, $title: String!, $phone: String!) {
  setupCompany(
    companyName: $companyName
    employeeCount: $employeeCount
    country: $country
    firstName: $firstName
    lastName: $lastName
    emailAddress: $emailAddress
    title: $title
    phone: $phone
  )
}
    `;
export type SetupCompanyMutationFn = Apollo.MutationFunction<SetupCompanyMutation, SetupCompanyMutationVariables>;

/**
 * __useSetupCompanyMutation__
 *
 * To run a mutation, you first call `useSetupCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupCompanyMutation, { data, loading, error }] = useSetupCompanyMutation({
 *   variables: {
 *      companyName: // value for 'companyName'
 *      employeeCount: // value for 'employeeCount'
 *      country: // value for 'country'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      emailAddress: // value for 'emailAddress'
 *      title: // value for 'title'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useSetupCompanyMutation(baseOptions?: Apollo.MutationHookOptions<SetupCompanyMutation, SetupCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupCompanyMutation, SetupCompanyMutationVariables>(SetupCompanyDocument, options);
      }
export type SetupCompanyMutationHookResult = ReturnType<typeof useSetupCompanyMutation>;
export type SetupCompanyMutationResult = Apollo.MutationResult<SetupCompanyMutation>;
export type SetupCompanyMutationOptions = Apollo.BaseMutationOptions<SetupCompanyMutation, SetupCompanyMutationVariables>;
export const ResendConnectEmailDocument = gql`
    mutation resendConnectEmail($companyId: String!, $inviteId: String!) {
  resendConnectEmail(companyId: $companyId, inviteId: $inviteId)
}
    `;
export type ResendConnectEmailMutationFn = Apollo.MutationFunction<ResendConnectEmailMutation, ResendConnectEmailMutationVariables>;

/**
 * __useResendConnectEmailMutation__
 *
 * To run a mutation, you first call `useResendConnectEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendConnectEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendConnectEmailMutation, { data, loading, error }] = useResendConnectEmailMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useResendConnectEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendConnectEmailMutation, ResendConnectEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendConnectEmailMutation, ResendConnectEmailMutationVariables>(ResendConnectEmailDocument, options);
      }
export type ResendConnectEmailMutationHookResult = ReturnType<typeof useResendConnectEmailMutation>;
export type ResendConnectEmailMutationResult = Apollo.MutationResult<ResendConnectEmailMutation>;
export type ResendConnectEmailMutationOptions = Apollo.BaseMutationOptions<ResendConnectEmailMutation, ResendConnectEmailMutationVariables>;
export const ConnectUserToCompanyDocument = gql`
    mutation connectUserToCompany($companyId: String!, $userId: String!, $inviteId: String!) {
  connectUserToCompany(
    companyId: $companyId
    userId: $userId
    inviteId: $inviteId
  )
}
    `;
export type ConnectUserToCompanyMutationFn = Apollo.MutationFunction<ConnectUserToCompanyMutation, ConnectUserToCompanyMutationVariables>;

/**
 * __useConnectUserToCompanyMutation__
 *
 * To run a mutation, you first call `useConnectUserToCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectUserToCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectUserToCompanyMutation, { data, loading, error }] = useConnectUserToCompanyMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      userId: // value for 'userId'
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useConnectUserToCompanyMutation(baseOptions?: Apollo.MutationHookOptions<ConnectUserToCompanyMutation, ConnectUserToCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectUserToCompanyMutation, ConnectUserToCompanyMutationVariables>(ConnectUserToCompanyDocument, options);
      }
export type ConnectUserToCompanyMutationHookResult = ReturnType<typeof useConnectUserToCompanyMutation>;
export type ConnectUserToCompanyMutationResult = Apollo.MutationResult<ConnectUserToCompanyMutation>;
export type ConnectUserToCompanyMutationOptions = Apollo.BaseMutationOptions<ConnectUserToCompanyMutation, ConnectUserToCompanyMutationVariables>;
export const SyncHrisDocument = gql`
    mutation syncHRIS($companyId: String!) {
  queueHrisSync(companyId: $companyId)
}
    `;
export type SyncHrisMutationFn = Apollo.MutationFunction<SyncHrisMutation, SyncHrisMutationVariables>;

/**
 * __useSyncHrisMutation__
 *
 * To run a mutation, you first call `useSyncHrisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncHrisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncHrisMutation, { data, loading, error }] = useSyncHrisMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useSyncHrisMutation(baseOptions?: Apollo.MutationHookOptions<SyncHrisMutation, SyncHrisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncHrisMutation, SyncHrisMutationVariables>(SyncHrisDocument, options);
      }
export type SyncHrisMutationHookResult = ReturnType<typeof useSyncHrisMutation>;
export type SyncHrisMutationResult = Apollo.MutationResult<SyncHrisMutation>;
export type SyncHrisMutationOptions = Apollo.BaseMutationOptions<SyncHrisMutation, SyncHrisMutationVariables>;
export const SetPublicTokenDocument = gql`
    mutation setPublicToken($publicToken: String!, $companyId: String!) {
  hris {
    merge {
      setPublicToken(publicToken: $publicToken, companyId: $companyId)
    }
  }
}
    `;
export type SetPublicTokenMutationFn = Apollo.MutationFunction<SetPublicTokenMutation, SetPublicTokenMutationVariables>;

/**
 * __useSetPublicTokenMutation__
 *
 * To run a mutation, you first call `useSetPublicTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPublicTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPublicTokenMutation, { data, loading, error }] = useSetPublicTokenMutation({
 *   variables: {
 *      publicToken: // value for 'publicToken'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useSetPublicTokenMutation(baseOptions?: Apollo.MutationHookOptions<SetPublicTokenMutation, SetPublicTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPublicTokenMutation, SetPublicTokenMutationVariables>(SetPublicTokenDocument, options);
      }
export type SetPublicTokenMutationHookResult = ReturnType<typeof useSetPublicTokenMutation>;
export type SetPublicTokenMutationResult = Apollo.MutationResult<SetPublicTokenMutation>;
export type SetPublicTokenMutationOptions = Apollo.BaseMutationOptions<SetPublicTokenMutation, SetPublicTokenMutationVariables>;
export const SetUserClaimsDocument = gql`
    mutation setUserClaims($uid: String, $admin: Boolean) {
  setUserClaims(uid: $uid, admin: $admin) {
    uid
    email
    admin
  }
}
    `;
export type SetUserClaimsMutationFn = Apollo.MutationFunction<SetUserClaimsMutation, SetUserClaimsMutationVariables>;

/**
 * __useSetUserClaimsMutation__
 *
 * To run a mutation, you first call `useSetUserClaimsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserClaimsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserClaimsMutation, { data, loading, error }] = useSetUserClaimsMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      admin: // value for 'admin'
 *   },
 * });
 */
export function useSetUserClaimsMutation(baseOptions?: Apollo.MutationHookOptions<SetUserClaimsMutation, SetUserClaimsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserClaimsMutation, SetUserClaimsMutationVariables>(SetUserClaimsDocument, options);
      }
export type SetUserClaimsMutationHookResult = ReturnType<typeof useSetUserClaimsMutation>;
export type SetUserClaimsMutationResult = Apollo.MutationResult<SetUserClaimsMutation>;
export type SetUserClaimsMutationOptions = Apollo.BaseMutationOptions<SetUserClaimsMutation, SetUserClaimsMutationVariables>;
export const SetUserDirectDepositDocument = gql`
    mutation setUserDirectDeposit($accountNumber: String!, $nameOnAccount: String!, $routingNumber: String!) {
  setUserDirectDeposit(
    accountNumber: $accountNumber
    nameOnAccount: $nameOnAccount
    routingNumber: $routingNumber
  )
}
    `;
export type SetUserDirectDepositMutationFn = Apollo.MutationFunction<SetUserDirectDepositMutation, SetUserDirectDepositMutationVariables>;

/**
 * __useSetUserDirectDepositMutation__
 *
 * To run a mutation, you first call `useSetUserDirectDepositMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserDirectDepositMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserDirectDepositMutation, { data, loading, error }] = useSetUserDirectDepositMutation({
 *   variables: {
 *      accountNumber: // value for 'accountNumber'
 *      nameOnAccount: // value for 'nameOnAccount'
 *      routingNumber: // value for 'routingNumber'
 *   },
 * });
 */
export function useSetUserDirectDepositMutation(baseOptions?: Apollo.MutationHookOptions<SetUserDirectDepositMutation, SetUserDirectDepositMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserDirectDepositMutation, SetUserDirectDepositMutationVariables>(SetUserDirectDepositDocument, options);
      }
export type SetUserDirectDepositMutationHookResult = ReturnType<typeof useSetUserDirectDepositMutation>;
export type SetUserDirectDepositMutationResult = Apollo.MutationResult<SetUserDirectDepositMutation>;
export type SetUserDirectDepositMutationOptions = Apollo.BaseMutationOptions<SetUserDirectDepositMutation, SetUserDirectDepositMutationVariables>;
export const QueueHrisSyncDocument = gql`
    mutation queueHrisSync($companyId: String!) {
  queueHrisSync(companyId: $companyId)
}
    `;
export type QueueHrisSyncMutationFn = Apollo.MutationFunction<QueueHrisSyncMutation, QueueHrisSyncMutationVariables>;

/**
 * __useQueueHrisSyncMutation__
 *
 * To run a mutation, you first call `useQueueHrisSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQueueHrisSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [queueHrisSyncMutation, { data, loading, error }] = useQueueHrisSyncMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useQueueHrisSyncMutation(baseOptions?: Apollo.MutationHookOptions<QueueHrisSyncMutation, QueueHrisSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<QueueHrisSyncMutation, QueueHrisSyncMutationVariables>(QueueHrisSyncDocument, options);
      }
export type QueueHrisSyncMutationHookResult = ReturnType<typeof useQueueHrisSyncMutation>;
export type QueueHrisSyncMutationResult = Apollo.MutationResult<QueueHrisSyncMutation>;
export type QueueHrisSyncMutationOptions = Apollo.BaseMutationOptions<QueueHrisSyncMutation, QueueHrisSyncMutationVariables>;
export const ConnectFinchDocument = gql`
    mutation connectFinch($clientCode: String!, $companyId: String!) {
  hris {
    finch {
      connectFinch(clientCode: $clientCode, companyId: $companyId)
    }
  }
}
    `;
export type ConnectFinchMutationFn = Apollo.MutationFunction<ConnectFinchMutation, ConnectFinchMutationVariables>;

/**
 * __useConnectFinchMutation__
 *
 * To run a mutation, you first call `useConnectFinchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectFinchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectFinchMutation, { data, loading, error }] = useConnectFinchMutation({
 *   variables: {
 *      clientCode: // value for 'clientCode'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useConnectFinchMutation(baseOptions?: Apollo.MutationHookOptions<ConnectFinchMutation, ConnectFinchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectFinchMutation, ConnectFinchMutationVariables>(ConnectFinchDocument, options);
      }
export type ConnectFinchMutationHookResult = ReturnType<typeof useConnectFinchMutation>;
export type ConnectFinchMutationResult = Apollo.MutationResult<ConnectFinchMutation>;
export type ConnectFinchMutationOptions = Apollo.BaseMutationOptions<ConnectFinchMutation, ConnectFinchMutationVariables>;
export const UploadCarrierAppointmentsDocument = gql`
    mutation uploadCarrierAppointments($csvData: [CarrierAppointmentsCSVInput!]!) {
  uploadCarrierAppointments(csvData: $csvData) {
    success
    count
  }
}
    `;
export type UploadCarrierAppointmentsMutationFn = Apollo.MutationFunction<UploadCarrierAppointmentsMutation, UploadCarrierAppointmentsMutationVariables>;

/**
 * __useUploadCarrierAppointmentsMutation__
 *
 * To run a mutation, you first call `useUploadCarrierAppointmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCarrierAppointmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCarrierAppointmentsMutation, { data, loading, error }] = useUploadCarrierAppointmentsMutation({
 *   variables: {
 *      csvData: // value for 'csvData'
 *   },
 * });
 */
export function useUploadCarrierAppointmentsMutation(baseOptions?: Apollo.MutationHookOptions<UploadCarrierAppointmentsMutation, UploadCarrierAppointmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadCarrierAppointmentsMutation, UploadCarrierAppointmentsMutationVariables>(UploadCarrierAppointmentsDocument, options);
      }
export type UploadCarrierAppointmentsMutationHookResult = ReturnType<typeof useUploadCarrierAppointmentsMutation>;
export type UploadCarrierAppointmentsMutationResult = Apollo.MutationResult<UploadCarrierAppointmentsMutation>;
export type UploadCarrierAppointmentsMutationOptions = Apollo.BaseMutationOptions<UploadCarrierAppointmentsMutation, UploadCarrierAppointmentsMutationVariables>;
export const AdminCreateUserFromCaseDocument = gql`
    mutation adminCreateUserFromCase($companyId: String!, $caseId: String!, $firstName: String!, $lastName: String!, $email: String!, $dateOfBirth: String!, $zipCode: String!) {
  adminCreateUserFromCase(
    companyId: $companyId
    caseId: $caseId
    firstName: $firstName
    lastName: $lastName
    email: $email
    dateOfBirth: $dateOfBirth
    zipCode: $zipCode
  ) {
    uid
    email
    admin
  }
}
    `;
export type AdminCreateUserFromCaseMutationFn = Apollo.MutationFunction<AdminCreateUserFromCaseMutation, AdminCreateUserFromCaseMutationVariables>;

/**
 * __useAdminCreateUserFromCaseMutation__
 *
 * To run a mutation, you first call `useAdminCreateUserFromCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateUserFromCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateUserFromCaseMutation, { data, loading, error }] = useAdminCreateUserFromCaseMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      caseId: // value for 'caseId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      dateOfBirth: // value for 'dateOfBirth'
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useAdminCreateUserFromCaseMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateUserFromCaseMutation, AdminCreateUserFromCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateUserFromCaseMutation, AdminCreateUserFromCaseMutationVariables>(AdminCreateUserFromCaseDocument, options);
      }
export type AdminCreateUserFromCaseMutationHookResult = ReturnType<typeof useAdminCreateUserFromCaseMutation>;
export type AdminCreateUserFromCaseMutationResult = Apollo.MutationResult<AdminCreateUserFromCaseMutation>;
export type AdminCreateUserFromCaseMutationOptions = Apollo.BaseMutationOptions<AdminCreateUserFromCaseMutation, AdminCreateUserFromCaseMutationVariables>;
export const UpdateCompanySettingsDocument = gql`
    mutation updateCompanySettings($companyId: String!, $companyInput: UpdateCompanyInput!) {
  updateCompany(companyId: $companyId, companyInput: $companyInput) {
    success
    error
  }
}
    `;
export type UpdateCompanySettingsMutationFn = Apollo.MutationFunction<UpdateCompanySettingsMutation, UpdateCompanySettingsMutationVariables>;

/**
 * __useUpdateCompanySettingsMutation__
 *
 * To run a mutation, you first call `useUpdateCompanySettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanySettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanySettingsMutation, { data, loading, error }] = useUpdateCompanySettingsMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      companyInput: // value for 'companyInput'
 *   },
 * });
 */
export function useUpdateCompanySettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanySettingsMutation, UpdateCompanySettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanySettingsMutation, UpdateCompanySettingsMutationVariables>(UpdateCompanySettingsDocument, options);
      }
export type UpdateCompanySettingsMutationHookResult = ReturnType<typeof useUpdateCompanySettingsMutation>;
export type UpdateCompanySettingsMutationResult = Apollo.MutationResult<UpdateCompanySettingsMutation>;
export type UpdateCompanySettingsMutationOptions = Apollo.BaseMutationOptions<UpdateCompanySettingsMutation, UpdateCompanySettingsMutationVariables>;
export const ConfigureDemoCaseDocument = gql`
    mutation ConfigureDemoCase($caseType: CaseTypes!, $whenBenefit: CaseWhenBenefitInput) {
  configureDemoCase(caseType: $caseType, whenBenefit: $whenBenefit) {
    id
    companyId
    caseId
    contact {
      firstName
      lastName
      dateOfBirth
      address {
        zip
      }
    }
    whenBenefit {
      amount
    }
  }
}
    `;
export type ConfigureDemoCaseMutationFn = Apollo.MutationFunction<ConfigureDemoCaseMutation, ConfigureDemoCaseMutationVariables>;

/**
 * __useConfigureDemoCaseMutation__
 *
 * To run a mutation, you first call `useConfigureDemoCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureDemoCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureDemoCaseMutation, { data, loading, error }] = useConfigureDemoCaseMutation({
 *   variables: {
 *      caseType: // value for 'caseType'
 *      whenBenefit: // value for 'whenBenefit'
 *   },
 * });
 */
export function useConfigureDemoCaseMutation(baseOptions?: Apollo.MutationHookOptions<ConfigureDemoCaseMutation, ConfigureDemoCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfigureDemoCaseMutation, ConfigureDemoCaseMutationVariables>(ConfigureDemoCaseDocument, options);
      }
export type ConfigureDemoCaseMutationHookResult = ReturnType<typeof useConfigureDemoCaseMutation>;
export type ConfigureDemoCaseMutationResult = Apollo.MutationResult<ConfigureDemoCaseMutation>;
export type ConfigureDemoCaseMutationOptions = Apollo.BaseMutationOptions<ConfigureDemoCaseMutation, ConfigureDemoCaseMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($uid: String, $user: UserInput) {
  updateUser(uid: $uid, user: $user) {
    uid
    email
    name {
      first
      last
      display
      lowercase
    }
    phoneNumber
    created
    lastLogin
    admin
    address {
      street1
      street2
      city
      state
      zip
      country
    }
    dateOfBirth
    gender
    directDeposit {
      last4
      accountType
      accountHolderName
    }
    acceptedPrivacyPolicy
    acceptedTermsOfService
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const CompanyDocument = gql`
    query Company($companyId: String!) {
  company(companyId: $companyId) {
    code
    address {
      street1
      street2
      city
      state
      zip
    }
    emailDomain
    servicesEnabled
    hrisSetup
    landingPages
    logo
    name
    servicesEnabled
    terminationDate
    zendeskOrganizationId
    createdOn
  }
}
    `;

/**
 * __useCompanyQuery__
 *
 * To run a query within a React component, call `useCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanyQuery(baseOptions: Apollo.QueryHookOptions<CompanyQuery, CompanyQueryVariables> & ({ variables: CompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
      }
export function useCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
        }
export function useCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
        }
export type CompanyQueryHookResult = ReturnType<typeof useCompanyQuery>;
export type CompanyLazyQueryHookResult = ReturnType<typeof useCompanyLazyQuery>;
export type CompanySuspenseQueryHookResult = ReturnType<typeof useCompanySuspenseQuery>;
export type CompanyQueryResult = Apollo.QueryResult<CompanyQuery, CompanyQueryVariables>;
export const CaseDocument = gql`
    query Case($companyId: String!, $caseId: String!) {
  case(companyId: $companyId, caseId: $caseId) {
    id
    caseId
    name
    caseType
    companyId
    status
    createdAt
    createdBy
    updatedAt
    updatedBy
    closeDate
    secure
    shareDate
    sharedOn
    scheduled
    shared
    sharedStatus
    klaviyoCaseShared
    klaviyo {
      caseShared {
        date
      }
    }
    zendeskTicket
    zendesk {
      ticketId
      date
    }
    tasks {
      open
      closed
      total
    }
    healthInsuranceDecision
    cobraElectionReason
    exitMeetingDate
    released
    ref
    benefitTier
    lastDay
    terminationDate
    reason
    terminationType
    dataVersion
    syncUser {
      id
      date
    }
    contact {
      id
      firstName
      lastName
      email
      phone
      dateOfBirth
      address {
        street1
        street2
        city
        state
        zip
      }
      salary
      gender
      status
      ethnicity
      maritalStatus
      flsaStatus
      payFrequency
      payRate
      payCurrency
      title
      hireDate
      terminationDate
    }
    cobranding {
      logo
      name
      companyCode
    }
    childCompany {
      id
      name
      logoUrl
      contact {
        name
        email
        phone
      }
    }
    event {
      type
      date
      termination {
        type
        reason
      }
      cobra {
        qualifyingEvent
        estimate
        currentContribution
      }
    }
    household {
      firstName
      lastName
      dateOfBirth
      relationship
    }
    benefits {
      type
      name
      carrier
      monthlyEmployeeContribution
      monthlyEmployerContribution
      benefitEndDate
      dependents {
        firstName
        lastName
        dateOfBirth
        relationship
      }
    }
    services {
      type
      whenBenefitAmount
    }
    whenBenefit {
      status
      hasBenefit
      benefitTier
      amount
      releasedDate
      detail {
        total
        amountSpent
        amountPending
        amountRemaining
        amountForfeited
      }
      distributionType
      unusedFunds
      monthsToAllocate
    }
    healthInsuranceDecisionDetail
    assignee
    syncStatus
    syncedAt
    servicesEnabled
  }
}
    `;

/**
 * __useCaseQuery__
 *
 * To run a query within a React component, call `useCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCaseQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useCaseQuery(baseOptions: Apollo.QueryHookOptions<CaseQuery, CaseQueryVariables> & ({ variables: CaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CaseQuery, CaseQueryVariables>(CaseDocument, options);
      }
export function useCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CaseQuery, CaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CaseQuery, CaseQueryVariables>(CaseDocument, options);
        }
export function useCaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CaseQuery, CaseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CaseQuery, CaseQueryVariables>(CaseDocument, options);
        }
export type CaseQueryHookResult = ReturnType<typeof useCaseQuery>;
export type CaseLazyQueryHookResult = ReturnType<typeof useCaseLazyQuery>;
export type CaseSuspenseQueryHookResult = ReturnType<typeof useCaseSuspenseQuery>;
export type CaseQueryResult = Apollo.QueryResult<CaseQuery, CaseQueryVariables>;
export const CasesDocument = gql`
    query Cases($limit: Int, $offset: Int, $filters: CasesFiltersInput) {
  cases(limit: $limit, offset: $offset, filters: $filters) {
    id
    caseId
    name
    caseType
    companyId
    status
    createdAt
    createdBy
    updatedAt
    updatedBy
    closeDate
    secure
    shareDate
    sharedOn
    scheduled
    shared
    sharedStatus
    klaviyoCaseShared
    klaviyo {
      caseShared {
        date
      }
    }
    zendeskTicket
    zendesk {
      ticketId
      date
    }
    tasks {
      open
      closed
      total
    }
    healthInsuranceDecision
    cobraElectionReason
    exitMeetingDate
    released
    ref
    benefitTier
    lastDay
    terminationDate
    reason
    terminationType
    dataVersion
    syncUser {
      id
      date
    }
    contact {
      id
      firstName
      lastName
      email
      phone
      dateOfBirth
      address {
        street1
        street2
        city
        state
        zip
      }
      salary
      gender
      status
      ethnicity
      maritalStatus
      flsaStatus
      payFrequency
      payRate
      payCurrency
      title
      hireDate
      terminationDate
    }
    cobranding {
      logo
      name
      companyCode
    }
    childCompany {
      id
      name
      logoUrl
      contact {
        name
        email
        phone
      }
    }
    event {
      type
      date
      termination {
        type
        reason
      }
      cobra {
        qualifyingEvent
        estimate
        currentContribution
      }
    }
    household {
      firstName
      lastName
      dateOfBirth
      relationship
    }
    benefits {
      type
      name
      carrier
      monthlyEmployeeContribution
      monthlyEmployerContribution
      benefitEndDate
      dependents {
        firstName
        lastName
        dateOfBirth
        relationship
      }
    }
    services {
      type
      whenBenefitAmount
    }
    whenBenefit {
      status
      hasBenefit
      benefitTier
      amount
      releasedDate
      detail {
        total
        amountSpent
        amountPending
        amountRemaining
        amountForfeited
      }
      distributionType
      unusedFunds
      monthsToAllocate
    }
    healthInsuranceDecisionDetail
    assignee
    syncStatus
    syncedAt
  }
}
    `;

/**
 * __useCasesQuery__
 *
 * To run a query within a React component, call `useCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCasesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCasesQuery(baseOptions?: Apollo.QueryHookOptions<CasesQuery, CasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CasesQuery, CasesQueryVariables>(CasesDocument, options);
      }
export function useCasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CasesQuery, CasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CasesQuery, CasesQueryVariables>(CasesDocument, options);
        }
export function useCasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CasesQuery, CasesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CasesQuery, CasesQueryVariables>(CasesDocument, options);
        }
export type CasesQueryHookResult = ReturnType<typeof useCasesQuery>;
export type CasesLazyQueryHookResult = ReturnType<typeof useCasesLazyQuery>;
export type CasesSuspenseQueryHookResult = ReturnType<typeof useCasesSuspenseQuery>;
export type CasesQueryResult = Apollo.QueryResult<CasesQuery, CasesQueryVariables>;
export const GetUserBankInfoDocument = gql`
    query getUserBankInfo($userId: String!) {
  getUserBankInfo(userId: $userId) {
    accountNumber
    routingNumber
    nameOnAccount
  }
}
    `;

/**
 * __useGetUserBankInfoQuery__
 *
 * To run a query within a React component, call `useGetUserBankInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserBankInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserBankInfoQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserBankInfoQuery(baseOptions: Apollo.QueryHookOptions<GetUserBankInfoQuery, GetUserBankInfoQueryVariables> & ({ variables: GetUserBankInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserBankInfoQuery, GetUserBankInfoQueryVariables>(GetUserBankInfoDocument, options);
      }
export function useGetUserBankInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserBankInfoQuery, GetUserBankInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserBankInfoQuery, GetUserBankInfoQueryVariables>(GetUserBankInfoDocument, options);
        }
export function useGetUserBankInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserBankInfoQuery, GetUserBankInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserBankInfoQuery, GetUserBankInfoQueryVariables>(GetUserBankInfoDocument, options);
        }
export type GetUserBankInfoQueryHookResult = ReturnType<typeof useGetUserBankInfoQuery>;
export type GetUserBankInfoLazyQueryHookResult = ReturnType<typeof useGetUserBankInfoLazyQuery>;
export type GetUserBankInfoSuspenseQueryHookResult = ReturnType<typeof useGetUserBankInfoSuspenseQuery>;
export type GetUserBankInfoQueryResult = Apollo.QueryResult<GetUserBankInfoQuery, GetUserBankInfoQueryVariables>;
export const ExitCodeInfoDocument = gql`
    query exitCodeInfo($companyId: String!, $exitCode: String!) {
  exitCodeInfo(companyId: $companyId, exitCode: $exitCode) {
    firstName
    documents
    whenBenefit
    servicesEnabled
  }
}
    `;

/**
 * __useExitCodeInfoQuery__
 *
 * To run a query within a React component, call `useExitCodeInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useExitCodeInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExitCodeInfoQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      exitCode: // value for 'exitCode'
 *   },
 * });
 */
export function useExitCodeInfoQuery(baseOptions: Apollo.QueryHookOptions<ExitCodeInfoQuery, ExitCodeInfoQueryVariables> & ({ variables: ExitCodeInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExitCodeInfoQuery, ExitCodeInfoQueryVariables>(ExitCodeInfoDocument, options);
      }
export function useExitCodeInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExitCodeInfoQuery, ExitCodeInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExitCodeInfoQuery, ExitCodeInfoQueryVariables>(ExitCodeInfoDocument, options);
        }
export function useExitCodeInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExitCodeInfoQuery, ExitCodeInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExitCodeInfoQuery, ExitCodeInfoQueryVariables>(ExitCodeInfoDocument, options);
        }
export type ExitCodeInfoQueryHookResult = ReturnType<typeof useExitCodeInfoQuery>;
export type ExitCodeInfoLazyQueryHookResult = ReturnType<typeof useExitCodeInfoLazyQuery>;
export type ExitCodeInfoSuspenseQueryHookResult = ReturnType<typeof useExitCodeInfoSuspenseQuery>;
export type ExitCodeInfoQueryResult = Apollo.QueryResult<ExitCodeInfoQuery, ExitCodeInfoQueryVariables>;
export const MessagesDocument = gql`
    query messages {
  messages {
    id
    text
    user
    timestamp
  }
}
    `;

/**
 * __useMessagesQuery__
 *
 * To run a query within a React component, call `useMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMessagesQuery(baseOptions?: Apollo.QueryHookOptions<MessagesQuery, MessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessagesQuery, MessagesQueryVariables>(MessagesDocument, options);
      }
export function useMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessagesQuery, MessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessagesQuery, MessagesQueryVariables>(MessagesDocument, options);
        }
export function useMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MessagesQuery, MessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MessagesQuery, MessagesQueryVariables>(MessagesDocument, options);
        }
export type MessagesQueryHookResult = ReturnType<typeof useMessagesQuery>;
export type MessagesLazyQueryHookResult = ReturnType<typeof useMessagesLazyQuery>;
export type MessagesSuspenseQueryHookResult = ReturnType<typeof useMessagesSuspenseQuery>;
export type MessagesQueryResult = Apollo.QueryResult<MessagesQuery, MessagesQueryVariables>;
export const AdminGetCaseDocument = gql`
    query adminGetCase($caseId: String!, $companyId: String!, $reason: HIPAAViewReasons) {
  adminGetCase(caseId: $caseId, companyId: $companyId, reason: $reason) {
    caseId
    companyId
    expiration
  }
}
    `;

/**
 * __useAdminGetCaseQuery__
 *
 * To run a query within a React component, call `useAdminGetCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetCaseQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      companyId: // value for 'companyId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useAdminGetCaseQuery(baseOptions: Apollo.QueryHookOptions<AdminGetCaseQuery, AdminGetCaseQueryVariables> & ({ variables: AdminGetCaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetCaseQuery, AdminGetCaseQueryVariables>(AdminGetCaseDocument, options);
      }
export function useAdminGetCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetCaseQuery, AdminGetCaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetCaseQuery, AdminGetCaseQueryVariables>(AdminGetCaseDocument, options);
        }
export function useAdminGetCaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetCaseQuery, AdminGetCaseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetCaseQuery, AdminGetCaseQueryVariables>(AdminGetCaseDocument, options);
        }
export type AdminGetCaseQueryHookResult = ReturnType<typeof useAdminGetCaseQuery>;
export type AdminGetCaseLazyQueryHookResult = ReturnType<typeof useAdminGetCaseLazyQuery>;
export type AdminGetCaseSuspenseQueryHookResult = ReturnType<typeof useAdminGetCaseSuspenseQuery>;
export type AdminGetCaseQueryResult = Apollo.QueryResult<AdminGetCaseQuery, AdminGetCaseQueryVariables>;
export const AdminGetUserDocument = gql`
    query adminGetUser($userId: String!, $reason: HIPAAViewReasons) {
  adminGetUser(userId: $userId, reason: $reason) {
    userId
    companyId
    expiration
  }
}
    `;

/**
 * __useAdminGetUserQuery__
 *
 * To run a query within a React component, call `useAdminGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useAdminGetUserQuery(baseOptions: Apollo.QueryHookOptions<AdminGetUserQuery, AdminGetUserQueryVariables> & ({ variables: AdminGetUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetUserQuery, AdminGetUserQueryVariables>(AdminGetUserDocument, options);
      }
export function useAdminGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetUserQuery, AdminGetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetUserQuery, AdminGetUserQueryVariables>(AdminGetUserDocument, options);
        }
export function useAdminGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetUserQuery, AdminGetUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetUserQuery, AdminGetUserQueryVariables>(AdminGetUserDocument, options);
        }
export type AdminGetUserQueryHookResult = ReturnType<typeof useAdminGetUserQuery>;
export type AdminGetUserLazyQueryHookResult = ReturnType<typeof useAdminGetUserLazyQuery>;
export type AdminGetUserSuspenseQueryHookResult = ReturnType<typeof useAdminGetUserSuspenseQuery>;
export type AdminGetUserQueryResult = Apollo.QueryResult<AdminGetUserQuery, AdminGetUserQueryVariables>;
export const HrisDocument = gql`
    query Hris($companyId: String, $ids: [String]) {
  hris {
    csvUpload {
      estimateImpact(companyId: $companyId, ids: $ids) {
        missing
        new
        total
        existing
      }
    }
  }
}
    `;

/**
 * __useHrisQuery__
 *
 * To run a query within a React component, call `useHrisQuery` and pass it any options that fit your needs.
 * When your component renders, `useHrisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHrisQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useHrisQuery(baseOptions?: Apollo.QueryHookOptions<HrisQuery, HrisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HrisQuery, HrisQueryVariables>(HrisDocument, options);
      }
export function useHrisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HrisQuery, HrisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HrisQuery, HrisQueryVariables>(HrisDocument, options);
        }
export function useHrisSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HrisQuery, HrisQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HrisQuery, HrisQueryVariables>(HrisDocument, options);
        }
export type HrisQueryHookResult = ReturnType<typeof useHrisQuery>;
export type HrisLazyQueryHookResult = ReturnType<typeof useHrisLazyQuery>;
export type HrisSuspenseQueryHookResult = ReturnType<typeof useHrisSuspenseQuery>;
export type HrisQueryResult = Apollo.QueryResult<HrisQuery, HrisQueryVariables>;
export const CaseEstimateImpactDocument = gql`
    query caseEstimateImpact($csvData: [BulkCaseCreateInput!]!) {
  caseEstimateImpact(csvData: $csvData) {
    employeesToBeCreated
    employeesExists
    casesToBeCreated
    caseExistsNoUpdates
    casesToBeUpdated
  }
}
    `;

/**
 * __useCaseEstimateImpactQuery__
 *
 * To run a query within a React component, call `useCaseEstimateImpactQuery` and pass it any options that fit your needs.
 * When your component renders, `useCaseEstimateImpactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCaseEstimateImpactQuery({
 *   variables: {
 *      csvData: // value for 'csvData'
 *   },
 * });
 */
export function useCaseEstimateImpactQuery(baseOptions: Apollo.QueryHookOptions<CaseEstimateImpactQuery, CaseEstimateImpactQueryVariables> & ({ variables: CaseEstimateImpactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CaseEstimateImpactQuery, CaseEstimateImpactQueryVariables>(CaseEstimateImpactDocument, options);
      }
export function useCaseEstimateImpactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CaseEstimateImpactQuery, CaseEstimateImpactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CaseEstimateImpactQuery, CaseEstimateImpactQueryVariables>(CaseEstimateImpactDocument, options);
        }
export function useCaseEstimateImpactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CaseEstimateImpactQuery, CaseEstimateImpactQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CaseEstimateImpactQuery, CaseEstimateImpactQueryVariables>(CaseEstimateImpactDocument, options);
        }
export type CaseEstimateImpactQueryHookResult = ReturnType<typeof useCaseEstimateImpactQuery>;
export type CaseEstimateImpactLazyQueryHookResult = ReturnType<typeof useCaseEstimateImpactLazyQuery>;
export type CaseEstimateImpactSuspenseQueryHookResult = ReturnType<typeof useCaseEstimateImpactSuspenseQuery>;
export type CaseEstimateImpactQueryResult = Apollo.QueryResult<CaseEstimateImpactQuery, CaseEstimateImpactQueryVariables>;
export const GetSearchTokenDocument = gql`
    query getSearchToken($companyId: String, $adminSearch: Boolean) {
  getSearchToken(companyId: $companyId, adminSearch: $adminSearch)
}
    `;

/**
 * __useGetSearchTokenQuery__
 *
 * To run a query within a React component, call `useGetSearchTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchTokenQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      adminSearch: // value for 'adminSearch'
 *   },
 * });
 */
export function useGetSearchTokenQuery(baseOptions?: Apollo.QueryHookOptions<GetSearchTokenQuery, GetSearchTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchTokenQuery, GetSearchTokenQueryVariables>(GetSearchTokenDocument, options);
      }
export function useGetSearchTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchTokenQuery, GetSearchTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchTokenQuery, GetSearchTokenQueryVariables>(GetSearchTokenDocument, options);
        }
export function useGetSearchTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchTokenQuery, GetSearchTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSearchTokenQuery, GetSearchTokenQueryVariables>(GetSearchTokenDocument, options);
        }
export type GetSearchTokenQueryHookResult = ReturnType<typeof useGetSearchTokenQuery>;
export type GetSearchTokenLazyQueryHookResult = ReturnType<typeof useGetSearchTokenLazyQuery>;
export type GetSearchTokenSuspenseQueryHookResult = ReturnType<typeof useGetSearchTokenSuspenseQuery>;
export type GetSearchTokenQueryResult = Apollo.QueryResult<GetSearchTokenQuery, GetSearchTokenQueryVariables>;
export const FetchDecryptedSsnDocument = gql`
    query fetchDecryptedSSN($applicationUserId: String!, $applicationId: ID!, $householdMemberId: String!) {
  fetchDecryptedSSN(
    applicationUserId: $applicationUserId
    applicationId: $applicationId
    householdMemberId: $householdMemberId
  )
}
    `;

/**
 * __useFetchDecryptedSsnQuery__
 *
 * To run a query within a React component, call `useFetchDecryptedSsnQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDecryptedSsnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDecryptedSsnQuery({
 *   variables: {
 *      applicationUserId: // value for 'applicationUserId'
 *      applicationId: // value for 'applicationId'
 *      householdMemberId: // value for 'householdMemberId'
 *   },
 * });
 */
export function useFetchDecryptedSsnQuery(baseOptions: Apollo.QueryHookOptions<FetchDecryptedSsnQuery, FetchDecryptedSsnQueryVariables> & ({ variables: FetchDecryptedSsnQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDecryptedSsnQuery, FetchDecryptedSsnQueryVariables>(FetchDecryptedSsnDocument, options);
      }
export function useFetchDecryptedSsnLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDecryptedSsnQuery, FetchDecryptedSsnQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDecryptedSsnQuery, FetchDecryptedSsnQueryVariables>(FetchDecryptedSsnDocument, options);
        }
export function useFetchDecryptedSsnSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchDecryptedSsnQuery, FetchDecryptedSsnQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchDecryptedSsnQuery, FetchDecryptedSsnQueryVariables>(FetchDecryptedSsnDocument, options);
        }
export type FetchDecryptedSsnQueryHookResult = ReturnType<typeof useFetchDecryptedSsnQuery>;
export type FetchDecryptedSsnLazyQueryHookResult = ReturnType<typeof useFetchDecryptedSsnLazyQuery>;
export type FetchDecryptedSsnSuspenseQueryHookResult = ReturnType<typeof useFetchDecryptedSsnSuspenseQuery>;
export type FetchDecryptedSsnQueryResult = Apollo.QueryResult<FetchDecryptedSsnQuery, FetchDecryptedSsnQueryVariables>;
export const GetApplicationNotesDocument = gql`
    query getApplicationNotes($applicationUserId: String!, $applicationId: ID!) {
  getApplicationNotes(
    applicationUserId: $applicationUserId
    applicationId: $applicationId
  ) {
    id
    userName
    date
    note
  }
}
    `;

/**
 * __useGetApplicationNotesQuery__
 *
 * To run a query within a React component, call `useGetApplicationNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationNotesQuery({
 *   variables: {
 *      applicationUserId: // value for 'applicationUserId'
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useGetApplicationNotesQuery(baseOptions: Apollo.QueryHookOptions<GetApplicationNotesQuery, GetApplicationNotesQueryVariables> & ({ variables: GetApplicationNotesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplicationNotesQuery, GetApplicationNotesQueryVariables>(GetApplicationNotesDocument, options);
      }
export function useGetApplicationNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationNotesQuery, GetApplicationNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplicationNotesQuery, GetApplicationNotesQueryVariables>(GetApplicationNotesDocument, options);
        }
export function useGetApplicationNotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApplicationNotesQuery, GetApplicationNotesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApplicationNotesQuery, GetApplicationNotesQueryVariables>(GetApplicationNotesDocument, options);
        }
export type GetApplicationNotesQueryHookResult = ReturnType<typeof useGetApplicationNotesQuery>;
export type GetApplicationNotesLazyQueryHookResult = ReturnType<typeof useGetApplicationNotesLazyQuery>;
export type GetApplicationNotesSuspenseQueryHookResult = ReturnType<typeof useGetApplicationNotesSuspenseQuery>;
export type GetApplicationNotesQueryResult = Apollo.QueryResult<GetApplicationNotesQuery, GetApplicationNotesQueryVariables>;
export const HrisConnectionDetailsDocument = gql`
    query hrisConnectionDetails($connectionId: String, $companyId: String) {
  hrisConnectionDetails(connectionId: $connectionId, companyId: $companyId) {
    name
    logo
    squareLogo
    status
    lastImport
    createdOn
  }
}
    `;

/**
 * __useHrisConnectionDetailsQuery__
 *
 * To run a query within a React component, call `useHrisConnectionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHrisConnectionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHrisConnectionDetailsQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useHrisConnectionDetailsQuery(baseOptions?: Apollo.QueryHookOptions<HrisConnectionDetailsQuery, HrisConnectionDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HrisConnectionDetailsQuery, HrisConnectionDetailsQueryVariables>(HrisConnectionDetailsDocument, options);
      }
export function useHrisConnectionDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HrisConnectionDetailsQuery, HrisConnectionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HrisConnectionDetailsQuery, HrisConnectionDetailsQueryVariables>(HrisConnectionDetailsDocument, options);
        }
export function useHrisConnectionDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HrisConnectionDetailsQuery, HrisConnectionDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HrisConnectionDetailsQuery, HrisConnectionDetailsQueryVariables>(HrisConnectionDetailsDocument, options);
        }
export type HrisConnectionDetailsQueryHookResult = ReturnType<typeof useHrisConnectionDetailsQuery>;
export type HrisConnectionDetailsLazyQueryHookResult = ReturnType<typeof useHrisConnectionDetailsLazyQuery>;
export type HrisConnectionDetailsSuspenseQueryHookResult = ReturnType<typeof useHrisConnectionDetailsSuspenseQuery>;
export type HrisConnectionDetailsQueryResult = Apollo.QueryResult<HrisConnectionDetailsQuery, HrisConnectionDetailsQueryVariables>;
export const ConfirmExitCodeIdentityDocument = gql`
    query confirmExitCodeIdentity($companyId: String!, $exitCode: String, $lastName: String!, $birthDate: String!, $zipCode: String, $workEmail: String, $terminationDate: String) {
  confirmExitCodeIdentity(
    companyId: $companyId
    exitCode: $exitCode
    lastName: $lastName
    birthDate: $birthDate
    zipCode: $zipCode
    workEmail: $workEmail
    terminationDate: $terminationDate
  )
}
    `;

/**
 * __useConfirmExitCodeIdentityQuery__
 *
 * To run a query within a React component, call `useConfirmExitCodeIdentityQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfirmExitCodeIdentityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfirmExitCodeIdentityQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      exitCode: // value for 'exitCode'
 *      lastName: // value for 'lastName'
 *      birthDate: // value for 'birthDate'
 *      zipCode: // value for 'zipCode'
 *      workEmail: // value for 'workEmail'
 *      terminationDate: // value for 'terminationDate'
 *   },
 * });
 */
export function useConfirmExitCodeIdentityQuery(baseOptions: Apollo.QueryHookOptions<ConfirmExitCodeIdentityQuery, ConfirmExitCodeIdentityQueryVariables> & ({ variables: ConfirmExitCodeIdentityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfirmExitCodeIdentityQuery, ConfirmExitCodeIdentityQueryVariables>(ConfirmExitCodeIdentityDocument, options);
      }
export function useConfirmExitCodeIdentityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfirmExitCodeIdentityQuery, ConfirmExitCodeIdentityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfirmExitCodeIdentityQuery, ConfirmExitCodeIdentityQueryVariables>(ConfirmExitCodeIdentityDocument, options);
        }
export function useConfirmExitCodeIdentitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConfirmExitCodeIdentityQuery, ConfirmExitCodeIdentityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConfirmExitCodeIdentityQuery, ConfirmExitCodeIdentityQueryVariables>(ConfirmExitCodeIdentityDocument, options);
        }
export type ConfirmExitCodeIdentityQueryHookResult = ReturnType<typeof useConfirmExitCodeIdentityQuery>;
export type ConfirmExitCodeIdentityLazyQueryHookResult = ReturnType<typeof useConfirmExitCodeIdentityLazyQuery>;
export type ConfirmExitCodeIdentitySuspenseQueryHookResult = ReturnType<typeof useConfirmExitCodeIdentitySuspenseQuery>;
export type ConfirmExitCodeIdentityQueryResult = Apollo.QueryResult<ConfirmExitCodeIdentityQuery, ConfirmExitCodeIdentityQueryVariables>;
export const ReScorePlansDocument = gql`
    query reScorePlans($effectiveDate: String, $uid: String) {
  reScorePlans(effectiveDate: $effectiveDate, uid: $uid) {
    total
  }
}
    `;

/**
 * __useReScorePlansQuery__
 *
 * To run a query within a React component, call `useReScorePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useReScorePlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReScorePlansQuery({
 *   variables: {
 *      effectiveDate: // value for 'effectiveDate'
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useReScorePlansQuery(baseOptions?: Apollo.QueryHookOptions<ReScorePlansQuery, ReScorePlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReScorePlansQuery, ReScorePlansQueryVariables>(ReScorePlansDocument, options);
      }
export function useReScorePlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReScorePlansQuery, ReScorePlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReScorePlansQuery, ReScorePlansQueryVariables>(ReScorePlansDocument, options);
        }
export function useReScorePlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReScorePlansQuery, ReScorePlansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReScorePlansQuery, ReScorePlansQueryVariables>(ReScorePlansDocument, options);
        }
export type ReScorePlansQueryHookResult = ReturnType<typeof useReScorePlansQuery>;
export type ReScorePlansLazyQueryHookResult = ReturnType<typeof useReScorePlansLazyQuery>;
export type ReScorePlansSuspenseQueryHookResult = ReturnType<typeof useReScorePlansSuspenseQuery>;
export type ReScorePlansQueryResult = Apollo.QueryResult<ReScorePlansQuery, ReScorePlansQueryVariables>;
export const AiRecommendationDocument = gql`
    query aiRecommendation($effectiveDate: String, $planId: String) {
  aiRecommendation(effectiveDate: $effectiveDate, planId: $planId) {
    aiScore
    pros
    cons
    headline
    explanation
  }
}
    `;

/**
 * __useAiRecommendationQuery__
 *
 * To run a query within a React component, call `useAiRecommendationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiRecommendationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiRecommendationQuery({
 *   variables: {
 *      effectiveDate: // value for 'effectiveDate'
 *      planId: // value for 'planId'
 *   },
 * });
 */
export function useAiRecommendationQuery(baseOptions?: Apollo.QueryHookOptions<AiRecommendationQuery, AiRecommendationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AiRecommendationQuery, AiRecommendationQueryVariables>(AiRecommendationDocument, options);
      }
export function useAiRecommendationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AiRecommendationQuery, AiRecommendationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AiRecommendationQuery, AiRecommendationQueryVariables>(AiRecommendationDocument, options);
        }
export function useAiRecommendationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AiRecommendationQuery, AiRecommendationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AiRecommendationQuery, AiRecommendationQueryVariables>(AiRecommendationDocument, options);
        }
export type AiRecommendationQueryHookResult = ReturnType<typeof useAiRecommendationQuery>;
export type AiRecommendationLazyQueryHookResult = ReturnType<typeof useAiRecommendationLazyQuery>;
export type AiRecommendationSuspenseQueryHookResult = ReturnType<typeof useAiRecommendationSuspenseQuery>;
export type AiRecommendationQueryResult = Apollo.QueryResult<AiRecommendationQuery, AiRecommendationQueryVariables>;
export const GenerateEnrollmentUrlDocument = gql`
    query generateEnrollmentUrl($effectiveDate: String, $planId: String, $carrierId: String) {
  generateEnrollmentUrl(
    effectiveDate: $effectiveDate
    planId: $planId
    carrierId: $carrierId
  ) {
    redirectUrl
  }
}
    `;

/**
 * __useGenerateEnrollmentUrlQuery__
 *
 * To run a query within a React component, call `useGenerateEnrollmentUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateEnrollmentUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateEnrollmentUrlQuery({
 *   variables: {
 *      effectiveDate: // value for 'effectiveDate'
 *      planId: // value for 'planId'
 *      carrierId: // value for 'carrierId'
 *   },
 * });
 */
export function useGenerateEnrollmentUrlQuery(baseOptions?: Apollo.QueryHookOptions<GenerateEnrollmentUrlQuery, GenerateEnrollmentUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateEnrollmentUrlQuery, GenerateEnrollmentUrlQueryVariables>(GenerateEnrollmentUrlDocument, options);
      }
export function useGenerateEnrollmentUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateEnrollmentUrlQuery, GenerateEnrollmentUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateEnrollmentUrlQuery, GenerateEnrollmentUrlQueryVariables>(GenerateEnrollmentUrlDocument, options);
        }
export function useGenerateEnrollmentUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GenerateEnrollmentUrlQuery, GenerateEnrollmentUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GenerateEnrollmentUrlQuery, GenerateEnrollmentUrlQueryVariables>(GenerateEnrollmentUrlDocument, options);
        }
export type GenerateEnrollmentUrlQueryHookResult = ReturnType<typeof useGenerateEnrollmentUrlQuery>;
export type GenerateEnrollmentUrlLazyQueryHookResult = ReturnType<typeof useGenerateEnrollmentUrlLazyQuery>;
export type GenerateEnrollmentUrlSuspenseQueryHookResult = ReturnType<typeof useGenerateEnrollmentUrlSuspenseQuery>;
export type GenerateEnrollmentUrlQueryResult = Apollo.QueryResult<GenerateEnrollmentUrlQuery, GenerateEnrollmentUrlQueryVariables>;
export const GetLinkTokenDocument = gql`
    query GetLinkToken($companyId: String!, $companyName: String!, $emailAddress: String!, $integrationMethodId: String!) {
  hris {
    merge {
      getLinkToken(
        companyId: $companyId
        companyName: $companyName
        emailAddress: $emailAddress
        integrationMethodId: $integrationMethodId
      ) {
        token
      }
    }
  }
}
    `;

/**
 * __useGetLinkTokenQuery__
 *
 * To run a query within a React component, call `useGetLinkTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinkTokenQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      companyName: // value for 'companyName'
 *      emailAddress: // value for 'emailAddress'
 *      integrationMethodId: // value for 'integrationMethodId'
 *   },
 * });
 */
export function useGetLinkTokenQuery(baseOptions: Apollo.QueryHookOptions<GetLinkTokenQuery, GetLinkTokenQueryVariables> & ({ variables: GetLinkTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLinkTokenQuery, GetLinkTokenQueryVariables>(GetLinkTokenDocument, options);
      }
export function useGetLinkTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLinkTokenQuery, GetLinkTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLinkTokenQuery, GetLinkTokenQueryVariables>(GetLinkTokenDocument, options);
        }
export function useGetLinkTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLinkTokenQuery, GetLinkTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLinkTokenQuery, GetLinkTokenQueryVariables>(GetLinkTokenDocument, options);
        }
export type GetLinkTokenQueryHookResult = ReturnType<typeof useGetLinkTokenQuery>;
export type GetLinkTokenLazyQueryHookResult = ReturnType<typeof useGetLinkTokenLazyQuery>;
export type GetLinkTokenSuspenseQueryHookResult = ReturnType<typeof useGetLinkTokenSuspenseQuery>;
export type GetLinkTokenQueryResult = Apollo.QueryResult<GetLinkTokenQuery, GetLinkTokenQueryVariables>;
export const GetRatesDocument = gql`
    query getRates($effectiveDate: String, $uid: String, $source: String) {
  getRates(effectiveDate: $effectiveDate, uid: $uid, source: $source) {
    total
  }
}
    `;

/**
 * __useGetRatesQuery__
 *
 * To run a query within a React component, call `useGetRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRatesQuery({
 *   variables: {
 *      effectiveDate: // value for 'effectiveDate'
 *      uid: // value for 'uid'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useGetRatesQuery(baseOptions?: Apollo.QueryHookOptions<GetRatesQuery, GetRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRatesQuery, GetRatesQueryVariables>(GetRatesDocument, options);
      }
export function useGetRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRatesQuery, GetRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRatesQuery, GetRatesQueryVariables>(GetRatesDocument, options);
        }
export function useGetRatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRatesQuery, GetRatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRatesQuery, GetRatesQueryVariables>(GetRatesDocument, options);
        }
export type GetRatesQueryHookResult = ReturnType<typeof useGetRatesQuery>;
export type GetRatesLazyQueryHookResult = ReturnType<typeof useGetRatesLazyQuery>;
export type GetRatesSuspenseQueryHookResult = ReturnType<typeof useGetRatesSuspenseQuery>;
export type GetRatesQueryResult = Apollo.QueryResult<GetRatesQuery, GetRatesQueryVariables>;
export const SubsidyCheckDocument = gql`
    query SubsidyCheck($uid: String!) {
  subsidyCheck(uid: $uid) {
    federalSubsidyAmount
  }
}
    `;

/**
 * __useSubsidyCheckQuery__
 *
 * To run a query within a React component, call `useSubsidyCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubsidyCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubsidyCheckQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useSubsidyCheckQuery(baseOptions: Apollo.QueryHookOptions<SubsidyCheckQuery, SubsidyCheckQueryVariables> & ({ variables: SubsidyCheckQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubsidyCheckQuery, SubsidyCheckQueryVariables>(SubsidyCheckDocument, options);
      }
export function useSubsidyCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubsidyCheckQuery, SubsidyCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubsidyCheckQuery, SubsidyCheckQueryVariables>(SubsidyCheckDocument, options);
        }
export function useSubsidyCheckSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubsidyCheckQuery, SubsidyCheckQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubsidyCheckQuery, SubsidyCheckQueryVariables>(SubsidyCheckDocument, options);
        }
export type SubsidyCheckQueryHookResult = ReturnType<typeof useSubsidyCheckQuery>;
export type SubsidyCheckLazyQueryHookResult = ReturnType<typeof useSubsidyCheckLazyQuery>;
export type SubsidyCheckSuspenseQueryHookResult = ReturnType<typeof useSubsidyCheckSuspenseQuery>;
export type SubsidyCheckQueryResult = Apollo.QueryResult<SubsidyCheckQuery, SubsidyCheckQueryVariables>;
export const GetCompanySettingsDocument = gql`
    query getCompanySettings($companyId: String!) {
  company(companyId: $companyId) {
    name
    address {
      street1
      street2
      city
      state
      zip
    }
    headquarterState
    planRenewalMonth
    activationDate
    terminationDate
    customerSuccessManager
    cobraAdministrationProvider
    emailDomain
    logo
    fein
    companyPointOfContact {
      name
      email
      phone
      title
    }
    employeeCount
    externalCompanyIdentifier
    servicesEnabled
    whenBenefitUseOnCobra
    automation {
      employerPlatformLessWorkflowEnable
      numberOfDays
      errorNotificationContactEmail
    }
    timing {
      betweenRequests {
        value
        measure
      }
      firstRequest {
        value
        measure
      }
    }
    monthlyWhenBenefitSettings {
      perMonthDeadline {
        dayOfMonth
        monthsAfter
      }
      monthlyBenefitInitialGracePeriod {
        dayOfMonth
        monthsAfter
      }
      unusedFunds
    }
  }
}
    `;

/**
 * __useGetCompanySettingsQuery__
 *
 * To run a query within a React component, call `useGetCompanySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanySettingsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCompanySettingsQuery(baseOptions: Apollo.QueryHookOptions<GetCompanySettingsQuery, GetCompanySettingsQueryVariables> & ({ variables: GetCompanySettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanySettingsQuery, GetCompanySettingsQueryVariables>(GetCompanySettingsDocument, options);
      }
export function useGetCompanySettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanySettingsQuery, GetCompanySettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanySettingsQuery, GetCompanySettingsQueryVariables>(GetCompanySettingsDocument, options);
        }
export function useGetCompanySettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanySettingsQuery, GetCompanySettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanySettingsQuery, GetCompanySettingsQueryVariables>(GetCompanySettingsDocument, options);
        }
export type GetCompanySettingsQueryHookResult = ReturnType<typeof useGetCompanySettingsQuery>;
export type GetCompanySettingsLazyQueryHookResult = ReturnType<typeof useGetCompanySettingsLazyQuery>;
export type GetCompanySettingsSuspenseQueryHookResult = ReturnType<typeof useGetCompanySettingsSuspenseQuery>;
export type GetCompanySettingsQueryResult = Apollo.QueryResult<GetCompanySettingsQuery, GetCompanySettingsQueryVariables>;
export const GetMixpanelDataDocument = gql`
    query getMixpanelData($events: String!, $fromDate: String!, $toDate: String!) {
  getMixpanelData(events: $events, fromDate: $fromDate, toDate: $toDate) {
    data {
      events {
        event
        values {
          date
          value
        }
      }
    }
  }
}
    `;

/**
 * __useGetMixpanelDataQuery__
 *
 * To run a query within a React component, call `useGetMixpanelDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMixpanelDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMixpanelDataQuery({
 *   variables: {
 *      events: // value for 'events'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useGetMixpanelDataQuery(baseOptions: Apollo.QueryHookOptions<GetMixpanelDataQuery, GetMixpanelDataQueryVariables> & ({ variables: GetMixpanelDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMixpanelDataQuery, GetMixpanelDataQueryVariables>(GetMixpanelDataDocument, options);
      }
export function useGetMixpanelDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMixpanelDataQuery, GetMixpanelDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMixpanelDataQuery, GetMixpanelDataQueryVariables>(GetMixpanelDataDocument, options);
        }
export function useGetMixpanelDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMixpanelDataQuery, GetMixpanelDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMixpanelDataQuery, GetMixpanelDataQueryVariables>(GetMixpanelDataDocument, options);
        }
export type GetMixpanelDataQueryHookResult = ReturnType<typeof useGetMixpanelDataQuery>;
export type GetMixpanelDataLazyQueryHookResult = ReturnType<typeof useGetMixpanelDataLazyQuery>;
export type GetMixpanelDataSuspenseQueryHookResult = ReturnType<typeof useGetMixpanelDataSuspenseQuery>;
export type GetMixpanelDataQueryResult = Apollo.QueryResult<GetMixpanelDataQuery, GetMixpanelDataQueryVariables>;
export const GetAllTimeReportDocument = gql`
    query getAllTimeReport {
  getAllTimeReport {
    totalCases
    wbTotal
    wbRemaining
    wbSpent
    wbForfeited
    activeCases
    openCases
    closedCases
    closedInactiveCases
    closedResolvedCases
    cancelledResolvedCases
    activatedCases
    healthDecisionACA
    healthDecisionCobra
    healthDecisionUnknown
    healthDecisionOther
    HID_ACA_ON_EXCHANGE_EXTERNAL
    HID_ACA_ON_EXCHANGE_VELAPOINT
    HID_ACA_ON_EXCHANGE_WHEN
    HID_COBRA
    HID_DECLINE_TO_DISCLOSE
    HID_MEDICAID_EXTERNAL
    HID_MEDICARE_EXTERNAL
    HID_MEDICARE_VELAPOINT
    HID_MEDICARE_WHEN
    HID_NEW_EMPLOYMENT
    HID_OFF_EXCHANGE_EXTERNAL
    HID_OFF_EXCHANGE_VELAPOINT
    HID_OFF_EXCHANGE_WHEN
    HID_OTHER_EXTERNAL_COVERAGE
    HID_PARENTS
    HID_PENDING
    HID_SHORT_TERM_EXTERNAL
    HID_SHORT_TERM_VELAPOINT
    HID_SHORT_TERM_WHEN
    HID_SPOUSE
    HID_UNINSURED
    HID_UNKNOWN_CASE_CLOSED
  }
}
    `;

/**
 * __useGetAllTimeReportQuery__
 *
 * To run a query within a React component, call `useGetAllTimeReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTimeReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTimeReportQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllTimeReportQuery(baseOptions?: Apollo.QueryHookOptions<GetAllTimeReportQuery, GetAllTimeReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTimeReportQuery, GetAllTimeReportQueryVariables>(GetAllTimeReportDocument, options);
      }
export function useGetAllTimeReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTimeReportQuery, GetAllTimeReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTimeReportQuery, GetAllTimeReportQueryVariables>(GetAllTimeReportDocument, options);
        }
export function useGetAllTimeReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllTimeReportQuery, GetAllTimeReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllTimeReportQuery, GetAllTimeReportQueryVariables>(GetAllTimeReportDocument, options);
        }
export type GetAllTimeReportQueryHookResult = ReturnType<typeof useGetAllTimeReportQuery>;
export type GetAllTimeReportLazyQueryHookResult = ReturnType<typeof useGetAllTimeReportLazyQuery>;
export type GetAllTimeReportSuspenseQueryHookResult = ReturnType<typeof useGetAllTimeReportSuspenseQuery>;
export type GetAllTimeReportQueryResult = Apollo.QueryResult<GetAllTimeReportQuery, GetAllTimeReportQueryVariables>;
export const GetCaseStateByCreatedAtDocument = gql`
    query getCaseStateByCreatedAt($fromDate: String!, $toDate: String!) {
  getCaseStateByCreatedAt(fromDate: $fromDate, toDate: $toDate) {
    data {
      createdAt
      totalCases
      totalCompanies
      companyIds
      wbTotal
      wbRemaining
      wbSpent
      wbForfeited
      activeCases
      openCases
      casesSharedOnTime
      klaviyoCasesShared
      zendeskCasesShared
      closedCases
      closedInactiveCases
      closedResolvedCases
      cancelledResolvedCases
      activatedCases
      healthDecisionACA
      healthDecisionCobra
      healthDecisionUnknown
      healthDecisionOther
    }
    lastUpdated
  }
}
    `;

/**
 * __useGetCaseStateByCreatedAtQuery__
 *
 * To run a query within a React component, call `useGetCaseStateByCreatedAtQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseStateByCreatedAtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseStateByCreatedAtQuery({
 *   variables: {
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useGetCaseStateByCreatedAtQuery(baseOptions: Apollo.QueryHookOptions<GetCaseStateByCreatedAtQuery, GetCaseStateByCreatedAtQueryVariables> & ({ variables: GetCaseStateByCreatedAtQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseStateByCreatedAtQuery, GetCaseStateByCreatedAtQueryVariables>(GetCaseStateByCreatedAtDocument, options);
      }
export function useGetCaseStateByCreatedAtLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseStateByCreatedAtQuery, GetCaseStateByCreatedAtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseStateByCreatedAtQuery, GetCaseStateByCreatedAtQueryVariables>(GetCaseStateByCreatedAtDocument, options);
        }
export function useGetCaseStateByCreatedAtSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseStateByCreatedAtQuery, GetCaseStateByCreatedAtQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseStateByCreatedAtQuery, GetCaseStateByCreatedAtQueryVariables>(GetCaseStateByCreatedAtDocument, options);
        }
export type GetCaseStateByCreatedAtQueryHookResult = ReturnType<typeof useGetCaseStateByCreatedAtQuery>;
export type GetCaseStateByCreatedAtLazyQueryHookResult = ReturnType<typeof useGetCaseStateByCreatedAtLazyQuery>;
export type GetCaseStateByCreatedAtSuspenseQueryHookResult = ReturnType<typeof useGetCaseStateByCreatedAtSuspenseQuery>;
export type GetCaseStateByCreatedAtQueryResult = Apollo.QueryResult<GetCaseStateByCreatedAtQuery, GetCaseStateByCreatedAtQueryVariables>;
export const GetCobraAdminDetailsDocument = gql`
    query getCobraAdminDetails($cobraAdminName: String!) {
  getCobraAdminDetails(cobraAdminName: $cobraAdminName) {
    name
    phone
    website
  }
}
    `;

/**
 * __useGetCobraAdminDetailsQuery__
 *
 * To run a query within a React component, call `useGetCobraAdminDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCobraAdminDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCobraAdminDetailsQuery({
 *   variables: {
 *      cobraAdminName: // value for 'cobraAdminName'
 *   },
 * });
 */
export function useGetCobraAdminDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetCobraAdminDetailsQuery, GetCobraAdminDetailsQueryVariables> & ({ variables: GetCobraAdminDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCobraAdminDetailsQuery, GetCobraAdminDetailsQueryVariables>(GetCobraAdminDetailsDocument, options);
      }
export function useGetCobraAdminDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCobraAdminDetailsQuery, GetCobraAdminDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCobraAdminDetailsQuery, GetCobraAdminDetailsQueryVariables>(GetCobraAdminDetailsDocument, options);
        }
export function useGetCobraAdminDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCobraAdminDetailsQuery, GetCobraAdminDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCobraAdminDetailsQuery, GetCobraAdminDetailsQueryVariables>(GetCobraAdminDetailsDocument, options);
        }
export type GetCobraAdminDetailsQueryHookResult = ReturnType<typeof useGetCobraAdminDetailsQuery>;
export type GetCobraAdminDetailsLazyQueryHookResult = ReturnType<typeof useGetCobraAdminDetailsLazyQuery>;
export type GetCobraAdminDetailsSuspenseQueryHookResult = ReturnType<typeof useGetCobraAdminDetailsSuspenseQuery>;
export type GetCobraAdminDetailsQueryResult = Apollo.QueryResult<GetCobraAdminDetailsQuery, GetCobraAdminDetailsQueryVariables>;
export const ListUsersDocument = gql`
    query listUsers($filters: String, $page: Int, $limit: Int) {
  listUsers(filters: $filters, page: $page, limit: $limit) {
    users {
      uid
      email
      admin
    }
  }
}
    `;

/**
 * __useListUsersQuery__
 *
 * To run a query within a React component, call `useListUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUsersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListUsersQuery(baseOptions?: Apollo.QueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
      }
export function useListUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
        }
export function useListUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
        }
export type ListUsersQueryHookResult = ReturnType<typeof useListUsersQuery>;
export type ListUsersLazyQueryHookResult = ReturnType<typeof useListUsersLazyQuery>;
export type ListUsersSuspenseQueryHookResult = ReturnType<typeof useListUsersSuspenseQuery>;
export type ListUsersQueryResult = Apollo.QueryResult<ListUsersQuery, ListUsersQueryVariables>;
export const GeographyByZipDocument = gql`
    query geographyByZip($zipcode: String) {
  geographyByZip(zipcode: $zipcode) {
    zipcode
    name
    fips
    state
  }
}
    `;

/**
 * __useGeographyByZipQuery__
 *
 * To run a query within a React component, call `useGeographyByZipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeographyByZipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeographyByZipQuery({
 *   variables: {
 *      zipcode: // value for 'zipcode'
 *   },
 * });
 */
export function useGeographyByZipQuery(baseOptions?: Apollo.QueryHookOptions<GeographyByZipQuery, GeographyByZipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeographyByZipQuery, GeographyByZipQueryVariables>(GeographyByZipDocument, options);
      }
export function useGeographyByZipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeographyByZipQuery, GeographyByZipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeographyByZipQuery, GeographyByZipQueryVariables>(GeographyByZipDocument, options);
        }
export function useGeographyByZipSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GeographyByZipQuery, GeographyByZipQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GeographyByZipQuery, GeographyByZipQueryVariables>(GeographyByZipDocument, options);
        }
export type GeographyByZipQueryHookResult = ReturnType<typeof useGeographyByZipQuery>;
export type GeographyByZipLazyQueryHookResult = ReturnType<typeof useGeographyByZipLazyQuery>;
export type GeographyByZipSuspenseQueryHookResult = ReturnType<typeof useGeographyByZipSuspenseQuery>;
export type GeographyByZipQueryResult = Apollo.QueryResult<GeographyByZipQuery, GeographyByZipQueryVariables>;
export const SearchPlansQueryDocument = gql`
    query SearchPlansQuery($filters: String, $page: Int) {
  searchPlans(filters: $filters, page: $page) {
    plans {
      premium
      name
      provider
      id
      source
      type
      maxOutOfPocket
      deductible
      metal
      rating
      market
      diseasePrograms
      benefits {
        name
        covered
        inNetwork
        outOfNetwork
      }
      benefitUrl
      formularyUrl
      brochureUrl
      networkUrl
    }
    total
  }
}
    `;

/**
 * __useSearchPlansQueryQuery__
 *
 * To run a query within a React component, call `useSearchPlansQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPlansQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPlansQueryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useSearchPlansQueryQuery(baseOptions?: Apollo.QueryHookOptions<SearchPlansQueryQuery, SearchPlansQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchPlansQueryQuery, SearchPlansQueryQueryVariables>(SearchPlansQueryDocument, options);
      }
export function useSearchPlansQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchPlansQueryQuery, SearchPlansQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchPlansQueryQuery, SearchPlansQueryQueryVariables>(SearchPlansQueryDocument, options);
        }
export function useSearchPlansQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchPlansQueryQuery, SearchPlansQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchPlansQueryQuery, SearchPlansQueryQueryVariables>(SearchPlansQueryDocument, options);
        }
export type SearchPlansQueryQueryHookResult = ReturnType<typeof useSearchPlansQueryQuery>;
export type SearchPlansQueryLazyQueryHookResult = ReturnType<typeof useSearchPlansQueryLazyQuery>;
export type SearchPlansQuerySuspenseQueryHookResult = ReturnType<typeof useSearchPlansQuerySuspenseQuery>;
export type SearchPlansQueryQueryResult = Apollo.QueryResult<SearchPlansQueryQuery, SearchPlansQueryQueryVariables>;
export const ApproveMonthlyReimbursementDocument = gql`
    mutation approveMonthlyReimbursement($requestId: String!, $requestUserId: String!, $requestBenefitId: String!, $approvedAmount: String!, $notes: String!, $status: String!, $companyId: String) {
  approveReimbursementRequest(
    requestId: $requestId
    requestUserId: $requestUserId
    requestBenefitId: $requestBenefitId
    approvedAmount: $approvedAmount
    notes: $notes
    status: $status
    companyId: $companyId
  )
}
    `;
export type ApproveMonthlyReimbursementMutationFn = Apollo.MutationFunction<ApproveMonthlyReimbursementMutation, ApproveMonthlyReimbursementMutationVariables>;

/**
 * __useApproveMonthlyReimbursementMutation__
 *
 * To run a mutation, you first call `useApproveMonthlyReimbursementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveMonthlyReimbursementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveMonthlyReimbursementMutation, { data, loading, error }] = useApproveMonthlyReimbursementMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      requestUserId: // value for 'requestUserId'
 *      requestBenefitId: // value for 'requestBenefitId'
 *      approvedAmount: // value for 'approvedAmount'
 *      notes: // value for 'notes'
 *      status: // value for 'status'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useApproveMonthlyReimbursementMutation(baseOptions?: Apollo.MutationHookOptions<ApproveMonthlyReimbursementMutation, ApproveMonthlyReimbursementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveMonthlyReimbursementMutation, ApproveMonthlyReimbursementMutationVariables>(ApproveMonthlyReimbursementDocument, options);
      }
export type ApproveMonthlyReimbursementMutationHookResult = ReturnType<typeof useApproveMonthlyReimbursementMutation>;
export type ApproveMonthlyReimbursementMutationResult = Apollo.MutationResult<ApproveMonthlyReimbursementMutation>;
export type ApproveMonthlyReimbursementMutationOptions = Apollo.BaseMutationOptions<ApproveMonthlyReimbursementMutation, ApproveMonthlyReimbursementMutationVariables>;
export const DenyMonthlyReimbursementDocument = gql`
    mutation denyMonthlyReimbursement($requestId: String!, $requestUserId: String!, $requestBenefitId: String!, $denialReason: String!, $notes: String!, $companyId: String) {
  denyReimbursementRequest(
    requestId: $requestId
    requestUserId: $requestUserId
    requestBenefitId: $requestBenefitId
    denialReason: $denialReason
    notes: $notes
    companyId: $companyId
  )
}
    `;
export type DenyMonthlyReimbursementMutationFn = Apollo.MutationFunction<DenyMonthlyReimbursementMutation, DenyMonthlyReimbursementMutationVariables>;

/**
 * __useDenyMonthlyReimbursementMutation__
 *
 * To run a mutation, you first call `useDenyMonthlyReimbursementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDenyMonthlyReimbursementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [denyMonthlyReimbursementMutation, { data, loading, error }] = useDenyMonthlyReimbursementMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      requestUserId: // value for 'requestUserId'
 *      requestBenefitId: // value for 'requestBenefitId'
 *      denialReason: // value for 'denialReason'
 *      notes: // value for 'notes'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useDenyMonthlyReimbursementMutation(baseOptions?: Apollo.MutationHookOptions<DenyMonthlyReimbursementMutation, DenyMonthlyReimbursementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DenyMonthlyReimbursementMutation, DenyMonthlyReimbursementMutationVariables>(DenyMonthlyReimbursementDocument, options);
      }
export type DenyMonthlyReimbursementMutationHookResult = ReturnType<typeof useDenyMonthlyReimbursementMutation>;
export type DenyMonthlyReimbursementMutationResult = Apollo.MutationResult<DenyMonthlyReimbursementMutation>;
export type DenyMonthlyReimbursementMutationOptions = Apollo.BaseMutationOptions<DenyMonthlyReimbursementMutation, DenyMonthlyReimbursementMutationVariables>;
export const AdminCaseWhenBenefitsDocument = gql`
    query AdminCaseWhenBenefits($companyId: String!, $caseId: String!) {
  case(companyId: $companyId, caseId: $caseId) {
    caseId
    companyId
    whenBenefit {
      status
      hasBenefit
      benefitTier
      amount
      releasedDate
      detail {
        total
        amountSpent
        amountPending
        amountRemaining
        amountForfeited
      }
      distributionType
      unusedFunds
      monthsToAllocate
      reimbursementRequests {
        reimbursementRequestId
        amount
        status
        userId
        approvedAmount
        approvedAt
        approvedBy
        deniedAt
        deniedBy
        coverageMonths
        createdAt
        updatedAt
        notes
        files {
          name
          type
          path
        }
      }
      months {
        month
        amount
        deadline
        requested
        reimbursedAmount
        expired
        returned
      }
      perMonthDeadline {
        dayOfMonth
        monthsAfter
      }
      monthlyBenefitInitialGracePeriod {
        dayOfMonth
        monthsAfter
      }
      useOnCobra
    }
  }
}
    `;

/**
 * __useAdminCaseWhenBenefitsQuery__
 *
 * To run a query within a React component, call `useAdminCaseWhenBenefitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCaseWhenBenefitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCaseWhenBenefitsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useAdminCaseWhenBenefitsQuery(baseOptions: Apollo.QueryHookOptions<AdminCaseWhenBenefitsQuery, AdminCaseWhenBenefitsQueryVariables> & ({ variables: AdminCaseWhenBenefitsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminCaseWhenBenefitsQuery, AdminCaseWhenBenefitsQueryVariables>(AdminCaseWhenBenefitsDocument, options);
      }
export function useAdminCaseWhenBenefitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminCaseWhenBenefitsQuery, AdminCaseWhenBenefitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminCaseWhenBenefitsQuery, AdminCaseWhenBenefitsQueryVariables>(AdminCaseWhenBenefitsDocument, options);
        }
export function useAdminCaseWhenBenefitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminCaseWhenBenefitsQuery, AdminCaseWhenBenefitsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminCaseWhenBenefitsQuery, AdminCaseWhenBenefitsQueryVariables>(AdminCaseWhenBenefitsDocument, options);
        }
export type AdminCaseWhenBenefitsQueryHookResult = ReturnType<typeof useAdminCaseWhenBenefitsQuery>;
export type AdminCaseWhenBenefitsLazyQueryHookResult = ReturnType<typeof useAdminCaseWhenBenefitsLazyQuery>;
export type AdminCaseWhenBenefitsSuspenseQueryHookResult = ReturnType<typeof useAdminCaseWhenBenefitsSuspenseQuery>;
export type AdminCaseWhenBenefitsQueryResult = Apollo.QueryResult<AdminCaseWhenBenefitsQuery, AdminCaseWhenBenefitsQueryVariables>;
export const GetUserDocument = gql`
    query getUser($uid: String) {
  user(uid: $uid) {
    uid
    email
    name {
      first
      last
      display
      lowercase
    }
    phoneNumber
    created
    lastLogin
    admin
    companies
    address {
      street1
      street2
      city
      state
      zip
      country
    }
    dateOfBirth
    gender
    directDeposit {
      last4
      accountType
      accountHolderName
    }
    acceptedPrivacyPolicy
    acceptedTermsOfService
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetMarketplaceServicesDocument = gql`
    query getMarketplaceServices($uid: String) {
  marketplaceServices(uid: $uid) {
    id
    serviceName
    serviceCategory
    serviceProvider
    tileHeader
    tileBodyText
    CTAButton
    CTAButtonText
    CTAButtonURL
    redeemCode
    phoneButton
    phoneNumber
    fontColor
    tilesVisibility
    isActive
    createdAt
    headerPhoto {
      name
      path
      type
    }
    logoFile {
      name
      path
      type
    }
  }
}
    `;

/**
 * __useGetMarketplaceServicesQuery__
 *
 * To run a query within a React component, call `useGetMarketplaceServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketplaceServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketplaceServicesQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetMarketplaceServicesQuery(baseOptions?: Apollo.QueryHookOptions<GetMarketplaceServicesQuery, GetMarketplaceServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarketplaceServicesQuery, GetMarketplaceServicesQueryVariables>(GetMarketplaceServicesDocument, options);
      }
export function useGetMarketplaceServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarketplaceServicesQuery, GetMarketplaceServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarketplaceServicesQuery, GetMarketplaceServicesQueryVariables>(GetMarketplaceServicesDocument, options);
        }
export function useGetMarketplaceServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMarketplaceServicesQuery, GetMarketplaceServicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMarketplaceServicesQuery, GetMarketplaceServicesQueryVariables>(GetMarketplaceServicesDocument, options);
        }
export type GetMarketplaceServicesQueryHookResult = ReturnType<typeof useGetMarketplaceServicesQuery>;
export type GetMarketplaceServicesLazyQueryHookResult = ReturnType<typeof useGetMarketplaceServicesLazyQuery>;
export type GetMarketplaceServicesSuspenseQueryHookResult = ReturnType<typeof useGetMarketplaceServicesSuspenseQuery>;
export type GetMarketplaceServicesQueryResult = Apollo.QueryResult<GetMarketplaceServicesQuery, GetMarketplaceServicesQueryVariables>;
export const WhenBenefitsDocument = gql`
    query WhenBenefits($uid: String) {
  whenBenefits(uid: $uid) {
    caseId
    companyId
    benefit {
      status
      hasBenefit
      benefitTier
      amount
      releasedDate
      detail {
        total
        amountSpent
        amountPending
        amountRemaining
        amountForfeited
      }
      distributionType
      unusedFunds
      monthsToAllocate
      reimbursementRequests {
        reimbursementRequestId
        amount
        status
        userId
        approvedAmount
        coverageMonths
        createdAt
        updatedAt
        files {
          name
          type
          path
        }
      }
      months {
        month
        amount
        deadline
        requested
        reimbursedAmount
        expired
        returned
      }
      perMonthDeadline {
        dayOfMonth
        monthsAfter
      }
      monthlyBenefitInitialGracePeriod {
        dayOfMonth
        monthsAfter
      }
    }
  }
}
    `;

/**
 * __useWhenBenefitsQuery__
 *
 * To run a query within a React component, call `useWhenBenefitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhenBenefitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhenBenefitsQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useWhenBenefitsQuery(baseOptions?: Apollo.QueryHookOptions<WhenBenefitsQuery, WhenBenefitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WhenBenefitsQuery, WhenBenefitsQueryVariables>(WhenBenefitsDocument, options);
      }
export function useWhenBenefitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WhenBenefitsQuery, WhenBenefitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WhenBenefitsQuery, WhenBenefitsQueryVariables>(WhenBenefitsDocument, options);
        }
export function useWhenBenefitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WhenBenefitsQuery, WhenBenefitsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WhenBenefitsQuery, WhenBenefitsQueryVariables>(WhenBenefitsDocument, options);
        }
export type WhenBenefitsQueryHookResult = ReturnType<typeof useWhenBenefitsQuery>;
export type WhenBenefitsLazyQueryHookResult = ReturnType<typeof useWhenBenefitsLazyQuery>;
export type WhenBenefitsSuspenseQueryHookResult = ReturnType<typeof useWhenBenefitsSuspenseQuery>;
export type WhenBenefitsQueryResult = Apollo.QueryResult<WhenBenefitsQuery, WhenBenefitsQueryVariables>;